import {
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  Values,
  PageDesignConstants,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import DateControl from "../../Components/DateControl";
import React, { useState, useContext, useEffect, useRef } from "react";
import InfoPopUp from "../../Components/InfoPopUp";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  GetOrdinal,
  IsAdmin,
  applySidebarState,
  toggleSidebar,
  IsDateBefore,
  IsDateAfter,
  AdjustDays,
  DateValid,
} from "../../Helpers/Utilities";
import CustomTextArea from "../../Components/CustomTextArea ";

import {
  CommonError_Msgs,
  zeroToTwelve,
  zeroToThree,
  fourToFifteen,
  sixteenToTwentySeven,
} from "../../Helpers/HelperText";
import { laboratoryAssessmentService } from "../../WebApiServices/LaboratoryAssessmentService";
import ErrorField from "../../Components/ErrorField";
import { Dropdown } from "react-bootstrap";

const RenalLabAssessment = () => {
  const navigatePaths = {
    prevPage: "/NonMDETreatment",
    currPage: "/RenalLabAssessment",
    nextPage: "/OtherLabAssessment",
  };

  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    isSideMenuActive,
    setisSideMenuActive,
  } = useContext(AppContext);

  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);

  const pidRef = useRef(0);
  let loggedInUserId = GetLoggedInUserID();

  let dates = GetLocalStorageData("ClinicalCharacteristicsDates") || {};


  const indexMinus365days = AdjustDays(dates.indexDt, -365) || "([index date – 365 days])";
  const indexMinus273days = AdjustDays(dates.indexDt, -273) || "([index date – 273 days])";
  const indexMinus182days = AdjustDays(dates.indexDt, -182) || "([index date – 182 days])";
  const indexMinus91days = AdjustDays(dates.indexDt, -91) || "([index date – 91 days])";

  const indexPlus182days = AdjustDays(dates.indexDt, 182) || "([index date + 182 days])";
  const indexPlus273days = AdjustDays(dates.indexDt, 273) || "([index date + 273 days])";
  const indexPlus365days = AdjustDays(dates.indexDt, 365) || "([index date + 365 days])";
  const three_month_stabilization = dates.three_month_stabilization || "([3-month stabilization date])";
  const twelve_month_post_stabilization = dates.twelve_month_post_stabilization || "([12-month post-stabilization date])";
  const eighteen_month_post_stabilization = dates.eighteen_month_post_stabilization || "([18-month post-stabilization date])";
  const twentyfour_month_post_stabilization = dates.twenty_four_months_post_stabilization || "([24-month post-stabilization date])";
  const endofFollowUpDate = dates.endofFollowUpDate || "([end of follow-up date])";
  const indexMinus456days = AdjustDays(dates.indexDt, -456);


  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);



  ///Belinda
  const [showHide012HyperlinkModal, setShowHide012HyperlinkModal] =
    useState(false);
  const [showHide03HyperlinkModal, setShowHide03HyperlinkModal] =
    useState(false);
  const [showHide415HyperlinkModal, setShowHide415HyperlinkModal] =
    useState(false);
  const [showHide1627HyperlinkModal, setShowHide1627HyperlinkModal] =
    useState(false);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [patientLocked, setpatientLocked] = useState(false);


 
  //#region Q32
  const [labrenalassessmentDetails, setlabrenalassessmentDetails] = useState([
    {
      labrenalassessmentid: 0,
      renalassessmentnumber: 1,
      renalbiomarker: "",
      renalstartAssessment: "",
      renalstartAssessment_dt: "",
      renalstartAssessment_dt_estimated: false,
      renalstartAssessmentUnkLTLKT: "",
      renalspecimen: "",

      creatinine_measurement: "",
      creatinine_measurement_value_l: "",
      creatinine_measurement_value_ml: "",
      creatinine_measurement_value_nl: "",
      creatinine_measurement_value_dl: "",

      cystatin_measurement: "",
      cystatin_measurement_value_l: "",
      cystatin_measurement_value_ml: "",
      cystatin_measurement_value_nl: "",
      urineprotein_measurement: "",
      urineprotein_measurement_value_l: "",
      urineprotein_measurement_value_ml: "",
      urineprotein_measurement_value_nl: "",
      urineprotein_measurement_value_gl:"",

      urinecreatinine_measurement: "",
      urinecreatinine_measurement_value_l: "",
      urinecreatinine_measurement_value_ml: "",
      urinecreatinine_measurement_value_nl: "",
      urinecreatinine_measurement_value_dl: "",

      q32biomarkerEmpty: false,
      q32assessmentEmpty: false,
      q32specimenEmpty: false,
      q32measurementEmpty: false,
      q32assessmentDateEmptyError: false,
      q32assessmentDateInvalid: false,
      q32AssessmentDateUnkEmpty: false,
      q32measurementCreatinineEmpty: false,
      q32measurementCystatinEmpty: false,
      q32measurementUrineEmpty: false,
      q32measurementUCreatinineEmpty: false,
      q32measurementCreatinineInvalid: false,
      q32measurementCystatinInvalid: false,
      q32measurementUrineInvalid: false,
      q32measurementUCreatinineInvalid: false,
    },
  ]);

  function addrenalassessmentRow(e) {
    setlabrenalassessmentDetails((prev) => [
      ...prev,
      {
        labrenalassessmentid: 0,
        renalassessmentnumber: 1,
        renalbiomarker: "",
        renalstartAssessment: "",
        renalstartAssessment_dt: "",
        renalstartAssessment_dt_estimated: false,
        renalstartAssessmentUnkLTLKT: "",
        renalspecimen: "",

        creatinine_measurement: "",
        creatinine_measurement_value_l: "",
        creatinine_measurement_value_ml: "",
        creatinine_measurement_value_nl: "",
        creatinine_measurement_value_dl: "",

        cystatin_measurement: "",
        cystatin_measurement_value_l: "",
        cystatin_measurement_value_ml: "",
        cystatin_measurement_value_nl: "",
        urineprotein_measurement: "",
        urineprotein_measurement_value_l: "",
        urineprotein_measurement_value_ml: "",
        urineprotein_measurement_value_nl: "",
        urineprotein_measurement_value_gl:"",
        urinecreatinine_measurement: "",
        urinecreatinine_measurement_value_l: "",
        urinecreatinine_measurement_value_ml: "",
        urinecreatinine_measurement_value_nl: "",
        urinecreatinine_measurement_value_dl: "",

        q32biomarkerEmpty: false,
        q32assessmentEmpty: false,
        q32specimenEmpty: false,
        q32measurementEmpty: false,
        q32assessmentDateEmptyError: false,
        q32assessmentDateInvalid: false,
        q32AssessmentDateUnkEmpty: false,
        q32measurementCreatinineEmpty: false,
        q32measurementCystatinEmpty: false,
        q32measurementUrineEmpty: false,
        q32measurementUCreatinineEmpty: false,
        q32measurementCreatinineInvalid: false,
        q32measurementCystatinInvalid: false,
        q32measurementUrineInvalid: false,
        q32measurementUCreatinineInvalid: false,
      },
    ]);
  }

  function deleteRenalAssessmentDetails(id) {
    const newRenalAssessmentDetailsArray = [...labrenalassessmentDetails];
    newRenalAssessmentDetailsArray.splice(id, 1);
    setlabrenalassessmentDetails(newRenalAssessmentDetailsArray);
  }

  //#endregion

  //#region Q34
  const [labchronicDetails, setlabchronicDetails] = useState([
    {
      labchronicid: 0,
      ckdAssessment: "",
      ckdAssessment_dt: "",
      ckdAssessment_dt_estimated: false,
      ckdAssessmentUnkLTLKT: "",
      ckdstage: "",
          ckdkidneyfailure: false,

      q34StageEmpty: false,
      q34assessmentEmpty: false,
      q34assessmentDateEmptyError: false,
      q34assessmentDateInvalid: false,
      q34AssessmentDateUnkEmpty: false,
    },
  ]);

  function addchronicRow(e) {
    setlabchronicDetails((prev) => [
      ...prev,
      {
        labchronicid: 0,
        ckdAssessment: "",
        ckdAssessment_dt: "",
        ckdAssessment_dt_estimated: false,
        ckdAssessmentUnkLTLKT: "",
        ckdstage: "",
          ckdkidneyfailure: false,

        q34StageEmpty: false,
        q34assessmentEmpty: false,
        q34assessmentDateEmptyError: false,
        q34assessmentDateInvalid: false,
        q34AssessmentDateUnkEmpty: false,
      },
    ]);
  }

  function deleteChronicDetails(id) {
    const newChronicDetailsArray = [...labchronicDetails];
    newChronicDetailsArray.splice(id, 1);
    setlabchronicDetails(newChronicDetailsArray);
  }

  //#endregion


  //#region Q33
  const [Q33AdmissionHideColumn, setQ33AdmissionHideColumn] = useState(false);
  const [Q33DischargeHideColumn, setQ33DischargeHideColumn] = useState(false);
  const renalSettingCareTypes = {
    question: "",
    label: "",
    specimenTypes: ["Urine"],
    measurements: ["g/L", "mg/L", "mg/dL", "Unknown"],
    extra: "",
    extraUrineProtein: "",
    urineMeasurement: ["µmol/L", "µmol/mL ", "nmol/mL ", "Unknown"],
    settingcare: [],

    labRenalSettingCareId: 0,
    labRenalSettingCareTypeId: 0,
    admissionAssessment: "",
    admissionAssessmentDate: "",
    admissionAssessmentDateEstimated: false,
    admissionSpecimenType: "",
    admissionSettingCareId: "",
    admissionSettingCareOther: "",
    admissionMeasurement: "",
    admissionMeasurementValue_l: "",
    admissionMeasurementValue_ml: "",
    admissionMeasurementValue_nl: "",
    admissionMeasurementValue_dl: "",
    dischargeMeasurementValue_dl: "",

    admissionProteinMeasurement: "",
    admissionProteinMeasurementValue_l: "",
    admissionProteinMeasurementValue_ml: "",
    admissionProteinMeasurementValue_nl: "",
    admissionProteinMeasurementValue_gl: "",
    
    admissionCreatinineMeasurement: "",
    admissionCreatinineMeasurementValue_l: "",
    admissionCreatinineMeasurementValue_ml: "",
    admissionCreatinineMeasurementValue_nl: "",
    admissionCreatinineMeasurementValue_dl: "",

    dischargeAssessment: "",
    dischargeAssessmentDate: "",
    dischargeAssessmentDateEstimated: false,
    dischargeSpecimenType: "",
    dischargeSettingCareId: "",
    dischargeSettingCareOther: "",
    dischargeMeasurement: "",
    dischargeMeasurementValue_l: "",
    dischargeMeasurementValue_ml: "",
    dischargeMeasurementValue_nl: "",
    dischargeProteinMeasurement: "",
    dischargeProteinMeasurementValue_l: "",
    dischargeProteinMeasurementValue_gl: "",
    dischargeProteinMeasurementValue_ml: "",
    dischargeProteinMeasurementValue_nl: "",
    dischargeProteinMeasurementValue_dl: "",

    dischargeCreatinineMeasurement: "",
    dischargeCreatinineMeasurementValue_l: "",
    dischargeCreatinineMeasurementValue_ml: "",
    dischargeCreatinineMeasurementValue_nl: "",
    dischargeCreatinineMeasurementValue_dl: "",

    q33AdmissionassessmentEmpty: false,
    q33AdmissionspecimenEmpty: false,
    q33AdmissionSettingCareEmpty: false,
    q33AdmissionSettingCareOtherEmpty: false,
    q33AdmissionmeasurementEmpty: false,
    q33AdmissionassessmentDateEmptyError: false,
    q33AdmissionassessmentDateInvalid: false,
    q33AdmissionAssessmentDateUnkEmpty: false,
    q33AdmissionmeasurementCreatinineEmpty: false,
    q33AdmissionmeasurementCystatinEmpty: false,
    q33AdmissionmeasurementUrineEmpty: false,
    q33AdmissionmeasurementUCreatinineEmpty: false,
    q33AdmissionmeasurementCreatinineInvalid: false,
    q33AdmissionmeasurementCystatinInvalid: false,
    q33AdmissionmeasurementUrineInvalid: false,
    q33AdmissionmeasurementUCreatinineInvalid: false,
    q33DischargeassessmentEmpty: false,
    q33DischargespecimenEmpty: false,
    q33DischargeSettingCareEmpty: false,
    q33DischargeSettingCareOtherEmpty: false,
    q33DischargemeasurementEmpty: false,
    q33DischargeassessmentDateEmptyError: false,
    q33DischargeassessmentDateInvalid: false,
    q33DischargeAssessmentDateUnkEmpty: false,
    q33DischargemeasurementCreatinineEmpty: false,
    q33DischargemeasurementCystatinEmpty: false,
    q33DischargemeasurementUrineEmpty: false,
    q33DischargemeasurementUCreatinineEmpty: false,
    q33DischargemeasurementCreatinineInvalid: false,
    q33DischargemeasurementCystatinInvalid: false,
    q33DischargemeasurementUrineInvalid: false,
    q33DischargemeasurementUCreatinineInvalid: false,
  };
  // Iteration function for Q3
  const [renalSettingCareData, setrenalSettingCareData] = useState(
    Array.from({ length: 4 }, (_, index) => ({
      ...renalSettingCareTypes,
      specimenTypes: index < 2 ? ["Blood", "Plasma", "Serum"] : ["Urine"],
      measurements:
        index === 0
          ? ["µmol/L", "µmol/mL ", "nmol/mL ", "mg/dL", "Unknown"]
          : index === 1
          ? ["mg/L", "mg/dL", "µg/mL", "Unknown"]
          : ["g/L","g/dL", "mg/L", "mg/dL", "Unknown value, positive","Unknown value, trace", "Unknown value, negative", "Unknown"],
      extra: index < 2 ? "" : "Urine creatinine from same urine sample",
        extraUrineProtein: index < 2 ? "" : (index == 2 ? "Urine protein" : "Urine albumin"),
      urineMeasurement:
        index < 2 ? [] : ["µmol/L", "µmol/mL ", "nmol/mL ","mg/dL", "Unknown"],
    }))
  );
  //#endregion





  const HandleRenalFieldChange = (e) => {
    
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);
    const types = splitNameArray[2];

    const settingindex =
      types === "settingcare"
        ? parseInt(splitNameArray[3], 10)
        : types === "mde"
        ? parseInt(splitNameArray[3], 10)
        : "";
    const textindex =
      types === "settingcare"
        ? parseInt(splitNameArray[4], 10)
        : types === "mde"
        ? parseInt(splitNameArray[4], 10)
        : "";

    if (types === "renal") {
      //Q32
      setlabrenalassessmentDetails((prevDetails) => {
        let updatedRenalDetails = prevDetails.map((item, idx) => {
          if (idx === index) {
            let updatedRenalItem = {
              ...item,
              [fieldName]:
                type === "checkbox"
                  ? checked
                  : type === "radio" && fieldName !== "rvUnknown"
                  ? parseInt(value, 10) || 0
                  : value,
            };

            if (fieldName === "renalbiomarker")
              updatedRenalItem.q32biomarkerEmpty = false;

            if (fieldName === "renalspecimen")
              updatedRenalItem.q32specimenEmpty = false;

            if (fieldName === "renalstartAssessment") {
              if (parseInt(value, 10) === Values.value99) {
                updatedRenalItem.renalstartAssessment_dt = "";
                updatedRenalItem.renalstartAssessment_dt_estimated = false;
                updatedRenalItem.renalstartAssessmentUnkLTLKT = "";
                updatedRenalItem.q32assessmentEmpty = false;
                updatedRenalItem.q32assessmentDateEmptyError = false;
                updatedRenalItem.q32assessmentDateInvalid = false;
                updatedRenalItem.q32AssessmentDateUnkEmpty = false;
              } else {
                updatedRenalItem.renalstartAssessmentUnkLTLKT = "";
                updatedRenalItem.q32assessmentEmpty = false;
              }
            }

            if (fieldName === "renalstartAssessmentUnkLTLKT") {
              updatedRenalItem.renalstartAssessmentUnkLTLKT = parseInt(
                value,
                10
              );
              updatedRenalItem.renalstartAssessment_dt = "";
              updatedRenalItem.renalstartAssessment_dt_estimated = false;
              updatedRenalItem.renalstartAssessment = 99;
              updatedRenalItem.q32assessmentEmpty = false;
              updatedRenalItem.q32assessmentDateEmptyError = false;
              updatedRenalItem.q32assessmentDateInvalid = false;
              updatedRenalItem.q32AssessmentDateUnkEmpty = false;
            } else if (fieldName === "renalstartAssessment_dt_estimated") {
              updatedRenalItem.renalstartAssessment = 1;
              updatedRenalItem.renalstartAssessmentUnkLTLKT = "";
              updatedRenalItem.q32assessmentEmpty = false;
              updatedRenalItem.q32assessmentDateEmptyError = false;
              updatedRenalItem.q32assessmentDateInvalid = false;
              updatedRenalItem.q32AssessmentDateUnkEmpty = false;
            }

            if (
              fieldName === "creatinine_measurement" &&
              (updatedRenalItem.renalbiomarker === Values.value1 || updatedRenalItem.renalbiomarker=="")
            ) {
              if (parseInt(value, 10) === Values.value99) {
                updatedRenalItem.creatinine_measurement_value_l = "";
                updatedRenalItem.creatinine_measurement_value_ml = "";
                updatedRenalItem.creatinine_measurement_value_nl = "";
                updatedRenalItem.creatinine_measurement_value_dl = "";
              } else {
                updatedRenalItem.creatinine_measurement_value_l = "";
                updatedRenalItem.creatinine_measurement_value_ml = "";
                updatedRenalItem.creatinine_measurement_value_nl = "";
                updatedRenalItem.creatinine_measurement_value_dl = "";
              }
              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
            }
            

            if (fieldName === "creatinine_measurement_value_l") {
              updatedRenalItem.creatinine_measurement_value_l = value;
              updatedRenalItem.creatinine_measurement = 1;
              updatedRenalItem.creatinine_measurement_value_ml = "";
              updatedRenalItem.creatinine_measurement_value_nl = "";
              updatedRenalItem.creatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            } else if (fieldName === "creatinine_measurement_value_ml") {
              updatedRenalItem.creatinine_measurement_value_ml = value;
              updatedRenalItem.creatinine_measurement = 2;
              updatedRenalItem.creatinine_measurement_value_l = "";
              updatedRenalItem.creatinine_measurement_value_nl = "";
              updatedRenalItem.creatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }
            if (fieldName === "creatinine_measurement_value_nl") {
              updatedRenalItem.creatinine_measurement_value_nl = value;
              updatedRenalItem.creatinine_measurement = 3;
              updatedRenalItem.creatinine_measurement_value_l = "";
              updatedRenalItem.creatinine_measurement_value_ml = "";
              updatedRenalItem.creatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }

            if (fieldName === "creatinine_measurement_value_dl") {
              updatedRenalItem.creatinine_measurement_value_dl = value;
              updatedRenalItem.creatinine_measurement = 4;
              updatedRenalItem.creatinine_measurement_value_l = "";
              updatedRenalItem.creatinine_measurement_value_ml = "";
              updatedRenalItem.creatinine_measurement_value_nl = "";
              
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }

            if (
              fieldName === "renalbiomarker" &&
              updatedRenalItem.renalbiomarker === 1
            ) {
              updatedRenalItem.cystatin_measurement = "";
              updatedRenalItem.cystatin_measurement_value_l = "";
              updatedRenalItem.cystatin_measurement_value_ml = "";
              updatedRenalItem.cystatin_measurement_value_nl = "";

              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.urineprotein_measurement = "";
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";

              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.urinecreatinine_measurement = "";
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
            }

            if (
              updatedRenalItem.renalbiomarker === Values.value2 &&
              fieldName === "cystatin_measurement"
            ) {
              if (parseInt(value, 10) === Values.value99) {
                updatedRenalItem.cystatin_measurement_value_l = "";
                updatedRenalItem.cystatin_measurement_value_ml = "";
                updatedRenalItem.cystatin_measurement_value_nl = "";
              } else {
                updatedRenalItem.cystatin_measurement_value_l = "";
                updatedRenalItem.cystatin_measurement_value_ml = "";
                updatedRenalItem.cystatin_measurement_value_nl = "";
              }
              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
            }

            if (fieldName === "cystatin_measurement_value_l") {
              updatedRenalItem.cystatin_measurement_value_l = value;
              updatedRenalItem.cystatin_measurement = 1;
              updatedRenalItem.cystatin_measurement_value_ml = "";
              updatedRenalItem.cystatin_measurement_value_nl = "";
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            } else if (fieldName === "cystatin_measurement_value_ml") {
              updatedRenalItem.cystatin_measurement_value_ml = value;
              updatedRenalItem.cystatin_measurement = 2;
              updatedRenalItem.cystatin_measurement_value_l = "";
              updatedRenalItem.cystatin_measurement_value_nl = "";
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }
            if (fieldName === "cystatin_measurement_value_nl") {
              updatedRenalItem.cystatin_measurement_value_nl = value;
              updatedRenalItem.cystatin_measurement = 3;
              updatedRenalItem.cystatin_measurement_value_l = "";
              updatedRenalItem.cystatin_measurement_value_ml = "";
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;

            }

            if (
              fieldName === "renalbiomarker" &&
              updatedRenalItem.renalbiomarker === 2
            ) {
              updatedRenalItem.creatinine_measurement = "";
              updatedRenalItem.creatinine_measurement_value_l = "";
              updatedRenalItem.creatinine_measurement_value_ml = "";
              updatedRenalItem.creatinine_measurement_value_nl = "";
              updatedRenalItem.creatinine_measurement_value_dl = "";

              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.urineprotein_measurement = "";
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";

              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.urinecreatinine_measurement = "";
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
            }

            if (
              fieldName === "urineprotein_measurement" &&
              (updatedRenalItem.renalbiomarker === Values.value3 ||
                updatedRenalItem.renalbiomarker === Values.value4)
            ) {
              if (parseInt(value, 10) === Values.value99) {
                updatedRenalItem.urineprotein_measurement_value_l = "";
                updatedRenalItem.urineprotein_measurement_value_nl = "";
                updatedRenalItem.urineprotein_measurement_value_ml = "";
                updatedRenalItem.urineprotein_measurement_value_gl = "";

                
              } else {
                updatedRenalItem.urineprotein_measurement_value_l = "";
                updatedRenalItem.urineprotein_measurement_value_nl = "";
                updatedRenalItem.urineprotein_measurement_value_ml = "";
                updatedRenalItem.urineprotein_measurement_value_gl = "";
              }

              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
           
            }
            if (
              fieldName === "renalbiomarker" &&
              (updatedRenalItem.renalbiomarker === Values.value3 ||
                updatedRenalItem.renalbiomarker === Values.value4)
            ) {
              updatedRenalItem.creatinine_measurement = "";
              updatedRenalItem.creatinine_measurement_value_l = "";
              updatedRenalItem.creatinine_measurement_value_ml = "";
              updatedRenalItem.creatinine_measurement_value_nl = "";
              updatedRenalItem.creatinine_measurement_value_dl = "";

              updatedRenalItem.cystatin_measurement = "";
              updatedRenalItem.cystatin_measurement_value_l = "";
              updatedRenalItem.cystatin_measurement_value_ml = "";
              updatedRenalItem.cystatin_measurement_value_nl = "";

              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.urineprotein_measurement = "";
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";

              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.urinecreatinine_measurement = "";
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";

              updatedRenalItem.renalspecimen = 4;

              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32specimenEmpty = false;
            }

            if (fieldName === "urineprotein_measurement_value_l") {
              updatedRenalItem.urineprotein_measurement_value_l = value;
              updatedRenalItem.urineprotein_measurement = 1;
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            } 
            else if (fieldName === "urineprotein_measurement_value_gl" &&  updatedRenalItem.renalbiomarker === Values.value4) {
              updatedRenalItem.urineprotein_measurement_value_gl = value;
              updatedRenalItem.urineprotein_measurement = 2;
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }
            
            else if (fieldName === "urineprotein_measurement_value_ml") {
              updatedRenalItem.urineprotein_measurement_value_ml = value;
              updatedRenalItem.urineprotein_measurement = updatedRenalItem.renalbiomarker === Values.value4?3:2;
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }
            if (fieldName === "urineprotein_measurement_value_nl") {
              updatedRenalItem.urineprotein_measurement_value_nl = value;
              updatedRenalItem.urineprotein_measurement = updatedRenalItem.renalbiomarker === Values.value4?4:3;
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }



            if (fieldName === "urinecreatinine_measurement") {
              if (parseInt(value, 10) === Values.value99) {
                updatedRenalItem.urinecreatinine_measurement_value_l = "";
                updatedRenalItem.urinecreatinine_measurement_value_ml = "";
                updatedRenalItem.urinecreatinine_measurement_value_nl = "";
                updatedRenalItem.urinecreatinine_measurement_value_dl = "";
              } else {
                updatedRenalItem.urinecreatinine_measurement_value_l = "";
                updatedRenalItem.urinecreatinine_measurement_value_ml = "";
                updatedRenalItem.urinecreatinine_measurement_value_nl = "";
                updatedRenalItem.urinecreatinine_measurement_value_dl = "";
              }
              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementCreatinineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementInvalid = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
            }
            if (fieldName === "urinecreatinine_measurement_value_l") {
              updatedRenalItem.urinecreatinine_measurement_value_l = value;
              updatedRenalItem.urinecreatinine_measurement = 1;
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            } else if (fieldName === "urinecreatinine_measurement_value_ml") {
              updatedRenalItem.urinecreatinine_measurement_value_ml = value;
              updatedRenalItem.urinecreatinine_measurement = 2;
              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";

              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }
            if (fieldName === "urinecreatinine_measurement_value_nl") {
              updatedRenalItem.urinecreatinine_measurement_value_nl = value;
              updatedRenalItem.urinecreatinine_measurement = 3;
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }

            if (fieldName === "urinecreatinine_measurement_value_dl") {
              updatedRenalItem.urinecreatinine_measurement_value_dl = value;
              updatedRenalItem.urinecreatinine_measurement = 4;
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
              updatedRenalItem.q32measurementEmpty = false;
            }


            if (
              fieldName === "renalbiomarker" &&
              parseInt(value, 10) === Values.value5
            ) {
              updatedRenalItem.creatinine_measurement = "";
              updatedRenalItem.creatinine_measurement_value_l = "";
              updatedRenalItem.creatinine_measurement_value_ml = "";
              updatedRenalItem.creatinine_measurement_value_nl = "";
              updatedRenalItem.creatinine_measurement_value_dl = "";
              

              updatedRenalItem.cystatin_measurement = "";
              updatedRenalItem.cystatin_measurement_value_l = "";
              updatedRenalItem.cystatin_measurement_value_ml = "";
              updatedRenalItem.cystatin_measurement_value_nl = "";

              updatedRenalItem.urineprotein_measurement_value_ml = "";
              updatedRenalItem.urineprotein_measurement = "";
              updatedRenalItem.urineprotein_measurement_value_l = "";
              updatedRenalItem.urineprotein_measurement_value_nl = "";
              updatedRenalItem.urineprotein_measurement_value_gl = "";

              updatedRenalItem.urinecreatinine_measurement_value_nl = "";
              updatedRenalItem.urinecreatinine_measurement = "";
              updatedRenalItem.urinecreatinine_measurement_value_l = "";
              updatedRenalItem.urinecreatinine_measurement_value_ml = "";
              updatedRenalItem.urinecreatinine_measurement_value_dl = "";

              updatedRenalItem.renalstartAssessment_dt = "";
              updatedRenalItem.renalstartAssessment_dt_estimated = "";
              updatedRenalItem.renalstartAssessmentUnkLTLKT = "";
              updatedRenalItem.renalstartAssessment = "";
              updatedRenalItem.renalspecimen = "";

              updatedRenalItem.q32biomarkerEmpty = false;
              updatedRenalItem.q32assessmentEmpty = false;
              updatedRenalItem.q32specimenEmpty = false;
              updatedRenalItem.q32measurementEmpty = false;
              updatedRenalItem.q32assessmentDateEmptyError = false;
              updatedRenalItem.q32assessmentDateInvalid = false;
              updatedRenalItem.q32AssessmentDateUnkEmpty = false;
              updatedRenalItem.q32measurementCreatinineeEmpty = false;
              updatedRenalItem.q32measurementCystatinEmpty = false;
              updatedRenalItem.q32measurementUrineEmpty = false;
              updatedRenalItem.q32measurementUCreatinineEmpty = false;
              updatedRenalItem.q32measurementCreatinineInvalid = false;
              updatedRenalItem.q32measurementCystatinInvalid = false;
              updatedRenalItem.q32measurementUrineInvalid = false;
              updatedRenalItem.q32measurementUCreatinineInvalid = false;
            }

            return updatedRenalItem;
          }
          return item;
        });

        if (
          fieldName === "renalbiomarker" &&
          parseInt(value, 10) === Values.value5 &&
          updatedRenalDetails.length > 1
        ) {
          updatedRenalDetails = [updatedRenalDetails[0]]; // Keep only the first entry
        }

        return updatedRenalDetails;
      });
    }
  }


  const HandleCkdFieldChange = (e) => {
    const { name, value, type, checked } = e.target;
    const splitNameArray = name.split("-");
    const fieldName = splitNameArray[0];
    const index = parseInt(splitNameArray[1], 10);
    const types = splitNameArray[2];

    const settingindex =
      types === "settingcare"
        ? parseInt(splitNameArray[3], 10)
        : types === "mde"
        ? parseInt(splitNameArray[3], 10)
        : "";
    const textindex =
      types === "settingcare"
        ? parseInt(splitNameArray[4], 10)
        : types === "mde"
        ? parseInt(splitNameArray[4], 10)
        : "";
   
    if (types === "ckd") {
      //Q34
      setlabchronicDetails((prevDetails) => {
        let updatedChronicDetails = prevDetails.map((item, idx) => {
          if (idx === index) {
            let updatedchronicItem = {
              ...item,
              [fieldName]:
                type === "checkbox"
                  ? checked
                  : type === "radio" && fieldName !== "rvUnknown"
                  ? parseInt(value, 10) || 0
                  : value,
            };

            if (fieldName === "ckdAssessment") {
              if (parseInt(value, 10) === Values.value99) {
                updatedchronicItem.ckdAssessment_dt = "";
                updatedchronicItem.ckdAssessment_dt_estimated = false;
                updatedchronicItem.ckdAssessmentUnkLTLKT = "";
                updatedchronicItem.q34assessmentEmpty = false;
                updatedchronicItem.q34assessmentDateEmptyError = false;
                updatedchronicItem.q34assessmentDateInvalid = false;
                updatedchronicItem.q34AssessmentDateUnkEmpty = false;
              } else {
                updatedchronicItem.ckdAssessmentUnkLTLKT = "";
                updatedchronicItem.q34assessmentEmpty = false;
              }
            }

            if (fieldName === "ckdAssessmentUnkLTLKT") {
              updatedchronicItem.ckdAssessmentUnkLTLKT = parseInt(value, 10);
              updatedchronicItem.ckdAssessment_dt = "";
              updatedchronicItem.ckdAssessment_dt_estimated = false;
              updatedchronicItem.ckdAssessment = 99;
              updatedchronicItem.q34assessmentEmpty = false;
              updatedchronicItem.q34assessmentDateEmptyError = false;
              updatedchronicItem.q34assessmentDateInvalid = false;
              updatedchronicItem.q34AssessmentDateUnkEmpty = false;
            } else if (fieldName === "ckdAssessment_dt_estimated") {
              updatedchronicItem.ckdAssessment = 3;
              updatedchronicItem.ckdAssessmentUnkLTLKT = "";
              updatedchronicItem.q34assessmentEmpty = false;
              updatedchronicItem.q34assessmentDateEmptyError = false;
              updatedchronicItem.q34assessmentDateInvalid = false;
              updatedchronicItem.q34AssessmentDateUnkEmpty = false;
            } else if (
              fieldName === "ckdAssessment" &&
              (parseInt(value, 10) === Values.value1 ||
                parseInt(value, 10) === Values.value2)
            ) {
              updatedchronicItem.ckdAssessmentUnkLTLKT = "";
              updatedchronicItem.ckdAssessment_dt = "";
              updatedchronicItem.ckdAssessment_dt_estimated = "";
              updatedchronicItem.ckdstage = "";
              updatedchronicItem.ckdkidneyfailure = "";
              updatedchronicItem.q34assessmentEmpty = false;
              updatedchronicItem.q34assessmentDateEmptyError = false;
              updatedchronicItem.q34assessmentDateInvalid = false;
              updatedchronicItem.q34AssessmentDateUnkEmpty = false;
              updatedchronicItem.q34StageEmpty = false;
            }

            if (fieldName === "ckdkidneyfailure") {
              if (parseInt(value, 10) === Values.value1) {
                updatedchronicItem.ckdstage = Values.value5;
                updatedchronicItem.q34StageEmpty = false;
              }
            }

            if (fieldName === "ckdstage") {
              updatedchronicItem.q34StageEmpty = false;
            }

            return updatedchronicItem;
          }
          return item;
        });

        if (
          fieldName === "ckdAssessment" &&
          (parseInt(value, 10) === Values.value1 ||
            parseInt(value, 10) === Values.value2) &&
          updatedChronicDetails.length > 1
        ) {
          updatedChronicDetails = [updatedChronicDetails[0]]; // Keep only the first entry
        }

        return updatedChronicDetails;
      });
    }
  }
  

      const HandleSettingcareFieldChange = (e) => {
        
        const { name, value, type, checked } = e.target;
        const splitNameArray = name.split("-");
        const fieldName = splitNameArray[0];
        const index = parseInt(splitNameArray[1], 10);
        const types = splitNameArray[2];
    
        const settingindex =
          types === "settingcare"
            ? parseInt(splitNameArray[3], 10)
            : types === "mde"
            ? parseInt(splitNameArray[3], 10)
            : "";
        const textindex =
          types === "settingcare"
            ? parseInt(splitNameArray[4], 10)
            : types === "mde"
            ? parseInt(splitNameArray[4], 10)
            : "";

            if (types === "settingcare") {
              setrenalSettingCareData((prevDetails) => {
                let updatedSettingDetails = prevDetails.map((item, idx) => {
                  if (idx === settingindex) {
                    let updatedSettingItem = {
                      ...item,
                      [fieldName]:
                        type === "checkbox"
                          ? checked
                          : type === "radio" && fieldName !== "rvUnknown"
                          ? parseInt(value, 10) || 0
                          : value,
                    };
        
                    if (
                      fieldName === "admissionAssessment" &&
                      (parseInt(value, 10) === Values.value99 ||
                        parseInt(value, 10) === Values.value2)
                    ) {
                      updatedSettingItem.admissionAssessmentDate = "";
                      updatedSettingItem.admissionAssessmentDateEstimated = false;
                      if (parseInt(value, 10) === Values.value2) {
                        updatedSettingItem.admissionMeasurementValue_l = "";
                        updatedSettingItem.admissionMeasurementValue_ml = "";
                        updatedSettingItem.admissionMeasurementValue_nl = "";
                        updatedSettingItem.admissionMeasurementValue_dl = "";
                        updatedSettingItem.admissionMeasurement = "";
                        updatedSettingItem.admissionSpecimenType = "";
                        updatedSettingItem.admissionSettingCareId = "";
                        updatedSettingItem.admissionSettingCareOther = "";
        
                        updatedSettingItem.admissionProteinMeasurementValue_l = "";
                        updatedSettingItem.admissionProteinMeasurementValue_ml = "";
                        updatedSettingItem.admissionProteinMeasurementValue_nl = "";
                        updatedSettingItem.admissionProteinMeasurementValue_gl = "";

                        updatedSettingItem.admissionProteinMeasurement = "";
        
                        updatedSettingItem.admissionCreatinineMeasurementValue_l = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_ml = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_nl = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_dl = "";

                        updatedSettingItem.admissionCreatinineMeasurement = "";
                        updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementUCreatinineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementInvalid = false;
                        updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                        updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                        updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                        updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                        updatedSettingItem.q33AdmissionspecimenEmpty = false;
                        updatedSettingItem.q33AdmissionSettingCareEmpty = false;
                        updatedSettingItem.q33AdmissionSettingCareOtherEmpty = false;
                      }
                      updatedSettingItem.q33AdmissionassessmentEmpty = false;
                      updatedSettingItem.q33AdmissionassessmentDateEmptyError = false;
                      updatedSettingItem.q33AdmissionassessmentDateInvalid = false;
                      updatedSettingItem.q33AdmissionAssessmentDateUnkEmpty = false;
                    } else if (fieldName === "admissionAssessmentDateEstimated") {
                      updatedSettingItem.admissionAssessment = 1;
                      updatedSettingItem.q33AdmissionassessmentEmpty = false;
                    }
        
                    if (fieldName === "admissionSpecimenType")
                      updatedSettingItem.q33AdmissionspecimenEmpty = false;
        
                    if (fieldName === "admissionSettingCareId") {
                      if (parseInt(value, 10) === Values.value99)
                        updatedSettingItem.admissionSettingCareOther = "";
                      else updatedSettingItem.admissionSettingCareOther = "";
                      updatedSettingItem.q33AdmissionSettingCareEmpty = false;
                      updatedSettingItem.q33AdmissionSettingCareOtherEmpty = false;
                    }
                    if (fieldName === "admissionSettingCareOther") {
                      updatedSettingItem.q33AdmissionSettingCareEmpty = false;
                      updatedSettingItem.q33AdmissionSettingCareOtherEmpty = false;
                      updatedSettingItem.admissionSettingCareOther = value;
                      updatedSettingItem.admissionSettingCareId = textindex + 1;
                    }
        
                    if (
                      fieldName === "dischargeAssessment" &&
                      (parseInt(value, 10) === Values.value99 ||
                        parseInt(value, 10) === Values.value2)
                    ) {
                      updatedSettingItem.dischargeAssessmentDate = "";
                      updatedSettingItem.dischargeAssessmentDateEstimated = false;
                      if (parseInt(value, 10) === Values.value2) {
                        updatedSettingItem.dischargeMeasurementValue_l = "";
                        updatedSettingItem.dischargeMeasurementValue_ml = "";
                        updatedSettingItem.dischargeMeasurementValue_nl = "";
                        updatedSettingItem.dischargeMeasurementValue_dl = "";
                        updatedSettingItem.dischargeMeasurement = "";
                        updatedSettingItem.dischargeSpecimenType = "";
                        updatedSettingItem.dischargeSettingCareId = "";
                        updatedSettingItem.dischargeSettingCareOther = "";
        
                        updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_gl = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                        updatedSettingItem.dischargeProteinMeasurement = "";
        
                        updatedSettingItem.dischargeCreatinineMeasurementValue_l = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_ml = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_nl = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_dl = "";
                        updatedSettingItem.dischargeCreatinineMeasurement = "";
                        updatedSettingItem.q33DischargemeasurementEmpty = false;
                        updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                        updatedSettingItem.q33DischargemeasurementInvalid = false;
                        updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                        updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                        updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                        updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                        updatedSettingItem.q33DischargespecimenEmpty = false;
                        updatedSettingItem.q33DischargeSettingCareEmpty = false;
                        updatedSettingItem.q33DischargeSettingCareOtherEmpty = false;
                      }
        
                      updatedSettingItem.q33DischargeassessmentEmpty = false;
                      updatedSettingItem.q33DischargeassessmentDateEmptyError = false;
                      updatedSettingItem.q33DischargeassessmentDateInvalid = false;
                      updatedSettingItem.q33DischargeAssessmentDateUnkEmpty = false;
                    } else if (fieldName === "dischargeAssessmentDateEstimated") {
                      updatedSettingItem.dischargeAssessment = 1;
                      updatedSettingItem.q33DischargeassessmentEmpty = false;
                    }
        
                    if (fieldName === "dischargeSpecimenType")
                      updatedSettingItem.q33DischargespecimenEmpty = false;
        
                    if (fieldName === "dischargeSettingCareId") {
                      if (parseInt(value, 10) === Values.value99)
                        updatedSettingItem.dischargeSettingCareOther = "";
                      else updatedSettingItem.dischargeSettingCareOther = "";
                      updatedSettingItem.q33DischargeSettingCareEmpty = false;
                      updatedSettingItem.q33DischargeSettingCareOtherEmpty = false;
                    }
                    if (fieldName === "dischargeSettingCareOther") {
                      updatedSettingItem.q33DischargeSettingCareEmpty = false;
                      updatedSettingItem.q33DischargeSettingCareOtherEmpty = false;
                      updatedSettingItem.dischargeSettingCareOther = value;
                      updatedSettingItem.dischargeSettingCareId = textindex + 1;
                    }
        
                    if (fieldName === "admissionMeasurement") {
                      if (parseInt(value, 10) === Values.value99) {
                        updatedSettingItem.admissionMeasurementValue_l = "";
                        updatedSettingItem.admissionMeasurementValue_ml = "";
                        updatedSettingItem.admissionMeasurementValue_nl = "";
                        updatedSettingItem.admissionMeasurementValue_dl = "";
                      } else {
                        updatedSettingItem.admissionMeasurementValue_l = "";
                        updatedSettingItem.admissionMeasurementValue_ml = "";
                        updatedSettingItem.admissionMeasurementValue_nl = "";
                        updatedSettingItem.admissionMeasurementValue_dl = "";
                      }
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                    }
                    if (fieldName === "admissionMeasurementValue_l") {
                      updatedSettingItem.admissionMeasurementValue_l = value;
                      updatedSettingItem.admissionMeasurement = textindex + 1;
                      updatedSettingItem.admissionMeasurementValue_ml = "";
                      updatedSettingItem.admissionMeasurementValue_nl = "";
                      updatedSettingItem.admissionMeasurementValue_dl = "";

                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    } else if (fieldName === "admissionMeasurementValue_ml") {
                      updatedSettingItem.admissionMeasurementValue_ml = value;
                      updatedSettingItem.admissionMeasurement = textindex + 1;
                      updatedSettingItem.admissionMeasurementValue_l = "";
                      updatedSettingItem.admissionMeasurementValue_nl = "";
                      updatedSettingItem.admissionMeasurementValue_dl = "";

                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                      }
                    } else if (fieldName === "admissionMeasurementValue_nl") {
                      updatedSettingItem.admissionMeasurementValue_nl = value;
                      updatedSettingItem.admissionMeasurement = textindex + 1;
                      updatedSettingItem.admissionMeasurementValue_ml = "";
                      updatedSettingItem.admissionMeasurementValue_l = "";
                      updatedSettingItem.admissionMeasurementValue_dl = "";
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    } else if (fieldName === "admissionMeasurementValue_dl") {
                      updatedSettingItem.admissionMeasurementValue_dl = value;
                      updatedSettingItem.admissionMeasurement = textindex + 1;
                      updatedSettingItem.admissionMeasurementValue_ml = "";
                      updatedSettingItem.admissionMeasurementValue_l = "";
                      updatedSettingItem.admissionMeasurementValue_nl = "";
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                        updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    }

        
                    if (fieldName === "dischargeMeasurement") {
                      if (parseInt(value, 10) === Values.value99) {
                        updatedSettingItem.dischargeMeasurementValue_l = "";
                        updatedSettingItem.dischargeMeasurementValue_ml = "";
                        updatedSettingItem.dischargeMeasurementValue_nl = "";
                        updatedSettingItem.dischargeMeasurementValue_dl = "";
                      } else {
                        updatedSettingItem.dischargeMeasurementValue_l = "";
                        updatedSettingItem.dischargeMeasurementValue_ml = "";
                        updatedSettingItem.dischargeMeasurementValue_nl = "";
                        updatedSettingItem.dischargeMeasurementValue_dl = "";
                      }
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                    }
                    if (fieldName === "dischargeMeasurementValue_l") {
                      updatedSettingItem.dischargeMeasurementValue_l = value;
                      updatedSettingItem.dischargeMeasurement = textindex + 1;
                      updatedSettingItem.dischargeMeasurementValue_ml = "";
                      updatedSettingItem.dischargeMeasurementValue_nl = "";
                      updatedSettingItem.dischargeMeasurementValue_dl = "";
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    } else if (fieldName === "dischargeMeasurementValue_ml") {
                      updatedSettingItem.dischargeMeasurementValue_ml = value;
                      updatedSettingItem.dischargeMeasurement = textindex + 1;
                      updatedSettingItem.dischargeMeasurementValue_l = "";
                      updatedSettingItem.dischargeMeasurementValue_nl = "";
                      updatedSettingItem.dischargeMeasurementValue_dl = "";
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    } else if (fieldName === "dischargeMeasurementValue_nl") {
                      updatedSettingItem.dischargeMeasurementValue_nl = value;
                      updatedSettingItem.dischargeMeasurement = textindex + 1;
                      updatedSettingItem.dischargeMeasurementValue_ml = "";
                      updatedSettingItem.dischargeMeasurementValue_l = "";
                      updatedSettingItem.dischargeMeasurementValue_dl = "";
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    }
                    else if (fieldName === "dischargeMeasurementValue_dl") {
                      updatedSettingItem.dischargeMeasurementValue_dl = value;
                      updatedSettingItem.dischargeMeasurement = textindex + 1;
                      updatedSettingItem.dischargeMeasurementValue_ml = "";
                      updatedSettingItem.dischargeMeasurementValue_l = "";
                      updatedSettingItem.dischargeMeasurementValue_nl = "";
                      if (updatedSettingItem.labRenalSettingCareTypeId === 1) {
                        updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      } else {
                        updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                        updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                      }
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    }

                    if (fieldName === "admissionProteinMeasurement") {
                      if (parseInt(value, 10) === Values.value99) {
                        updatedSettingItem.admissionProteinMeasurementValue_l = "";
                        updatedSettingItem.admissionProteinMeasurementValue_ml = "";
                        updatedSettingItem.admissionProteinMeasurementValue_nl = "";
                        updatedSettingItem.admissionProteinMeasurementValue_gl = "";
                      
                      } else {
                        updatedSettingItem.admissionProteinMeasurementValue_l = "";
                        updatedSettingItem.admissionProteinMeasurementValue_ml = "";
                        updatedSettingItem.admissionProteinMeasurementValue_nl = "";
                        updatedSettingItem.admissionProteinMeasurementValue_gl = "";
                        
                      }
                      updatedSettingItem.admissionSpecimenType = 4;
        
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                    }
                    if (fieldName === "admissionProteinMeasurementValue_l") {
                      updatedSettingItem.admissionProteinMeasurementValue_l = value;
                      updatedSettingItem.admissionProteinMeasurement = textindex + 1;
                      updatedSettingItem.admissionProteinMeasurementValue_ml = "";
                      updatedSettingItem.admissionProteinMeasurementValue_nl = "";
                      updatedSettingItem.admissionProteinMeasurementValue_gl = "";
                      updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    }else if (fieldName === "admissionProteinMeasurementValue_gl" &&  updatedSettingItem.labRenalSettingCareTypeId  === Values.value4) {
                      updatedSettingItem.admissionProteinMeasurementValue_gl = value;
                      updatedSettingItem.admissionProteinMeasurement = textindex + 1;
                      updatedSettingItem.admissionProteinMeasurementValue_l = "";
                      updatedSettingItem.admissionProteinMeasurementValue_nl = "";
                      updatedSettingItem.admissionProteinMeasurementValue_ml = "";
                      updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    }
                    
                    else if (fieldName === "admissionProteinMeasurementValue_ml") {
                      updatedSettingItem.admissionProteinMeasurementValue_ml = value;
                      updatedSettingItem.admissionProteinMeasurement = textindex + 1;
                      updatedSettingItem.admissionProteinMeasurementValue_l = "";
                      updatedSettingItem.admissionProteinMeasurementValue_nl = "";
                      updatedSettingItem.admissionProteinMeasurementValue_gl = "";
                      updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    } else if (fieldName === "admissionProteinMeasurementValue_nl") {
                      updatedSettingItem.admissionProteinMeasurementValue_nl = value;
                      updatedSettingItem.admissionProteinMeasurement = textindex + 1;
                      updatedSettingItem.admissionProteinMeasurementValue_ml = "";
                      updatedSettingItem.admissionProteinMeasurementValue_l = "";
                      updatedSettingItem.admissionProteinMeasurementValue_gl = "";
                      updatedSettingItem.q33AdmissionmeasurementUrineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUrineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    }
                    
        
                    if (fieldName === "dischargeProteinMeasurement") {
                      if (parseInt(value, 10) === Values.value99) {
                        updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_gl = "";
                      } else {
                        updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                        updatedSettingItem.dischargeProteinMeasurementValue_gl = "";
                      }
                      updatedSettingItem.dischargeSpecimenType = 4;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                      updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                    }
                    if (fieldName === "dischargeProteinMeasurementValue_l") {
                      updatedSettingItem.dischargeProteinMeasurementValue_l = value;
                      updatedSettingItem.dischargeProteinMeasurement = textindex + 1;
                      updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_gl = "";

                      updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    } else if (fieldName === "dischargeProteinMeasurementValue_ml") {
                      updatedSettingItem.dischargeProteinMeasurementValue_ml = value;
                      updatedSettingItem.dischargeProteinMeasurement = textindex + 1;
                      updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_gl = "";
                      updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    } else if (fieldName === "dischargeProteinMeasurementValue_nl") {
                      updatedSettingItem.dischargeProteinMeasurementValue_nl = value;
                      updatedSettingItem.dischargeProteinMeasurement = textindex + 1;
                      updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_gl = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                      updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    // }else if (fieldName === "dischargeProteinMeasurementValue_dl") {
                    //   updatedSettingItem.dischargeProteinMeasurementValue_dl = value;
                    //   updatedSettingItem.dischargeProteinMeasurement = textindex + 1;
                    //   updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                    //   updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                    //   updatedSettingItem.dischargeProteinMeasurementValue_gl = "";
                    //   updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                    //   updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                    //   updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                    //   updatedSettingItem.q33DischargemeasurementEmpty = false;
                    }else if (fieldName === "dischargeProteinMeasurementValue_gl" && updatedSettingItem.labRenalSettingCareTypeId === Values.value4) {
                      updatedSettingItem.dischargeProteinMeasurementValue_gl = value;
                      updatedSettingItem.dischargeProteinMeasurement = textindex + 1;
                      updatedSettingItem.dischargeProteinMeasurementValue_ml = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_l = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_nl = "";
                      updatedSettingItem.dischargeProteinMeasurementValue_dl = "";
                      updatedSettingItem.q33DischargemeasurementUrineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUrineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    }
        
                    if (fieldName === "admissionCreatinineMeasurement") {
                      if (parseInt(value, 10) === Values.value99) {
                        updatedSettingItem.admissionCreatinineMeasurementValue_l = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_ml = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_nl = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_dl = "";
                      } else {
                        updatedSettingItem.admissionCreatinineMeasurementValue_l = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_ml = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_nl = "";
                        updatedSettingItem.admissionCreatinineMeasurementValue_dl = "";
                      }
        
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCystatinEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementCystatinInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                    }
                    if (fieldName === "admissionCreatinineMeasurementValue_l") {
                      updatedSettingItem.admissionCreatinineMeasurementValue_l = value;
                      updatedSettingItem.admissionCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.admissionCreatinineMeasurementValue_ml = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_nl = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_dl = "";
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    } else if (fieldName === "admissionCreatinineMeasurementValue_ml") {
                      updatedSettingItem.admissionCreatinineMeasurementValue_ml = value;
                      updatedSettingItem.admissionCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.admissionCreatinineMeasurementValue_l = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_nl = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_dl = "";
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    } else if (fieldName === "admissionCreatinineMeasurementValue_nl") {
                      updatedSettingItem.admissionCreatinineMeasurementValue_nl = value;
                      updatedSettingItem.admissionCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.admissionCreatinineMeasurementValue_ml = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_l = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_dl = "";
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    } else if (fieldName === "admissionCreatinineMeasurementValue_dl") {
                      updatedSettingItem.admissionCreatinineMeasurementValue_dl = value;
                      updatedSettingItem.admissionCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.admissionCreatinineMeasurementValue_ml = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_l = "";
                      updatedSettingItem.admissionCreatinineMeasurementValue_nl = "";
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33AdmissionmeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33AdmissionmeasurementEmpty = false;
                    }
        
                    if (fieldName === "dischargeCreatinineMeasurement") {
                      if (parseInt(value, 10) === Values.value99) {
                        updatedSettingItem.dischargeCreatinineMeasurementValue_l = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_ml = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_nl = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_dl = "";
                      } else {
                        updatedSettingItem.dischargeCreatinineMeasurementValue_l = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_ml = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_nl = "";
                        updatedSettingItem.dischargeCreatinineMeasurementValue_dl = "";
                      }
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCystatinEmpty = false;
                      updatedSettingItem.q33DischargemeasurementCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementCystatinInvalid = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                    }
                    if (fieldName === "dischargeCreatinineMeasurementValue_l") {
                      updatedSettingItem.dischargeCreatinineMeasurementValue_l = value;
                      updatedSettingItem.dischargeCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.dischargeCreatinineMeasurementValue_ml = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_nl = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_dl = "";
                      updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    } else if (fieldName === "dischargeCreatinineMeasurementValue_ml") {
                      updatedSettingItem.dischargeCreatinineMeasurementValue_ml = value;
                      updatedSettingItem.dischargeCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.dischargeCreatinineMeasurementValue_l = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_nl = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_dl = "";
                      updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    } else if (fieldName === "dischargeCreatinineMeasurementValue_nl") {
                      updatedSettingItem.dischargeCreatinineMeasurementValue_nl = value;
                      updatedSettingItem.dischargeCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.dischargeCreatinineMeasurementValue_ml = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_l = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_dl = "";
                      updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    }else if (fieldName === "dischargeCreatinineMeasurementValue_dl") {
                      updatedSettingItem.dischargeCreatinineMeasurementValue_dl = value;
                      updatedSettingItem.dischargeCreatinineMeasurement = textindex + 1;
                      updatedSettingItem.dischargeCreatinineMeasurementValue_ml = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_l = "";
                      updatedSettingItem.dischargeCreatinineMeasurementValue_nl = "";
                      updatedSettingItem.q33DischargemeasurementUCreatinineEmpty = false;
                      updatedSettingItem.q33DischargemeasurementUCreatinineInvalid = false;
                      updatedSettingItem.q33DischargemeasurementEmpty = false;
                    }
        
                    return updatedSettingItem;
                  }
                  return item;
                });
        
                return updatedSettingDetails;
              });
            }
          }


  const HandleDateChange = (name, date, optionId, index) => {
    const lastIndex = name.lastIndexOf("-");
    const idx = name.slice(lastIndex + 1);

    switch (optionId) {
     case "renalstartAssessment_dt":
        {
          let Q32array = [...labrenalassessmentDetails];
          Q32array[idx][optionId] = date;
          Q32array[idx].renalstartAssessment = 1;
          Q32array[idx].renalstartAssessmentUnkLTLKT = "";
          Q32array[idx].q32assessmentDateEmptyError = false;
          Q32array[idx].q32assessmentEmpty = false;
          setlabrenalassessmentDetails(Q32array);
        }
        break;
      case "ckdAssessment_dt":
        {
          let Q34array = [...labchronicDetails];
          Q34array[idx][optionId] = date;
          Q34array[idx].ckdAssessment = 3;
          Q34array[idx].ckdAssessmentUnkLTLKT = "";
          Q34array[idx].q34assessmentDateEmptyError = false;
          Q34array[idx].q34assessmentEmpty = false;
          setlabchronicDetails(Q34array);
        }
        break;
      case "admissionAssessmentDate":
        {
          let Q33array = [...renalSettingCareData];
          Q33array[idx][optionId] = date;
          Q33array[idx].admissionAssessment = 1;
          Q33array[idx].q33AdmissionassessmentDateEmptyError = false;
          Q33array[idx].q33AdmissionassessmentEmpty = false;
          setrenalSettingCareData(Q33array);
        }
        break;
      case "dischargeAssessmentDate":
        {
          let Q33array = [...renalSettingCareData];
          Q33array[idx][optionId] = date;
          Q33array[idx].dischargeAssessment = 1;
          Q33array[idx].q33DischargeassessmentDateEmptyError = false;
          Q33array[idx].q33DischargeassessmentEmpty = false;
          setrenalSettingCareData(Q33array);
        }
        break;
   
     
        default:
        break;
    }
  };

  useEffect(() => {

    async function FetchData() {
      pidRef.current = GetLocalStorageData("patientId") || 0;
      if (pidRef.current !== 0) {
        ToggleLoader(true);
        await GetLabData();
        setQ33AdmissionHideColumn(dates?.closest_transplantAdmissionDt);
        setQ33DischargeHideColumn(dates?.closest_transplantDischargeDt);
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  const GetLabData = async () => {
    try {
      const response = await laboratoryAssessmentService.LoadRenalLabData(
        pidRef.current,
        loggedInUserId
      );
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setpatientLocked(data.patientLocked);

 
        //#region Q32
        if (
          data.labRenalAssessmenListDetails !== null &&
          data.labRenalAssessmenListDetails.length > 0
        ) {
          let i = 0;
          let dataarray = [];

          for (i; i < data.labRenalAssessmenListDetails.length; i++) {
            const detailsStart = data.labRenalAssessmenListDetails[i];
            const assessmentUnkStart =
              detailsStart.renalAssessmentStartDateUnknown ?? "";

            const startRenalUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT &&
                assessmentUnkStart === Values.value1) ||
              (!dates?.four_to_15months_after_LT_LKT &&
                assessmentUnkStart === Values.value3) ||
              (!dates?.sixteen_to_27months_after_LT_LKT &&
                assessmentUnkStart === Values.value4)
                ? ""
                : assessmentUnkStart;

            let datacomponent = {
              labrenalassessmentid:
                data.labRenalAssessmenListDetails[i].labRenalAssessmentID !=
                null
                  ? data.labRenalAssessmenListDetails[i].labRenalAssessmentID
                  : 0,
              renalassessmentnumber:
                data.labRenalAssessmenListDetails[i].assessmentNumber,
              renalbiomarker:
                data.labRenalAssessmenListDetails[i].bioMarker !== null
                  ? data.labRenalAssessmenListDetails[i].bioMarker
                  : "",

              renalstartAssessment:
                data.labRenalAssessmenListDetails[i].renalAssessmentStart !=
                null
                  ? data.labRenalAssessmenListDetails[i].renalAssessmentStart
                  : "",
              renalstartAssessment_dt:
                data.labRenalAssessmenListDetails[i].renalAssessmentStartDate !=
                null
                  ? data.labRenalAssessmenListDetails[i]
                      .renalAssessmentStartDate
                  : "",
              renalstartAssessment_dt_estimated:
                data.labRenalAssessmenListDetails[i]
                  .renalAssessmentStartDateEstimated !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .renalAssessmentStartDateEstimated
                  : false,
              renalstartAssessmentUnkLTLKT: startRenalUnkLTLKT,

              renalspecimen:
                data.labRenalAssessmenListDetails[i].specimen !== null
                  ? data.labRenalAssessmenListDetails[i].specimen
                  : "",

              creatinine_measurement:
                data.labRenalAssessmenListDetails[i].creatinineMeasurement !=
                null
                  ? data.labRenalAssessmenListDetails[i].creatinineMeasurement
                  : "",

              creatinine_measurement_value_l:
                data.labRenalAssessmenListDetails[i]
                  .creatinineMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .creatinineMeasurement === 1
                    ? data.labRenalAssessmenListDetails[i]
                        .creatinineMeasurementValue
                    : ""
                  : "",

              creatinine_measurement_value_ml:
                data.labRenalAssessmenListDetails[i]
                  .creatinineMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .creatinineMeasurement === 2
                    ? data.labRenalAssessmenListDetails[i]
                        .creatinineMeasurementValue
                    : ""
                  : "",

              creatinine_measurement_value_nl:
                data.labRenalAssessmenListDetails[i]
                  .creatinineMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .creatinineMeasurement === 3
                    ? data.labRenalAssessmenListDetails[i]
                        .creatinineMeasurementValue
                    : ""
                  : "",

                  creatinine_measurement_value_dl:
                  data.labRenalAssessmenListDetails[i]
                    .creatinineMeasurementValue !== null
                    ? data.labRenalAssessmenListDetails[i]
                        .creatinineMeasurement === 4
                      ? data.labRenalAssessmenListDetails[i]
                          .creatinineMeasurementValue
                      : ""
                    : "",
                  

              cystatin_measurement:
                data.labRenalAssessmenListDetails[i].cystatinMeasurement !==
                null
                  ? data.labRenalAssessmenListDetails[i].cystatinMeasurement
                  : "",

              cystatin_measurement_value_l:
                data.labRenalAssessmenListDetails[i].cystatinMeasurementValue !=
                null
                  ? data.labRenalAssessmenListDetails[i].cystatinMeasurement ===
                    1
                    ? data.labRenalAssessmenListDetails[i]
                        .cystatinMeasurementValue
                    : ""
                  : "",

              cystatin_measurement_value_ml:
                data.labRenalAssessmenListDetails[i].cystatinMeasurementValue !=
                null
                  ? data.labRenalAssessmenListDetails[i].cystatinMeasurement ===
                    2
                    ? data.labRenalAssessmenListDetails[i]
                        .cystatinMeasurementValue
                    : ""
                  : "",

              cystatin_measurement_value_nl:
                data.labRenalAssessmenListDetails[i].cystatinMeasurementValue !=
                null
                  ? data.labRenalAssessmenListDetails[i].cystatinMeasurement ===
                    3
                    ? data.labRenalAssessmenListDetails[i]
                        .cystatinMeasurementValue
                    : ""
                  : "",

              urineprotein_measurement:
                data.labRenalAssessmenListDetails[i].urineProteinMeasurement !=
                null
                  ? data.labRenalAssessmenListDetails[i].urineProteinMeasurement
                  : "",

              urineprotein_measurement_value_l:
                data.labRenalAssessmenListDetails[i]
                  .urineProteinMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .urineProteinMeasurement === 1
                    ? data.labRenalAssessmenListDetails[i]
                        .urineProteinMeasurementValue
                    : ""
                  : "",

              urineprotein_measurement_value_gl:
                data.labRenalAssessmenListDetails[i]
                  .urineProteinMeasurementValue !== null
                  ? (data.labRenalAssessmenListDetails[i]
                      .urineProteinMeasurement === 2 && data.labRenalAssessmenListDetails[i].bioMarker==4)
                    ? data.labRenalAssessmenListDetails[i]
                        .urineProteinMeasurementValue
                    : ""
                  : "",

                  urineprotein_measurement_value_ml:
                  data.labRenalAssessmenListDetails[i]
                    .urineProteinMeasurementValue !== null
                    ? data.labRenalAssessmenListDetails[i]
                        .urineProteinMeasurement === (data.labRenalAssessmenListDetails[i].bioMarker==4?3:2)
                      ? data.labRenalAssessmenListDetails[i]
                          .urineProteinMeasurementValue
                      : ""
                    : "",

              urineprotein_measurement_value_nl:
                data.labRenalAssessmenListDetails[i]
                  .urineProteinMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .urineProteinMeasurement === (data.labRenalAssessmenListDetails[i].bioMarker==4?4:3)
                    ? data.labRenalAssessmenListDetails[i]
                        .urineProteinMeasurementValue
                    : ""
                  : "",

              urinecreatinine_measurement:
                data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurement !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .urineCreatinineMeasurement
                  : "",

              urinecreatinine_measurement_value_l:
                data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .urineCreatinineMeasurement === 1
                    ? data.labRenalAssessmenListDetails[i]
                        .urineCreatinineMeasurementValue
                    : ""
                  : "",

              urinecreatinine_measurement_value_ml:
                data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .urineCreatinineMeasurement === 2
                    ? data.labRenalAssessmenListDetails[i]
                        .urineCreatinineMeasurementValue
                    : ""
                  : "",

              urinecreatinine_measurement_value_nl:
                data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurementValue !== null
                  ? data.labRenalAssessmenListDetails[i]
                      .urineCreatinineMeasurement === 3
                    ? data.labRenalAssessmenListDetails[i]
                        .urineCreatinineMeasurementValue
                    : ""
                  : "",

                  urinecreatinine_measurement_value_dl:
                  data.labRenalAssessmenListDetails[i]
                    .urineCreatinineMeasurementValue !== null
                    ? data.labRenalAssessmenListDetails[i]
                        .urineCreatinineMeasurement === 4
                      ? data.labRenalAssessmenListDetails[i]
                          .urineCreatinineMeasurementValue
                      : ""
                    : "",


              q32biomarkerEmpty: false,
              q32assessmentEmpty: false,
              q32specimenEmpty: false,
              q32measurementEmpty: false,
              q32assessmentDateEmptyError: false,
              q32assessmentDateInvalid: false,
              q32AssessmentDateUnkEmpty: false,
              q32measurementCreatinineEmpty: false,
              q32measurementCystatinEmpty: false,
              q32measurementUrineEmpty: false,
              q32measurementUCreatinineEmpty: false,
              q32measurementCreatinineInvalid: false,
              q32measurementCystatinInvalid: false,
              q32measurementUrineInvalid: false,
              q32measurementUCreatinineInvalid: false,
            };

            dataarray.push(datacomponent);
          }
          setlabrenalassessmentDetails(dataarray);
        }
        //#endregion

        //#region  Q34
        if (
          data.labChronicKidneyListDetails !== null &&
          data.labChronicKidneyListDetails.length > 0
        ) {
          let i = 0;
          let dataarray = [];

          for (i; i < data.labChronicKidneyListDetails.length; i++) {
            const detailsStart = data.labChronicKidneyListDetails[i];
            const assessmentUnkStart =
              detailsStart.ckdAssessmentDateUnknown ?? "";

            const startChronicUnkLTLKT =
              (!dates?.zero_to12months_before_LT_LKT &&
                assessmentUnkStart === Values.value1) ||
              (!dates?.zero_to_3months_after_LT_LKT &&
                assessmentUnkStart === Values.value2) ||
              (!dates?.four_to_15months_after_LT_LKT &&
                assessmentUnkStart === Values.value3) ||
              (!dates?.sixteen_to_27months_after_LT_LKT &&
                assessmentUnkStart === Values.value4)
                ? ""
                : assessmentUnkStart;

            let datacomponent = {
              labchronicid:
                data.labChronicKidneyListDetails[i].labChronicID !== null
                  ? data.labChronicKidneyListDetails[i].labChronicID
                  : 0,
              ckdAssessment:
                data.labChronicKidneyListDetails[i].ckdAssessment !== null
                  ? data.labChronicKidneyListDetails[i].ckdAssessment
                  : "",
              ckdAssessment_dt:
                data.labChronicKidneyListDetails[i].ckdAssessmentDate !== null
                  ? data.labChronicKidneyListDetails[i].ckdAssessmentDate
                  : "",
              ckdAssessment_dt_estimated:
                data.labChronicKidneyListDetails[i]
                  .ckdAssessmentDateEstimated !== null
                  ? data.labChronicKidneyListDetails[i]
                      .ckdAssessmentDateEstimated
                  : false,
                  ckdAssessmentUnkLTLKT: startChronicUnkLTLKT,

              ckdstage:
                data.labChronicKidneyListDetails[i].ckdStage !== null
                  ? data.labChronicKidneyListDetails[i].ckdStage
                  : "",

              ckdkidneyfailure:
                data.labChronicKidneyListDetails[i].ckdKidneyFailure !== null
                  ? data.labChronicKidneyListDetails[i].ckdKidneyFailure
                      : false,
              q34StageEmpty: false,
              q34assessmentEmpty: false,
              q34assessmentDateEmptyError: false,
              q34assessmentDateInvalid: false,
              q34AssessmentDateUnkEmpty: false,
            };

            dataarray.push(datacomponent);
          }
          setlabchronicDetails(dataarray);
        }
        //#endregion

        //#region Q33

        setrenalSettingCareData((prev) =>
          prev.map((item, index) => ({
            ...item,
            labRenalSettingCareTypeId:
              data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid ||
              0,
            question: data.labrenalsettingcaretypes[index]?.questionno || "",
            label: data.labrenalsettingcaretypes[index]?.name || "",
            settingcare: data.labRenalSettingCareVisit,
            labRenalSettingCareId:
              data.labRenalSettingCareDetails[index]?.labRenalSettingCareId ||
              0,
            admissionAssessment:
              data.labRenalSettingCareDetails[index]?.admissionAssessment || "",
            admissionAssessmentDate:
              data.labRenalSettingCareDetails[index]?.admissionAssessmentDate ||
              "",
            admissionAssessmentDateEstimated:
              data.labRenalSettingCareDetails[index]
                ?.admissionAssessmentDateEstimated || false,
            admissionSpecimenType:
              data.labRenalSettingCareDetails[index]?.admissionSpecimenType ||
              "",
            admissionMeasurement:
              data.labRenalSettingCareDetails[index]?.admissionMeasurement ||
              "",

            admissionMeasurementValue_l:
              data.labRenalSettingCareDetails[index]
                ?.admissionMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionMeasurement === 1
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",
            admissionMeasurementValue_ml:
              data.labRenalSettingCareDetails[index]
                ?.admissionMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionMeasurement === 2
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",
            admissionMeasurementValue_nl:
              data.labRenalSettingCareDetails[index]
                ?.admissionMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionMeasurement === 3
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",

                admissionMeasurementValue_dl:
                data.labRenalSettingCareDetails[index]
                  ?.admissionMeasurementValue !== null
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionMeasurement === 4
                    ? data.labRenalSettingCareDetails[index]
                        ?.admissionMeasurementValue
                    : ""
                  : "",

            admissionProteinMeasurement:
              data.labRenalSettingCareDetails[index]
                ?.admissionProteinMeasurement || "",

            admissionProteinMeasurementValue_l:
              data.labRenalSettingCareDetails[index]
                ?.admissionProteinMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurement === 1
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionProteinMeasurementValue
                  : ""
                : "",


                admissionProteinMeasurementValue_gl:
                data.labRenalSettingCareDetails[index]
                  ?.admissionProteinMeasurementValue !== null
                  ? (data.labRenalSettingCareDetails[index]
                      ?.admissionProteinMeasurement === 2 && data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===Values.values4)
                    ? data.labRenalSettingCareDetails[index]
                        ?.admissionProteinMeasurementValue
                    : ""
                  : "",

         

            admissionProteinMeasurementValue_ml:
              data.labRenalSettingCareDetails[index]
                ?.admissionProteinMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?3:2)
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionProteinMeasurementValue
                  : ""
                : "",
            admissionProteinMeasurementValue_nl:
              data.labRenalSettingCareDetails[index]
                ?.admissionProteinMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?4:3)
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionProteinMeasurementValue
                  : ""
                : "",

            admissionCreatinineMeasurement:
              data.labRenalSettingCareDetails[index]
                ?.admissionCreatinineMeasurement || "",

            admissionCreatinineMeasurementValue_l:
              data.labRenalSettingCareDetails[index]
                ?.admissionCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurement === 1
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionCreatinineMeasurementValue
                  : ""
                : "",
            admissionCreatinineMeasurementValue_ml:
              data.labRenalSettingCareDetails[index]
                ?.admissionCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurement === 2
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionCreatinineMeasurementValue
                  : ""
                : "",
            admissionCreatinineMeasurementValue_nl:
              data.labRenalSettingCareDetails[index]
                ?.admissionCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurement === 3
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionCreatinineMeasurementValue
                  : ""
                : "",

                admissionCreatinineMeasurementValue_dl:
                data.labRenalSettingCareDetails[index]
                  ?.admissionCreatinineMeasurementValue !== null
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionCreatinineMeasurement === 4
                    ? data.labRenalSettingCareDetails[index]
                        ?.admissionCreatinineMeasurementValue
                    : ""
                  : "",

            admissionSettingCareId:
              data.labRenalSettingCareDetails[index]?.admissionSettingCareID ||
              "",
            admissionSettingCareOther:
              data.labRenalSettingCareDetails[index]
                ?.admissionSettingCareOther || "",

            dischargeAssessment:
              data.labRenalSettingCareDetails[index]?.dischargeAssessment || "",
            dischargeAssessmentDate:
              data.labRenalSettingCareDetails[index]?.dischargeAssessmentDate ||
              "",
            dischargeAssessmentDateEstimated:
              data.labRenalSettingCareDetails[index]
                ?.dischargeAssessmentDateEstimated || false,
            dischargeSpecimenType:
              data.labRenalSettingCareDetails[index]?.dischargeSpecimenType ||
              "",
            dischargeMeasurement:
              data.labRenalSettingCareDetails[index]?.dischargeMeasurement ||
              "",

            dischargeMeasurementValue_l:
              data.labRenalSettingCareDetails[index]
                ?.dischargeMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeMeasurement === 1
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",
            dischargeMeasurementValue_ml:
              data.labRenalSettingCareDetails[index]
                ?.dischargeMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeMeasurement === 2
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",
            dischargeMeasurementValue_nl:
              data.labRenalSettingCareDetails[index]
                ?.dischargeMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeMeasurement === 3
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",


                dischargeMeasurementValue_dl:
                data.labRenalSettingCareDetails[index]
                  ?.dischargeMeasurementValue !== null
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeMeasurement === 4
                    ? data.labRenalSettingCareDetails[index]
                        ?.dischargeMeasurementValue
                    : ""
                  : "",

            dischargeProteinMeasurement:
              data.labRenalSettingCareDetails[index]
                ?.dischargeProteinMeasurement || "",

            dischargeProteinMeasurementValue_l:
              data.labRenalSettingCareDetails[index]
                ?.dischargeProteinMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurement === 1
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeProteinMeasurementValue
                  : ""
                : "",

                dischargeProteinMeasurementValue_gl:
                data.labRenalSettingCareDetails[index]
                  ?.dischargeProteinMeasurementValue !== null
                  ? (data.labRenalSettingCareDetails[index]
                      ?.dischargeProteinMeasurement === 2 && data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===Values.value4)
                    ? data.labRenalSettingCareDetails[index]
                        ?.dischargeProteinMeasurementValue
                    : ""
                  : "",

            dischargeProteinMeasurementValue_ml:
              data.labRenalSettingCareDetails[index]
                ?.dischargeProteinMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?3:2)
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeProteinMeasurementValue
                  : ""
                : "",
            dischargeProteinMeasurementValue_nl:
              data.labRenalSettingCareDetails[index]
                ?.dischargeProteinMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?4:3)
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeProteinMeasurementValue
                  : ""
                : "",

                // dischargeProteinMeasurementValue_dl:
                // data.labRenalSettingCareDetails[index]
                //   ?.dischargeProteinMeasurementValue !== null
                //   ? data.labRenalSettingCareDetails[index]
                //       ?.dischargeProteinMeasurement === 5
                //     ? data.labRenalSettingCareDetails[index]
                //         ?.dischargeProteinMeasurementValue
                //     : ""
                //   : "",

            dischargeCreatinineMeasurement:
              data.labRenalSettingCareDetails[index]
                ?.dischargeCreatinineMeasurement || "",

            dischargeCreatinineMeasurementValue_l:
              data.labRenalSettingCareDetails[index]
                ?.dischargeCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurement === 1
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeCreatinineMeasurementValue
                  : ""
                : "",
            dischargeCreatinineMeasurementValue_ml:
              data.labRenalSettingCareDetails[index]
                ?.dischargeCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurement === 2
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeCreatinineMeasurementValue
                  : ""
                : "",
            dischargeCreatinineMeasurementValue_nl:
              data.labRenalSettingCareDetails[index]
                ?.dischargeCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurement === 3
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeCreatinineMeasurementValue
                  : ""
                : "",

                dischargeCreatinineMeasurementValue_dl:
                data.labRenalSettingCareDetails[index]
                  ?.dischargeCreatinineMeasurementValue !== null
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeCreatinineMeasurement === 4
                    ? data.labRenalSettingCareDetails[index]
                        ?.dischargeCreatinineMeasurementValue
                    : ""
                  : "",

            dischargeSettingCareId:
              data.labRenalSettingCareDetails[index]?.dischargeSettingCareID ||
              "",
            dischargeSettingCareOther:
              data.labRenalSettingCareDetails[index]
                ?.dischargeSettingCareOther || "",

            q33AdmissionassessmentEmpty: false,
            q33AdmissionspecimenEmpty: false,
            q33AdmissionSettingCareEmpty: false,
            q33AdmissionSettingCareOtherEmpty: false,
            q33AdmissionmeasurementEmpty: false,
            q33AdmissionassessmentDateEmptyError: false,
            q33AdmissionassessmentDateInvalid: false,
            q33AdmissionAssessmentDateUnkEmpty: false,
            q33AdmissionmeasurementCreatinineEmpty: false,
            q33AdmissionmeasurementCystatinEmpty: false,
            q33AdmissionmeasurementUrineEmpty: false,
            q33AdmissionmeasurementUCreatinineEmpty: false,
            q33AdmissionmeasurementCreatinineInvalid: false,
            q33AdmissionmeasurementCystatinInvalid: false,
            q33AdmissionmeasurementUrineInvalid: false,
            q33AdmissionmeasurementUCreatinineInvalid: false,
            q33DischargeassessmentEmpty: false,
            q33DischargespecimenEmpty: false,
            q33DischargeSettingCareEmpty: false,
            q33DischargeSettingCareOtherEmpty: false,
            q33DischargemeasurementEmpty: false,
            q33DischargeassessmentDateEmptyError: false,
            q33DischargeassessmentDateInvalid: false,
            q33DischargeAssessmentDateUnkEmpty: false,
            q33DischargemeasurementCreatinineEmpty: false,
            q33DischargemeasurementCystatinEmpty: false,
            q33DischargemeasurementUrineEmpty: false,
            q33DischargemeasurementUCreatinineEmpty: false,
            q33DischargemeasurementCreatinineInvalid: false,
            q33DischargemeasurementCystatinInvalid: false,
            q33DischargemeasurementUrineInvalid: false,
            q33DischargemeasurementUCreatinineInvalid: false,
          }))
        );
        //#endregion

      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch {}
  };

  const SavePage = async (validate) => {
    try {
        if (!patientLocked) {
            //Reset Errors
            let isValid = validate ? Validate() : true;

            if (!isValid) {
                setShowTopErrMsg(true);
                return false;
            }
            setShowTopErrMsg(false);
            if (pidRef.current > 0) {
                const data = {
                    LabAssessmentModel: {
                        LoggedInUserId: loggedInUserId,
                        Patientid: pidRef.current,
                        IsValidated: validate,
                        IsAdmin: IsAdmin(),
                        LabBiomarkerAssessmenListDetails: [],
                        LabRenalAssessmenListDetails: [],
                        LabChronicKidneyListDetails: [],
                        LabAssessmentListDetails: [],
                        LabRenalSettingCareDetails: [],
                        LabAssessmentMdeDetails: [],
                    },
                };

                //#region Q32
                if (labrenalassessmentDetails.length > 0) {
                    for (const renalAssessment of labrenalassessmentDetails) {
                        let renalAssessmentData = {
                            labRenalAssessmentID: renalAssessment.labrenalassessmentid,
                            assessmentNumber: renalAssessment.renalassessmentnumber,
                            biomarker: renalAssessment.renalbiomarker,
                            renalAssessmentStart: renalAssessment.renalstartAssessment,
                            renalAssessmentStartDate: renalAssessment.renalstartAssessment_dt,
                            renalAssessmentStartDateEstimated:
                                renalAssessment.renalstartAssessment_dt_estimated,
                            renalAssessmentStartDateUnknown:
                                renalAssessment.renalstartAssessmentUnkLTLKT,
                            specimen: renalAssessment.renalspecimen,
                            creatinineMeasurement: renalAssessment.creatinine_measurement,
                            creatinineMeasurementValue:
                                renalAssessment.creatinine_measurement === 1
                                    ? renalAssessment.creatinine_measurement_value_l
                                    : renalAssessment.creatinine_measurement === 2
                                        ? renalAssessment.creatinine_measurement_value_ml
                                        : renalAssessment.creatinine_measurement === 3
                                            ? renalAssessment.creatinine_measurement_value_nl
                                            : renalAssessment.creatinine_measurement === 4
                                                ? renalAssessment.creatinine_measurement_value_dl
                                                : "",

                            cystatinMeasurement: renalAssessment.cystatin_measurement,
                            cystatinMeasurementValue:
                                renalAssessment.cystatin_measurement === 1
                                    ? renalAssessment.cystatin_measurement_value_l
                                    : renalAssessment.cystatin_measurement === 2
                                        ? renalAssessment.cystatin_measurement_value_ml
                                        : renalAssessment.cystatin_measurement === 3
                                            ? renalAssessment.cystatin_measurement_value_nl
                                            : "",
                            urineProteinMeasurement: renalAssessment.urineprotein_measurement,
                            urineProteinMeasurementValue:
                                renalAssessment.urineprotein_measurement === 1
                                    ? renalAssessment.urineprotein_measurement_value_l
                                    : renalAssessment.urineprotein_measurement === 2 && renalAssessment.renalbiomarker === 4
                                        ? renalAssessment.urineprotein_measurement_value_gl
                                        : renalAssessment.urineprotein_measurement === (renalAssessment.renalbiomarker === 4 ? 3 : 2)
                                            ? renalAssessment.urineprotein_measurement_value_ml
                                            : renalAssessment.urineprotein_measurement === (renalAssessment.renalbiomarker === 4 ? 4 : 3)
                                                ? renalAssessment.urineprotein_measurement_value_nl
                                                : "",
                            urineCreatinineMeasurement:
                                renalAssessment.urinecreatinine_measurement,
                            UrineCreatinineMeasurementValue:
                                renalAssessment.urinecreatinine_measurement === 1
                                    ? renalAssessment.urinecreatinine_measurement_value_l
                                    : renalAssessment.urinecreatinine_measurement === 2
                                        ? renalAssessment.urinecreatinine_measurement_value_ml
                                        : renalAssessment.urinecreatinine_measurement === 3
                                            ? renalAssessment.urinecreatinine_measurement_value_nl
                                            : renalAssessment.urinecreatinine_measurement === 4
                                                ? renalAssessment.urinecreatinine_measurement_value_dl
                                                : "",
                        };
                        data.LabAssessmentModel.LabRenalAssessmenListDetails.push(
                            renalAssessmentData
                        );
                    }
                }
                //#endregion

                //#region  Q34
                if (labchronicDetails.length > 0) {
                    for (const chronicAssessment of labchronicDetails) {
                        let chronicData = {
                            labChronicID: chronicAssessment.labchronicid,
                            ckdAssessment: chronicAssessment.ckdAssessment,
                            ckdAssessmentDate: chronicAssessment.ckdAssessment_dt,
                            ckdAssessmentDateEstimated:
                                chronicAssessment.ckdAssessment_dt_estimated,
                            ckdAssessmentDateUnknown: chronicAssessment.ckdAssessmentUnkLTLKT,
                            ckdStage: chronicAssessment.ckdstage,
                            ckdKidneyFailure: chronicAssessment.ckdkidneyfailure == false ? 0 : 1,
                        };
                        data.LabAssessmentModel.LabChronicKidneyListDetails.push(
                            chronicData
                        );
                    }
                }
                //#endregion


                //#region Q33
                if (renalSettingCareData.length > 0) {
                    for (const settingCare of renalSettingCareData) {
                        let SettingCareData = {
                            labRenalSettingCareId: settingCare.labRenalSettingCareId,
                            labRenalSettingCareTypeId: settingCare.labRenalSettingCareTypeId,
                            admissionAssessment: settingCare.admissionAssessment,
                            admissionAssessmentDate: settingCare.admissionAssessmentDate,
                            admissionAssessmentDateEstimated:
                                settingCare.admissionAssessmentDateEstimated,
                            admissionSpecimenType: settingCare.admissionSpecimenType,
                            admissionMeasurement: settingCare.admissionMeasurement,
                            admissionMeasurementValue:
                                settingCare.admissionMeasurement === 1
                                    ? settingCare.admissionMeasurementValue_l
                                    : settingCare.admissionMeasurement === 2
                                        ? settingCare.admissionMeasurementValue_ml
                                        : settingCare.admissionMeasurement === 3
                                            ? settingCare.admissionMeasurementValue_nl
                                            : settingCare.admissionMeasurement === 4
                                                ? settingCare.admissionMeasurementValue_dl
                                                : "",
                            admissionProteinMeasurement:
                                settingCare.admissionProteinMeasurement,
                            admissionProteinMeasurementValue:
                                settingCare.admissionProteinMeasurement === 1
                                    ? settingCare.admissionProteinMeasurementValue_l
                                    : settingCare.admissionProteinMeasurement === 2 && settingCare.labRenalSettingCareTypeId === Values.value4
                                        ? settingCare.admissionProteinMeasurementValue_gl
                                        : settingCare.admissionProteinMeasurement === (settingCare.labRenalSettingCareTypeId === 4 ? 3 : 2)
                                            ? settingCare.admissionProteinMeasurementValue_ml
                                            : settingCare.admissionProteinMeasurement === (settingCare.labRenalSettingCareTypeId === 4 ? 4 : 3)
                                                ? settingCare.admissionProteinMeasurementValue_nl
                                                : "",

                            admissionCreatinineMeasurement:
                                settingCare.admissionCreatinineMeasurement,
                            admissionCreatinineMeasurementValue:
                                settingCare.admissionCreatinineMeasurement === 1
                                    ? settingCare.admissionCreatinineMeasurementValue_l
                                    : settingCare.admissionCreatinineMeasurement === 2
                                        ? settingCare.admissionCreatinineMeasurementValue_ml
                                        : settingCare.admissionCreatinineMeasurement === 3
                                            ? settingCare.admissionCreatinineMeasurementValue_nl
                                            : settingCare.admissionCreatinineMeasurement === 4
                                                ? settingCare.admissionCreatinineMeasurementValue_dl
                                                : "",
                            admissionSettingCareID: settingCare.admissionSettingCareId,
                            admissionSettingCareOther: settingCare.admissionSettingCareOther,

                            dischargeAssessment: settingCare.dischargeAssessment,
                            dischargeAssessmentDate: settingCare.dischargeAssessmentDate,
                            dischargeAssessmentDateEstimated:
                                settingCare.dischargeAssessmentDateEstimated,
                            dischargeSpecimenType: settingCare.dischargeSpecimenType,
                            dischargeMeasurement: settingCare.dischargeMeasurement,
                            dischargeMeasurementValue:
                                settingCare.dischargeMeasurement === 1
                                    ? settingCare.dischargeMeasurementValue_l
                                    : settingCare.dischargeMeasurement === 2
                                        ? settingCare.dischargeMeasurementValue_ml
                                        : settingCare.dischargeMeasurement === 3
                                            ? settingCare.dischargeMeasurementValue_nl
                                            : settingCare.dischargeMeasurement === 4
                                                ? settingCare.dischargeMeasurementValue_dl
                                                : "",
                            dischargeProteinMeasurement:
                                settingCare.dischargeProteinMeasurement,
                            dischargeProteinMeasurementValue:
                                settingCare.dischargeProteinMeasurement === 1
                                    ? settingCare.dischargeProteinMeasurementValue_l
                                    : settingCare.dischargeProteinMeasurement === 2 && settingCare.labRenalSettingCareTypeId === Values.value4
                                        ? settingCare.dischargeProteinMeasurementValue_gl
                                        : settingCare.dischargeProteinMeasurement === (settingCare.labRenalSettingCareTypeId === 4 ? 3 : 2)
                                            ? settingCare.dischargeProteinMeasurementValue_ml
                                            : settingCare.dischargeProteinMeasurement === (settingCare.labRenalSettingCareTypeId === 4 ? 4 : 3)
                                                ? settingCare.dischargeProteinMeasurementValue_nl
                                                // : settingCare.dischargeProteinMeasurement === 5
                                                // ? settingCare.dischargeProteinMeasurementValue_dl
                                                : "",
                            dischargeCreatinineMeasurement:
                                settingCare.dischargeCreatinineMeasurement,
                            dischargeCreatinineMeasurementValue:
                                settingCare.dischargeCreatinineMeasurement === 1
                                    ? settingCare.dischargeCreatinineMeasurementValue_l
                                    : settingCare.dischargeCreatinineMeasurement === 2
                                        ? settingCare.dischargeCreatinineMeasurementValue_ml
                                        : settingCare.dischargeCreatinineMeasurement === 3
                                            ? settingCare.dischargeCreatinineMeasurementValue_nl
                                            : settingCare.dischargeCreatinineMeasurement === 4
                                                ? settingCare.dischargeCreatinineMeasurementValue_dl
                                                : "",
                            dischargeSettingCareID: settingCare.dischargeSettingCareId,
                            dischargeSettingCareOther: settingCare.dischargeSettingCareOther,
                        };
                        data.LabAssessmentModel.LabRenalSettingCareDetails.push(
                            SettingCareData
                        );
                    }
                }
                //#endregion


                ToggleLoader(true);
                const response = await laboratoryAssessmentService.SaveRenalLabData(
                    data.LabAssessmentModel
                );
                ToggleLoader(false);
                if (response.status !== HTTPResponse.OK) {
                    if (response?.status === HTTPResponse.Unauthorized) {
                        HandleSessionTimeout();
                    } else throw response.error;
                } else {
                    ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                    // await LoadData();
                    if (response) {
                        const { data } = response;
                        if (data) {
                            SetAssessmentFields(data);
                        }
                    }
                }
            }
        }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  const SetAssessmentFields = (data) => {

    //#region Q32
    if (
      data.labRenalAssessmenListDetails !== null &&
      data.labRenalAssessmenListDetails.length > 0
    ) {
      let i = 0;
      let dataarray = [];
      for (i; i < data.labRenalAssessmenListDetails.length; i++) {
        let datacomponent = {
          labrenalassessmentid:
            data.labRenalAssessmenListDetails[i].labRenalAssessmentID !== null
              ? data.labRenalAssessmenListDetails[i].labRenalAssessmentID
              : 0,
          renalassessmentnumber:
            data.labRenalAssessmenListDetails[i].assessmentNumber,
          renalbiomarker:
            data.labRenalAssessmenListDetails[i].bioMarker !== null
              ? data.labRenalAssessmenListDetails[i].bioMarker
              : "",

          renalstartAssessment:
            data.labRenalAssessmenListDetails[i].renalAssessmentStart !== null
              ? data.labRenalAssessmenListDetails[i].renalAssessmentStart
              : "",
          renalstartAssessment_dt:
            data.labRenalAssessmenListDetails[i].renalAssessmentStartDate !=
            null
              ? data.labRenalAssessmenListDetails[i].renalAssessmentStartDate
              : "",
          renalstartAssessment_dt_estimated:
            data.labRenalAssessmenListDetails[i]
              .renalAssessmentStartDateEstimated !== null
              ? data.labRenalAssessmenListDetails[i]
                  .renalAssessmentStartDateEstimated
              : false,
          renalstartAssessmentUnkLTLKT:
            data.labRenalAssessmenListDetails[i]
              .renalAssessmentStartDateUnknown !== null
              ? data.labRenalAssessmenListDetails[i]
                  .renalAssessmentStartDateUnknown
              : "",

          renalspecimen:
            data.labRenalAssessmenListDetails[i].specimen !== null
              ? data.labRenalAssessmenListDetails[i].specimen
              : "",

          creatinine_measurement:
            data.labRenalAssessmenListDetails[i].creatinineMeasurement !== null
              ? data.labRenalAssessmenListDetails[i].creatinineMeasurement
              : "",

          creatinine_measurement_value_l:
            data.labRenalAssessmenListDetails[i].creatinineMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].creatinineMeasurement === 1
                ? data.labRenalAssessmenListDetails[i]
                    .creatinineMeasurementValue
                : ""
              : "",

          creatinine_measurement_value_ml:
            data.labRenalAssessmenListDetails[i].creatinineMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].creatinineMeasurement === 2
                ? data.labRenalAssessmenListDetails[i]
                    .creatinineMeasurementValue
                : ""
              : "",

          creatinine_measurement_value_nl:
            data.labRenalAssessmenListDetails[i].creatinineMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].creatinineMeasurement === 3
                ? data.labRenalAssessmenListDetails[i]
                    .creatinineMeasurementValue
                : ""
              : "",

              creatinine_measurement_value_dl:
              data.labRenalAssessmenListDetails[i].creatinineMeasurementValue !=
              null
                ? data.labRenalAssessmenListDetails[i].creatinineMeasurement === 4
                  ? data.labRenalAssessmenListDetails[i]
                      .creatinineMeasurementValue
                  : ""
                : "",

          cystatin_measurement:
            data.labRenalAssessmenListDetails[i].cystatinMeasurement !== null
              ? data.labRenalAssessmenListDetails[i].cystatinMeasurement
              : "",

          cystatin_measurement_value_l:
            data.labRenalAssessmenListDetails[i].cystatinMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].cystatinMeasurement === 1
                ? data.labRenalAssessmenListDetails[i].cystatinMeasurementValue
                : ""
              : "",

              cystatin_measurement_value_ml:
              data.labRenalAssessmenListDetails[i].cystatinMeasurementValue !=
              null
                ? data.labRenalAssessmenListDetails[i].cystatinMeasurement === 2
                  ? data.labRenalAssessmenListDetails[i].cystatinMeasurementValue
                  : ""
                : "",

          cystatin_measurement_value_nl:
            data.labRenalAssessmenListDetails[i].cystatinMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].cystatinMeasurement === 3
                ? data.labRenalAssessmenListDetails[i].cystatinMeasurementValue
                : ""
              : "",

          urineprotein_measurement:
            data.labRenalAssessmenListDetails[i].urineProteinMeasurement !==
            null
              ? data.labRenalAssessmenListDetails[i].urineProteinMeasurement
              : "",

          urineprotein_measurement_value_l:
            data.labRenalAssessmenListDetails[i].urineProteinMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].urineProteinMeasurement ===
                1
                ? data.labRenalAssessmenListDetails[i]
                    .urineProteinMeasurementValue
                : ""
              : "",


              urineprotein_measurement_value_gl:
              data.labRenalAssessmenListDetails[i].urineProteinMeasurementValue !=
              null
                ? (data.labRenalAssessmenListDetails[i].urineProteinMeasurement ===
                  2 && data.labRenalAssessmenListDetails[i].bioMarker===4)
                  ? data.labRenalAssessmenListDetails[i]
                      .urineProteinMeasurementValue
                  : ""
                : "",

          urineprotein_measurement_value_ml:
            data.labRenalAssessmenListDetails[i].urineProteinMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].urineProteinMeasurement ===
                (data.labRenalAssessmenListDetails[i].bioMarker==4?3:2)
                ? data.labRenalAssessmenListDetails[i]
                    .urineProteinMeasurementValue
                : ""
              : "",

          urineprotein_measurement_value_nl:
            data.labRenalAssessmenListDetails[i].urineProteinMeasurementValue !=
            null
              ? data.labRenalAssessmenListDetails[i].urineProteinMeasurement ===
                (data.labRenalAssessmenListDetails[i].bioMarker===4?4:3)
                ? data.labRenalAssessmenListDetails[i]
                    .urineProteinMeasurementValue
                : ""
              : "",

          urinecreatinine_measurement:
            data.labRenalAssessmenListDetails[i].urineCreatinineMeasurement !=
            null
              ? data.labRenalAssessmenListDetails[i].urineCreatinineMeasurement
              : "",

          urinecreatinine_measurement_value_l:
            data.labRenalAssessmenListDetails[i]
              .urineCreatinineMeasurementValue !== null
              ? data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurement === 1
                ? data.labRenalAssessmenListDetails[i]
                    .urineCreatinineMeasurementValue
                : ""
              : "",

          urinecreatinine_measurement_value_ml:
            data.labRenalAssessmenListDetails[i]
              .urineCreatinineMeasurementValue !== null
              ? data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurement === 2
                ? data.labRenalAssessmenListDetails[i]
                    .urineCreatinineMeasurementValue
                : ""
              : "",

          urinecreatinine_measurement_value_nl:
            data.labRenalAssessmenListDetails[i]
              .urineCreatinineMeasurementValue !== null
              ? data.labRenalAssessmenListDetails[i]
                  .urineCreatinineMeasurement === 3
                ? data.labRenalAssessmenListDetails[i]
                    .urineCreatinineMeasurementValue
                : ""
              : "",

              urinecreatinine_measurement_value_dl:
              data.labRenalAssessmenListDetails[i]
                .urineCreatinineMeasurementValue !== null
                ? data.labRenalAssessmenListDetails[i]
                    .urineCreatinineMeasurement === 4
                  ? data.labRenalAssessmenListDetails[i]
                      .urineCreatinineMeasurementValue
                  : ""
                : "",


          q32biomarkerEmpty: false,
          q32assessmentEmpty: false,
          q32specimenEmpty: false,
          q32measurementEmpty: false,
          q32assessmentDateEmptyError: false,
          q32assessmentDateInvalid: false,
          q32AssessmentDateUnkEmpty: false,
          q32measurementCreatinineEmpty: false,
          q32measurementCystatinEmpty: false,
          q32measurementUrineEmpty: false,
          q32measurementUCreatinineEmpty: false,
          q32measurementCreatinineInvalid: false,
          q32measurementCystatinInvalid: false,
          q32measurementUrineInvalid: false,
          q32measurementUCreatinineInvalid: false,
        };

        dataarray.push(datacomponent);
      }
      setlabrenalassessmentDetails(dataarray);
    }
    //#endregion

    //#region Q34
    if (
      data.labChronicKidneyListDetails !== null &&
      data.labChronicKidneyListDetails.length > 0
    ) {
      let i = 0;
      let dataarray = [];

      for (i; i < data.labChronicKidneyListDetails.length; i++) {
        let datacomponent = {
          labchronicid:
            data.labChronicKidneyListDetails[i].labChronicID !== null
              ? data.labChronicKidneyListDetails[i].labChronicID
              : 0,
          ckdAssessment:
            data.labChronicKidneyListDetails[i].ckdAssessment !== null
              ? data.labChronicKidneyListDetails[i].ckdAssessment
              : "",
          ckdAssessment_dt:
            data.labChronicKidneyListDetails[i].ckdAssessmentDate !== null
              ? data.labChronicKidneyListDetails[i].ckdAssessmentDate
              : "",
          ckdAssessment_dt_estimated:
            data.labChronicKidneyListDetails[i].ckdAssessmentDateEstimated !=
            null
              ? data.labChronicKidneyListDetails[i].ckdAssessmentDateEstimated
              : false,
              ckdAssessmentUnkLTLKT:
            data.labChronicKidneyListDetails[i].ckdAssessmentDateUnknown !== null
              ? data.labChronicKidneyListDetails[i].ckdAssessmentDateUnknown
              : "",

          ckdstage:
            data.labChronicKidneyListDetails[i].ckdStage !== null
              ? data.labChronicKidneyListDetails[i].ckdStage
              : "",

          ckdkidneyfailure:
            data.labChronicKidneyListDetails[i].ckdKidneyFailure !== null
              ? data.labChronicKidneyListDetails[i].ckdKidneyFailure
                  : false,
          q34StageEmpty: false,
          q34assessmentEmpty: false,
          q34assessmentDateEmptyError: false,
          q34assessmentDateInvalid: false,
          q34AssessmentDateUnkEmpty: false,
        };

        dataarray.push(datacomponent);
      }
      setlabchronicDetails(dataarray);
    }
    //#endregion

 //#region Q33
    setrenalSettingCareData((prev) =>
      prev
        .map((item, index) => ({
          ...item,
          labRenalSettingCareTypeId:
            data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid ||
            0,
          question: data.labrenalsettingcaretypes[index]?.questionno || "",
          label: data.labrenalsettingcaretypes[index]?.name || "",
          settingcare: data.labRenalSettingCareVisit,
          labRenalSettingCareId:
            data.labRenalSettingCareDetails[index]?.labRenalSettingCareId || 0,
          admissionAssessment:
            data.labRenalSettingCareDetails[index]?.admissionAssessment || "",
          admissionAssessmentDate:
            data.labRenalSettingCareDetails[index]?.admissionAssessmentDate ||
            "",
          admissionAssessmentDateEstimated:
            data.labRenalSettingCareDetails[index]
              ?.admissionAssessmentDateEstimated || false,
          admissionSpecimenType:
            data.labRenalSettingCareDetails[index]?.admissionSpecimenType || "",
          admissionMeasurement:
            data.labRenalSettingCareDetails[index]?.admissionMeasurement || "",
          admissionMeasurementValue_l:
            data.labRenalSettingCareDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labRenalSettingCareDetails[index]?.admissionMeasurement ===
                1
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionMeasurementValue
                : ""
              : "",
          admissionMeasurementValue_ml:
            data.labRenalSettingCareDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labRenalSettingCareDetails[index]?.admissionMeasurement ===
                2
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionMeasurementValue
                : ""
              : "",
          admissionMeasurementValue_nl:
            data.labRenalSettingCareDetails[index]?.admissionMeasurementValue !=
            null
              ? data.labRenalSettingCareDetails[index]?.admissionMeasurement ===
                3
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionMeasurementValue
                : ""
              : "",

              admissionMeasurementValue_dl:
              data.labRenalSettingCareDetails[index]?.admissionMeasurementValue !=
              null
                ? data.labRenalSettingCareDetails[index]?.admissionMeasurement ===
                  4
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionMeasurementValue
                  : ""
                : "",

          admissionProteinMeasurement:
            data.labRenalSettingCareDetails[index]
              ?.admissionProteinMeasurement || "",

          admissionProteinMeasurementValue_l:
            data.labRenalSettingCareDetails[index]
              ?.admissionProteinMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.admissionProteinMeasurement === 1
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurementValue
                : ""
              : "",

              admissionProteinMeasurementValue_gl:
              data.labRenalSettingCareDetails[index]
                ?.admissionProteinMeasurementValue !== null
                ? (data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurement === 2 && data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===Values.value4)
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionProteinMeasurementValue
                  : ""
                : "",
              
          admissionProteinMeasurementValue_ml:
            data.labRenalSettingCareDetails[index]
              ?.admissionProteinMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.admissionProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?3:2)
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurementValue
                : ""
              : "",
          admissionProteinMeasurementValue_nl:
            data.labRenalSettingCareDetails[index]
              ?.admissionProteinMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.admissionProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid==4?4:3)
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionProteinMeasurementValue
                : ""
              : "",

         

          admissionCreatinineMeasurement:
            data.labRenalSettingCareDetails[index]
              ?.admissionCreatinineMeasurement || "",

          admissionCreatinineMeasurementValue_l:
            data.labRenalSettingCareDetails[index]
              ?.admissionCreatinineMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.admissionCreatinineMeasurement === 1
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurementValue
                : ""
              : "",
          admissionCreatinineMeasurementValue_ml:
            data.labRenalSettingCareDetails[index]
              ?.admissionCreatinineMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.admissionCreatinineMeasurement === 2
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurementValue
                : ""
              : "",
          admissionCreatinineMeasurementValue_nl:
            data.labRenalSettingCareDetails[index]
              ?.admissionCreatinineMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.admissionCreatinineMeasurement === 3
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurementValue
                : ""
              : "",

              admissionCreatinineMeasurementValue_dl:
              data.labRenalSettingCareDetails[index]
                ?.admissionCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.admissionCreatinineMeasurement === 4
                  ? data.labRenalSettingCareDetails[index]
                      ?.admissionCreatinineMeasurementValue
                  : ""
                : "",

          admissionSettingCareId:
            data.labRenalSettingCareDetails[index]?.admissionSettingCareID ||
            "",
          admissionSettingCareOther:
            data.labRenalSettingCareDetails[index]?.admissionSettingCareOther ||
            "",

          dischargeAssessment:
            data.labRenalSettingCareDetails[index]?.dischargeAssessment || "",
          dischargeAssessmentDate:
            data.labRenalSettingCareDetails[index]?.dischargeAssessmentDate ||
            "",
          dischargeAssessmentDateEstimated:
            data.labRenalSettingCareDetails[index]
              ?.dischargeAssessmentDateEstimated || false,
          dischargeSpecimenType:
            data.labRenalSettingCareDetails[index]?.dischargeSpecimenType || "",
          dischargeMeasurement:
            data.labRenalSettingCareDetails[index]?.dischargeMeasurement || "",

          dischargeMeasurementValue_l:
            data.labRenalSettingCareDetails[index]?.dischargeMeasurementValue !=
            null
              ? data.labRenalSettingCareDetails[index]?.dischargeMeasurement ===
                1
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeMeasurementValue
                : ""
              : "",
          dischargeMeasurementValue_ml:
            data.labRenalSettingCareDetails[index]?.dischargeMeasurementValue !=
            null
              ? data.labRenalSettingCareDetails[index]?.dischargeMeasurement ===
                2
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeMeasurementValue
                : ""
              : "",
          dischargeMeasurementValue_nl:
            data.labRenalSettingCareDetails[index]?.dischargeMeasurementValue !=
            null
              ? data.labRenalSettingCareDetails[index]?.dischargeMeasurement ===
                3
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeMeasurementValue
                : ""
              : "",


              dischargeMeasurementValue_dl:
              data.labRenalSettingCareDetails[index]?.dischargeMeasurementValue !=
              null
                ? data.labRenalSettingCareDetails[index]?.dischargeMeasurement ===
                  4
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeMeasurementValue
                  : ""
                : "",

          dischargeProteinMeasurement:
            data.labRenalSettingCareDetails[index]
              ?.dischargeProteinMeasurement || "",

          dischargeProteinMeasurementValue_l:
            data.labRenalSettingCareDetails[index]
              ?.dischargeProteinMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.dischargeProteinMeasurement === 1
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurementValue
                : ""
              : "",

              dischargeProteinMeasurementValue_gl:
              data.labRenalSettingCareDetails[index]
                ?.dischargeProteinMeasurementValue !== null
                ? (data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurement === 2 && data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===Values.value4)
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeProteinMeasurementValue
                  : ""
                : "",

          dischargeProteinMeasurementValue_ml:
            data.labRenalSettingCareDetails[index]
              ?.dischargeProteinMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.dischargeProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?3:2)
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurementValue
                : ""
              : "",
          dischargeProteinMeasurementValue_nl:
            data.labRenalSettingCareDetails[index]
              ?.dischargeProteinMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.dischargeProteinMeasurement === (data.labrenalsettingcaretypes[index]?.labrenalsettingcaretypeid===4?4:3)
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeProteinMeasurementValue
                : ""
              : "",

              // dischargeProteinMeasurementValue_dl:
              // data.labRenalSettingCareDetails[index]
              //   ?.dischargeProteinMeasurementValue !== null
              //   ? data.labRenalSettingCareDetails[index]
              //       ?.dischargeProteinMeasurement === 5
              //     ? data.labRenalSettingCareDetails[index]
              //         ?.dischargeProteinMeasurementValue
              //     : ""
              //   : "",

          dischargeCreatinineMeasurement:
            data.labRenalSettingCareDetails[index]
              ?.dischargeCreatinineMeasurement || "",

          dischargeCreatinineMeasurementValue_l:
            data.labRenalSettingCareDetails[index]
              ?.dischargeCreatinineMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.dischargeCreatinineMeasurement === 1
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurementValue
                : ""
              : "",
          dischargeCreatinineMeasurementValue_ml:
            data.labRenalSettingCareDetails[index]
              ?.dischargeCreatinineMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.dischargeCreatinineMeasurement === 2
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurementValue
                : ""
              : "",
          dischargeCreatinineMeasurementValue_nl:
            data.labRenalSettingCareDetails[index]
              ?.dischargeCreatinineMeasurementValue !== null
              ? data.labRenalSettingCareDetails[index]
                  ?.dischargeCreatinineMeasurement === 3
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurementValue
                : ""
              : "",

              dischargeCreatinineMeasurementValue_dl:
              data.labRenalSettingCareDetails[index]
                ?.dischargeCreatinineMeasurementValue !== null
                ? data.labRenalSettingCareDetails[index]
                    ?.dischargeCreatinineMeasurement === 4
                  ? data.labRenalSettingCareDetails[index]
                      ?.dischargeCreatinineMeasurementValue
                  : ""
                : "",

          dischargeSettingCareId:
            data.labRenalSettingCareDetails[index]?.dischargeSettingCareID ||
            "",
          dischargeSettingCareOther:
            data.labRenalSettingCareDetails[index]?.dischargeSettingCareOther ||
            "",

          q33AdmissionassessmentEmpty: false,
          q33AdmissionspecimenEmpty: false,
          q33AdmissionSettingCareEmpty: false,
          q33AdmissionSettingCareOtherEmpty: false,
          q33AdmissionmeasurementEmpty: false,
          q33AdmissionassessmentDateEmptyError: false,
          q33AdmissionassessmentDateInvalid: false,
          q33AdmissionAssessmentDateUnkEmpty: false,
          q33AdmissionmeasurementCreatinineEmpty: false,
          q33AdmissionmeasurementCystatinEmpty: false,
          q33AdmissionmeasurementUrineEmpty: false,
          q33AdmissionmeasurementUCreatinineEmpty: false,
          q33AdmissionmeasurementCreatinineInvalid: false,
          q33AdmissionmeasurementCystatinInvalid: false,
          q33AdmissionmeasurementUrineInvalid: false,
          q33AdmissionmeasurementUCreatinineInvalid: false,
          q33DischargeassessmentEmpty: false,
          q33DischargespecimenEmpty: false,
          q33DischargeSettingCareEmpty: false,
          q33DischargeSettingCareOtherEmpty: false,
          q33DischargemeasurementEmpty: false,
          q33DischargeassessmentDateEmptyError: false,
          q33DischargeassessmentDateInvalid: false,
          q33DischargeAssessmentDateUnkEmpty: false,
          q33DischargemeasurementCreatinineEmpty: false,
          q33DischargemeasurementCystatinEmpty: false,
          q33DischargemeasurementUrineEmpty: false,
          q33DischargemeasurementUCreatinineEmpty: false,
          q33DischargemeasurementCreatinineInvalid: false,
          q33DischargemeasurementCystatinInvalid: false,
          q33DischargemeasurementUrineInvalid: false,
          q33DischargemeasurementUCreatinineInvalid: false,
        }))
        .sort(
          (a, b) => a.labRenalSettingCareTypeId - b.labRenalSettingCareTypeId
        )
    );
    //#endregion


  };

  const validateConcentrationUnits = (
    value,
    unit,
    LitreMinRange,
    litreMaxRange
  ) => {
    let validrange;
    //const minL = 0, maxL = 60000; // Allowed range in Litres

    let volumeInLitres;
    let litreMaxRanges = litreMaxRange;
    volumeInLitres = value;
    // if (unit === "L" || unit === "nl") {
    //   volumeInLitres = value; // No conversion needed
    // } else
    if (unit === "mL") {
      // volumeInLitres = value ; // Convert to Litres
      litreMaxRanges = litreMaxRanges / 1000;
    }

    if (volumeInLitres >= LitreMinRange && volumeInLitres <= litreMaxRanges) {
      validrange = false;
    } else validrange = true;

    return validrange;
  };

  const validateMassConcentrationUnits = (value, unit, MinRange, MaxRange) => {
    let validrange;

    let volumeInGrams;
    let gramsMaxRanges = MaxRange;
    volumeInGrams = value;
    // if (unit === "L" || unit === "mL") {
    //   volumeInGrams = value; // No conversion needed
    // } else
    if (unit === "dl") {
      //  volumeInGrams = value / 10; // Convert to dL
      gramsMaxRanges = gramsMaxRanges / 10;
    }

    if (volumeInGrams >= MinRange && volumeInGrams <= gramsMaxRanges) {
      validrange = false;
    } else validrange = true;

    return validrange;
  };




// Convert µmol/L → mg/dL
const umolToMgDl = (umolValue) => {
  const conversionFactor = 0.011312; // (Molar Mass / 10,000), M = 113.12 g/mol
  return umolValue * conversionFactor;
};

// Validate if user input falls in serum creatinine range (mg/dL)
const validateCreatinineMgDl = (umolValue, minRange , maxRange ) => {
  
  let validrange;
  const mgDlValue = umolToMgDl(umolValue); //user value umol - mg/dL
  maxRange = umolToMgDl(900); //max value umol 900 to mg/dL
  // return {
  //   isValid: mgDlValue >= minRange && mgDlValue <= maxRange,
  // };

  if (mgDlValue >= minRange && mgDlValue <= maxRange) {
    validrange = false;
  } else validrange = true;

  return validrange;
};



  const validateMassUnits = (value, unit, MinRange, MaxRange) => {
    
    let validrange;

    let volumeInGrams;

    //if (unit === "g") {
    volumeInGrams = value; // No conversion needed  
    if (unit === "L") {
      // volumeInGrams = value * 1000; // Convert to mg/L
      MaxRange = MaxRange * 1000;
    } else if (unit === "dL") {
      //  volumeInGrams = value * 100; // Convert to dL
      MaxRange = MaxRange * 100;
    }

    else if (unit === "mg"){ //--g/dL
      MaxRange = 10;
    }

    if (volumeInGrams >= MinRange && volumeInGrams <= MaxRange) {
      validrange = false;
    } else validrange = true;

    return validrange;
  };


  const validateMeasurement = (
    labDetails,
    qarray,
    index,
    maxLimit,
    questionno,
    isValidValue
  ) => {
    let isValid = isValidValue;

    //#region  Q32
    if (questionno === "Q32") {
      if (labDetails.renalbiomarker === 1) {
        const measurementValue =
          labDetails.creatinine_measurement === 1
            ? labDetails.creatinine_measurement_value_l
            : labDetails.creatinine_measurement === 2
            ? labDetails.creatinine_measurement_value_ml
            : labDetails.creatinine_measurement === 3
            ? labDetails.creatinine_measurement_value_nl
            : labDetails.creatinine_measurement_value_dl;
        const unit =
          labDetails.creatinine_measurement === 1
            ? "L"
            :labDetails.creatinine_measurement === 4
            ? "dl"
            : labDetails.creatinine_measurement === 3
            ? "nl"
            : "mL";

            if(labDetails.creatinine_measurement === 4)
            {
                qarray[index].q32measurementCreatinineInvalid = validateCreatinineMgDl(
                  measurementValue,
                  0,
                  900
                );

                if (qarray[index].q32measurementCreatinineInvalid) {
                  isValid = false;
                }
            }

            else if(labDetails.creatinine_measurement != 4){
        qarray[index].q32measurementCreatinineInvalid =
          validateConcentrationUnits(measurementValue, unit, 0, maxLimit);
        if (qarray[index].q32measurementCreatinineInvalid) {
          isValid = false;
        }
      }
      } else if (labDetails.renalbiomarker === 2) {
        const measurementValue =
          labDetails.cystatin_measurement === 1
            ? labDetails.cystatin_measurement_value_l
            : labDetails.cystatin_measurement === 2
            ? labDetails.cystatin_measurement_value_ml
            : labDetails.cystatin_measurement_value_nl;
        const unit =
          labDetails.cystatin_measurement === 1
            ? "L"
            : labDetails.cystatin_measurement === 2
            ? "dl"
            : "mL";
        qarray[index].q32measurementCystatinInvalid =
          validateMassConcentrationUnits(measurementValue, unit, 0, maxLimit);
        if (qarray[index].q32measurementCystatinInvalid) {
          isValid = false;
        }
      } else {
        const measurementValue =
          labDetails.urineprotein_measurement === 1
            ? labDetails.urineprotein_measurement_value_l
            : labDetails.urineprotein_measurement === 2
            ? labDetails.urineprotein_measurement_value_gl
            : labDetails.urineprotein_measurement === 3
            ? labDetails.urineprotein_measurement_value_ml
            : labDetails.urineprotein_measurement_value_nl;
        const unit =
          labDetails.urineprotein_measurement === 1
            ? "g"
            : labDetails.urineprotein_measurement === 2
            ? "mg"
            : labDetails.urineprotein_measurement === 3
            ? "L"
            : "dL";
        qarray[index].q32measurementUrineInvalid = validateMassUnits(
          measurementValue,
          unit,
          0,
          maxLimit
        );
        if (qarray[index].q32measurementUrineInvalid) {
          isValid = false;
        }

        const measurementCreatinineValue =
          labDetails.urinecreatinine_measurement === 1
            ? labDetails.urinecreatinine_measurement_value_l
            : labDetails.urinecreatinine_measurement === 2
            ? labDetails.urinecreatinine_measurement_value_ml
            : labDetails.urinecreatinine_measurement === 3
            ? labDetails.urinecreatinine_measurement_value_nl
            : labDetails.urinecreatinine_measurement_value_dl;
        const cunit =
          labDetails.urinecreatinine_measurement === 1
            ? "L"
            : labDetails.urinecreatinine_measurement === 4
            ? "dl"
            : labDetails.urinecreatinine_measurement === 3
            ? "nl"
            : "mL";

        //For Urine Creatinine
        //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
        let molecularurinecreatinine = 900;

        if(labDetails.urinecreatinine_measurement === 4){
            qarray[index].q32measurementUCreatinineInvalid = validateCreatinineMgDl(
              measurementCreatinineValue,
              0,
              molecularurinecreatinine);
              if (qarray[index].q32measurementUCreatinineInvalid) {
                isValid = false;
              }
        }
        else if(labDetails.urinecreatinine_measurement != 4){
        qarray[index].q32measurementUCreatinineInvalid =
          validateConcentrationUnits(
            measurementCreatinineValue,
            cunit,
            0,
            molecularurinecreatinine
          );
        if (qarray[index].q32measurementUCreatinineInvalid) {
          isValid = false;
        }
      }
      }
    }
    //#endregion
 
    //#region  Q33
    if (questionno === "Q33") {
      if (labDetails.labRenalSettingCareTypeId === 1) {
        const AmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurement === 2
            ? labDetails.admissionMeasurementValue_ml
            :  labDetails.admissionMeasurement === 3
            ? labDetails.admissionMeasurementValue_nl
            :labDetails.admissionMeasurementValue_dl;
        const Aunit =
          labDetails.admissionMeasurement === 1
            ? "L"
            : labDetails.admissionMeasurement === 4
            ? "dl"
            : labDetails.admissionMeasurement === 3
            ? "nl"
            : "mL";
        if (Q33AdmissionHideColumn === true && labDetails.admissionMeasurement != 4) {
          qarray[index].q33AdmissionmeasurementCreatinineInvalid =
            validateConcentrationUnits(AmeasurementValue, Aunit, 0, maxLimit);

          if (qarray[index].q33AdmissionmeasurementCreatinineInvalid) {
            isValid = false;
          }
        }

        if (Q33AdmissionHideColumn === true && labDetails.admissionMeasurement == 4) {
          qarray[index].q33AdmissionmeasurementCreatinineInvalid =
            validateCreatinineMgDl(AmeasurementValue, 0, 900);

          if (qarray[index].q33AdmissionmeasurementCreatinineInvalid) {
            isValid = false;
          }
        }


        const DmeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurement === 2
            ? labDetails.dischargeMeasurementValue_ml
            : labDetails.dischargeMeasurement === 3
            ? labDetails.dischargeMeasurementValue_nl
            : labDetails.dischargeMeasurementValue_dl;
        const Dunit =
          labDetails.dischargeMeasurement === 1
            ? "L"
            : labDetails.dischargeMeasurement === 3
            ? "nl"
            : "mL";

        if (Q33DischargeHideColumn === true && labDetails.dischargeMeasurement != 4) {
          qarray[index].q33DischargemeasurementCreatinineInvalid =
            validateConcentrationUnits(DmeasurementValue, Dunit, 0, maxLimit);

          if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
            isValid = false;
          }
        }

        if (Q33DischargeHideColumn === true && labDetails.dischargeMeasurement == 4) {
          qarray[index].q33DischargemeasurementCreatinineInvalid =
            validateCreatinineMgDl(DmeasurementValue, 0, 900);

          if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
            isValid = false;
          }
        }

      } else if (labDetails.labRenalSettingCareTypeId === 2) {
        const AmeasurementValue =
          labDetails.admissionMeasurement === 1
            ? labDetails.admissionMeasurementValue_l
            : labDetails.admissionMeasurement === 2
            ? labDetails.admissionMeasurementValue_ml
            : labDetails.admissionMeasurement === 3
            ? labDetails.admissionMeasurementValue_nl
            : labDetails.admissionMeasurementValue_dl;
        const Aunit =
          labDetails.admissionMeasurement === 1
            ? "L"
            : labDetails.admissionMeasurement === 2
            ? "dl"
            : "mL";
        if (Q33AdmissionHideColumn === true) {
          qarray[index].q33AdmissionmeasurementCystatinInvalid =
            validateMassConcentrationUnits(
              AmeasurementValue,
              Aunit,
              0,
              maxLimit
            );
          if (qarray[index].q33AdmissionmeasurementCystatinInvalid) {
            isValid = false;
          }
        }

        const DmeasurementValue =
          labDetails.dischargeMeasurement === 1
            ? labDetails.dischargeMeasurementValue_l
            : labDetails.dischargeMeasurement === 2
            ? labDetails.dischargeMeasurementValue_ml
            : labDetails.dischargeMeasurement === 3
            ? labDetails.dischargeMeasurementValue_nl
            : labDetails.dischargeMeasurementValue_dl;
        const Dunit =
          labDetails.dischargeMeasurement === 1
            ? "L"
            : labDetails.dischargeMeasurement === 2
            ? "dl"
            : "mL";
        if (Q33DischargeHideColumn === true) {
          qarray[index].q33DischargemeasurementCystatinInvalid =
            validateMassConcentrationUnits(
              DmeasurementValue,
              Dunit,
              0,
              maxLimit
            );
          if (qarray[index].q33AdmissionmeasurementCystatinInvalid) {
            isValid = false;
          }
        }
      } 
//       else {
//         const AmeasurementValue =
//           labDetails.admissionProteinMeasurement === 1
//             ? labDetails.admissionProteinMeasurementValue_l
//             : labDetails.admissionProteinMeasurement === 2
//             ? labDetails.admissionProteinMeasurementValue_ml
//             : labDetails.admissionProteinMeasurement === 3
//             ? labDetails.admissionProteinMeasurementValue_nl
//            : labDetails.admissionProteinMeasurementValue_dl
//           ;


// const Aunit = "";
//     if(labDetails.label == "Urine protein"){
//        Aunit =
//         labDetails.admissionProteinMeasurement === 1
//           ? "g"
//           : labDetails.admissionProteinMeasurement === 2
//           ? "L"
//           : "dL";
//         }
    
//     if(labDetails.label == "Urine albumin"){
//          Aunit =
//           labDetails.admissionProteinMeasurement === 1
//             ? "g"
//             : labDetails.admissionProteinMeasurement === 2?
//             "mg"
//             : labDetails.admissionProteinMeasurement === 3
//             ? "L"
//             : "dL";
//           }
   
//         if (Q33AdmissionHideColumn === true &&  labDetails.admissionProteinMeasurement != "" && labDetails.admissionProteinMeasurement != 4 && labDetails.admissionProteinMeasurement != 5 && labDetails.admissionProteinMeasurement != 6 && labDetails.admissionProteinMeasurement != 7) {
//           qarray[index].q33AdmissionmeasurementUrineInvalid = validateMassUnits(
//             AmeasurementValue,
//             Aunit,
//             0,
//             maxLimit
//           );
//           if (qarray[index].q33AdmissionmeasurementUrineInvalid) {
//             isValid = false;
//           }
//         }

//         const DmeasurementValue =
//           labDetails.dischargeProteinMeasurement === 1
//             ? labDetails.dischargeProteinMeasurementValue_l
//             : labDetails.dischargeProteinMeasurement === 2
//             ? labDetails.dischargeProteinMeasurementValue_gl
//             : labDetails.dischargeProteinMeasurement === 3
//             ? labDetails.dischargeProteinMeasurementValue_ml
//             : labDetails.dischargeProteinMeasurement === 4
//             ? labDetails.dischargeProteinMeasurementValue_dl
//             : labDetails.dischargeProteinMeasurementValue_nl;
//         const Dunit =
//           labDetails.dischargeProteinMeasurement === 1
//             ? "g"
//             : labDetails.dischargeProteinMeasurement === 2
//             ? "L"
//             : "dL";
//         if (Q33DischargeHideColumn === true &&  labDetails.admissionProteinMeasurement != "" && labDetails.admissionProteinMeasurement != 4 && labDetails.admissionProteinMeasurement != 5 && labDetails.admissionProteinMeasurement != 6 && labDetails.admissionProteinMeasurement != 7) {
//           qarray[index].q33DischargemeasurementUrineInvalid = validateMassUnits(
//             DmeasurementValue,
//             Dunit,
//             0,
//             maxLimit
//           );
//           if (qarray[index].q33DischargemeasurementUrineInvalid) {
//             isValid = false;
//           }
//         }

//         const AmeasurementCreatinineValue =
//           labDetails.admissionCreatinineMeasurement === 1
//             ? labDetails.admissionCreatinineMeasurementValue_l
//             : labDetails.admissionCreatinineMeasurement === 2
//             ? labDetails.admissionCreatinineMeasurementValue_ml
//             : labDetails.admissionCreatinineMeasurement === 3
//             ? labDetails.admissionCreatinineMeasurementValue_nl
//             : labDetails.admissionCreatinineMeasurementValue_dl;
//         const Acunit =
//           labDetails.admissionCreatinineMeasurement === 1
//             ? "L"
//             : labDetails.admissionCreatinineMeasurement === 3
//             ? "nl"
//             : "mL";
//         if (Q33AdmissionHideColumn === true) {
//           //For Urine Creatinine
//           //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
//           let molecularurinecreatinine =900;
//           if(labDetails.admissionCreatinineMeasurement === 4){
//             qarray[index].q33AdmissionmeasurementUCreatinineInvalid = validateCreatinineMgDl(
//               AmeasurementCreatinineValue,
//               0,
//               molecularurinecreatinine
//             );
//             if (qarray[index].q33AdmissionmeasurementUCreatinineInvalid) {
//               isValid = false;
//             }
//           }

//           else if( labDetails.admissionCreatinineMeasurement != 4){
//           qarray[index
//           ].q33AdmissionmeasurementUCreatinineInvalid =
//             validateConcentrationUnits(
//               AmeasurementCreatinineValue,
//               Acunit,
//               0,
//               molecularurinecreatinine
//             );
//           if (qarray[index].q33AdmissionmeasurementUCreatinineInvalid) {
//             isValid = false;
//           }
//         }
//         }

//         const DmeasurementCreatinineValue =
//           labDetails.dischargeCreatinineMeasurement === 1
//             ? labDetails.dischargeCreatinineMeasurementValue_l
//             : labDetails.dischargeCreatinineMeasurement === 2
//             ? labDetails.dischargeCreatinineMeasurementValue_ml
//             : labDetails.dischargeCreatinineMeasurement === 3
//             ? labDetails.dischargeCreatinineMeasurementValue_nl
//             : labDetails.dischargeCreatinineMeasurementValue_dl;
//         const Dcunit =
//           labDetails.dischargeCreatinineMeasurement === 1
//             ? "L"
//             : labDetails.dischargeCreatinineMeasurement === 3
//             ? "nl"
//             : "mL";
//         if (Q33DischargeHideColumn === true && labDetails.dischargeCreatinineMeasurement != 4) {
//           //For Urine Creatinine
//           //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
//           let molecularurinecreatinine =900;
//           qarray[index].q33DischargemeasurementCreatinineInvalid =
//             validateConcentrationUnits(
//               DmeasurementCreatinineValue,
//               Dcunit,
//               0,
//               molecularurinecreatinine
//             );
//           if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
//             isValid = false;
//           }
//         }

//         if (Q33DischargeHideColumn === true && labDetails.dischargeCreatinineMeasurement == 4) {
//           //For Urine Creatinine
//           //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
//           let molecularurinecreatinine =900;
//           qarray[index].q33DischargemeasurementCreatinineInvalid =
//             validateCreatinineMgDl(
//               DmeasurementCreatinineValue,
//               0,
//               molecularurinecreatinine
//             );
//           if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
//             isValid = false;
//           }
//         }

//         // if (Q33DischargeHideColumn === true) {
//         //   const molecularWeightCreatinine = 113.12; // g/mol
//         //   const minRange = 0.5;  // mg/dL (example)
//         //   const maxRange = 3.0;  // mg/dL (example)
        
//         //   qarray[index].q33DischargemeasurementCreatinineInvalid =
//         //     validateConcentrationUnitsUmol(
//         //       DmeasurementCreatinineValue,   // user-entered value
//         //       Dcunit,                        // "umol/L" or "mg/dL"
//         //     0,
//         //       molecularWeightCreatinine
//         //     );
        
//         //   if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
//         //     isValid = false;
//         //   }
//         // }

//       }

else {
  let AmeasurementValue = "";
  let Aunit = "";

  // ✅ Admission section
  if (labDetails.label === "Urine protein") {
    AmeasurementValue =
      labDetails.admissionProteinMeasurement === 1
        ? labDetails.admissionProteinMeasurementValue_l
        : labDetails.admissionProteinMeasurement === 2
        ? labDetails.admissionProteinMeasurementValue_ml
        : labDetails.admissionProteinMeasurementValue_nl

    Aunit =
      labDetails.admissionProteinMeasurement === 1
        ? "g"
        : labDetails.admissionProteinMeasurement === 2
        ? "L"
        : labDetails.admissionProteinMeasurement === 3
        ? "dL"
        : "";
  }

  if (labDetails.label === "Urine albumin") {
    AmeasurementValue =
      labDetails.admissionProteinMeasurement === 1
        ? labDetails.admissionProteinMeasurementValue_l
        : labDetails.admissionProteinMeasurement === 2
        ? labDetails.admissionProteinMeasurementValue_gl
        : labDetails.admissionProteinMeasurement === 3
        ? labDetails.admissionProteinMeasurementValue_ml
        : labDetails.admissionProteinMeasurementValue_nl;

    Aunit =
      labDetails.admissionProteinMeasurement === 1
        ? "g"
        : labDetails.admissionProteinMeasurement === 2
        ? "mg"
        : labDetails.admissionProteinMeasurement === 3
        ? "L"
        : "dL";
  }

  if (
    Q33AdmissionHideColumn === true &&
    labDetails.admissionProteinMeasurement !== "" && labDetails.label === "Urine protein" &&
    ![4, 5, 6, 7].includes(labDetails.admissionProteinMeasurement)
  ) {
    qarray[index].q33AdmissionmeasurementUrineInvalid = validateMassUnits(
      AmeasurementValue,
      Aunit,
      0,
      maxLimit
    );
    if (qarray[index].q33AdmissionmeasurementUrineInvalid) {
      isValid = false;
    }
  }


  if (
    Q33AdmissionHideColumn === true &&
    labDetails.admissionProteinMeasurement !== "" && labDetails.label === "Urine albumin" &&
    ![5].includes(labDetails.admissionProteinMeasurement)
  ) {
    qarray[index].q33AdmissionmeasurementUrineInvalid = validateMassUnits(
      AmeasurementValue,
      Aunit,
      0,
      maxLimit
    );
    if (qarray[index].q33AdmissionmeasurementUrineInvalid) {
      isValid = false;
    }
  }


  // ✅ Discharge section
  let DmeasurementValue = "";
  let Dunit = "";

  if (labDetails.label === "Urine protein") {
    DmeasurementValue =
      labDetails.dischargeProteinMeasurement === 1
        ? labDetails.dischargeProteinMeasurementValue_l
        : labDetails.dischargeProteinMeasurement === 2
        ? labDetails.dischargeProteinMeasurementValue_ml
        :labDetails.dischargeProteinMeasurementValue_nl

    Dunit =
      labDetails.dischargeProteinMeasurement === 1
        ? "g"
        : labDetails.dischargeProteinMeasurement === 2
        ? "L"
        : "dL";
  }

  if (labDetails.label === "Urine albumin") {
    DmeasurementValue =
      labDetails.dischargeProteinMeasurement === 1
        ? labDetails.dischargeProteinMeasurementValue_l
        : labDetails.dischargeProteinMeasurement === 2
        ? labDetails.dischargeProteinMeasurementValue_gl
        : labDetails.dischargeProteinMeasurement === 3
        ? labDetails.dischargeProteinMeasurementValue_ml
        : labDetails.dischargeProteinMeasurementValue_nl;

    Dunit =
      labDetails.dischargeProteinMeasurement === 1
        ? "g"
        : labDetails.dischargeProteinMeasurement === 2
        ? "mg"
        : labDetails.dischargeProteinMeasurement === 3
        ? "L"
        : "dL";
  }

  if (
    Q33DischargeHideColumn === true &&
    labDetails.dischargeProteinMeasurement !== "" && labDetails.label === "Urine protein" &&
    ![4, 5, 6, 7].includes(labDetails.dischargeProteinMeasurement)
  ) {
    qarray[index].q33DischargemeasurementUrineInvalid = validateMassUnits(
      DmeasurementValue,
      Dunit,
      0,
      maxLimit
    );
    if (qarray[index].q33DischargemeasurementUrineInvalid) {
      isValid = false;
    }
  }


  if (
    Q33DischargeHideColumn === true &&
    labDetails.dischargeProteinMeasurement !== "" && labDetails.label === "Urine albumin" &&
    ![5].includes(labDetails.dischargeProteinMeasurement)
  ) {
    qarray[index].q33DischargemeasurementUrineInvalid = validateMassUnits(
      DmeasurementValue,
      Dunit,
      0,
      maxLimit
    );
    if (qarray[index].q33DischargemeasurementUrineInvalid) {
      isValid = false;
    }
  }


          const AmeasurementCreatinineValue =
          labDetails.admissionCreatinineMeasurement === 1
            ? labDetails.admissionCreatinineMeasurementValue_l
            : labDetails.admissionCreatinineMeasurement === 2
            ? labDetails.admissionCreatinineMeasurementValue_ml
            : labDetails.admissionCreatinineMeasurement === 3
            ? labDetails.admissionCreatinineMeasurementValue_nl
            : labDetails.admissionCreatinineMeasurementValue_dl;
        const Acunit =
          labDetails.admissionCreatinineMeasurement === 1
            ? "L"
            : labDetails.admissionCreatinineMeasurement === 3
            ? "nl"
            : "mL";
        if (Q33AdmissionHideColumn === true) {
          //For Urine Creatinine
          //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
          let molecularurinecreatinine =900;
          if(labDetails.admissionCreatinineMeasurement === 4){
            qarray[index].q33AdmissionmeasurementUCreatinineInvalid = validateCreatinineMgDl(
              AmeasurementCreatinineValue,
              0,
              molecularurinecreatinine
            );
            if (qarray[index].q33AdmissionmeasurementUCreatinineInvalid) {
              isValid = false;
            }
          }

          else if( labDetails.admissionCreatinineMeasurement != 4){
          qarray[index
          ].q33AdmissionmeasurementUCreatinineInvalid =
            validateConcentrationUnits(
              AmeasurementCreatinineValue,
              Acunit,
              0,
              molecularurinecreatinine
            );
          if (qarray[index].q33AdmissionmeasurementUCreatinineInvalid) {
            isValid = false;
          }
        }
        }

        const DmeasurementCreatinineValue =
          labDetails.dischargeCreatinineMeasurement === 1
            ? labDetails.dischargeCreatinineMeasurementValue_l
            : labDetails.dischargeCreatinineMeasurement === 2
            ? labDetails.dischargeCreatinineMeasurementValue_ml
            : labDetails.dischargeCreatinineMeasurement === 3
            ? labDetails.dischargeCreatinineMeasurementValue_nl
            : labDetails.dischargeCreatinineMeasurementValue_dl;
        const Dcunit =
          labDetails.dischargeCreatinineMeasurement === 1
            ? "L"
            : labDetails.dischargeCreatinineMeasurement === 3
            ? "nl"
            : "mL";
        if (Q33DischargeHideColumn === true && labDetails.dischargeCreatinineMeasurement != 4) {
          //For Urine Creatinine
          //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
          let molecularurinecreatinine =900;
          qarray[index].q33DischargemeasurementCreatinineInvalid =
            validateConcentrationUnits(
              DmeasurementCreatinineValue,
              Dcunit,
              0,
              molecularurinecreatinine
            );
          if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
            isValid = false;
          }
        }

        if (Q33DischargeHideColumn === true && labDetails.dischargeCreatinineMeasurement == 4) {
          //For Urine Creatinine
          //formula µmol/L = (g/L × 1,000,000) ÷ Molar Mass(113.12)
          let molecularurinecreatinine =900;
          qarray[index].q33DischargemeasurementCreatinineInvalid =
            validateCreatinineMgDl(
              DmeasurementCreatinineValue,
              0,
              molecularurinecreatinine
            );
          if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
            isValid = false;
          }
        }

        // if (Q33DischargeHideColumn === true) {
        //   const molecularWeightCreatinine = 113.12; // g/mol
        //   const minRange = 0.5;  // mg/dL (example)
        //   const maxRange = 3.0;  // mg/dL (example)
        
        //   qarray[index].q33DischargemeasurementCreatinineInvalid =
        //     validateConcentrationUnitsUmol(
        //       DmeasurementCreatinineValue,   // user-entered value
        //       Dcunit,                        // "umol/L" or "mg/dL"
        //     0,
        //       molecularWeightCreatinine
        //     );
        
        //   if (qarray[index].q33DischargemeasurementCreatinineInvalid) {
        //     isValid = false;
        //   }
        // }

}









    }
    //#endregion


    return isValid;
  };

  const Validate = () => {

    let isValid = true;
    let isQ32Valid = true;
    let isQ34Valid = true;
    let isQ33Valid = true;



    isQ32Valid = ValidateQ32();
    isQ34Valid = ValidateQ34();
    isQ33Valid = ValidateQ33();


    if (
      isQ32Valid &&
      isQ34Valid &&
      isQ33Valid 
    )
      isValid = true;
    else isValid = false;

    return isValid;
  };



  const ValidateQ32 = () => {
    let isValid = true;
    let q32array = [...labrenalassessmentDetails];
    for (let i = 0; i < labrenalassessmentDetails.length; i++) {
      if (labrenalassessmentDetails[i].renalbiomarker !== Values.value5) {
        if (labrenalassessmentDetails[i].renalbiomarker === "") {
          q32array[i].q32biomarkerEmpty = true;
          isValid = false;
        }

        if (
          labrenalassessmentDetails[i].renalspecimen === "" &&
          labrenalassessmentDetails[i].renalbiomarker !== 3 &&
          labrenalassessmentDetails[i].renalbiomarker !== 4
        ) {
          q32array[i].q32specimenEmpty = true;
          isValid = false;
        }

        if (labrenalassessmentDetails[i].renalstartAssessment === "") {
          q32array[i].q32assessmentEmpty = true;
          isValid = false;
        }
        if (
          labrenalassessmentDetails[i].creatinine_measurement === "" &&
          labrenalassessmentDetails[i].cystatin_measurement === "" &&
          labrenalassessmentDetails[i].urineprotein_measurement === "" &&
          labrenalassessmentDetails[i].urinecreatinine_measurement === ""
        ) {
          q32array[i].q32measurementEmpty = true;
          isValid = false;
        } else if (
          labrenalassessmentDetails[i].renalbiomarker === 1 &&
          labrenalassessmentDetails[i].creatinine_measurement === ""
        ) {
          q32array[i].q32measurementEmpty = true;
          isValid = false;
        } else if (
          labrenalassessmentDetails[i].renalbiomarker === 2 &&
          labrenalassessmentDetails[i].cystatin_measurement === ""
        ) {
          q32array[i].q32measurementEmpty = true;
          isValid = false;
        }
        if (
          labrenalassessmentDetails[i].renalbiomarker === 3 &&
          (labrenalassessmentDetails[i].urineprotein_measurement === "" ||
            labrenalassessmentDetails[i].urinecreatinine_measurement === "")
        ) {
          q32array[i].q32measurementEmpty = true;
          isValid = false;
        }

        if (
          labrenalassessmentDetails[i].renalbiomarker === 4 &&
          (labrenalassessmentDetails[i].urinecreatinine_measurement === "" ||
            labrenalassessmentDetails[i].urinecreatinine_measurement === "")
        ) {
          q32array[i].q32measurementEmpty = true;
          isValid = false;
        }

        if (
          labrenalassessmentDetails[i].renalstartAssessment ===
            Values.value99 &&
          labrenalassessmentDetails[i].renalstartAssessmentUnkLTLKT === ""
        ) {
          q32array[i].q32AssessmentDateUnkEmpty = true;
          isValid = false;
        }

        // const isAssessmentDateBefore =
        //   dates.oneYr_pretransplant_start &&
        //   IsDateBefore(
        //     labrenalassessmentDetails[i].renalstartAssessment_dt,
        //     dates.oneYr_pretransplant_start
        //   );
        // const isAssessmentDateAfter =
        //   dates.oneYr_pretransplant_end &&
        //   IsDateAfter(
        //     labrenalassessmentDetails[i].renalstartAssessment_dt,
        //     dates.oneYr_pretransplant_end
        //   );

        // const isTransplantDateBefore =
        //   dates.transplant_dischargeDt &&
        //   IsDateBefore(
        //     labrenalassessmentDetails[i].renalstartAssessment_dt,
        //     dates.transplant_dischargeDt
        //   );
        // const isTransplantDateAfter =
        //   dates.endofFollowUpDate &&
        //   IsDateAfter(
        //     labrenalassessmentDetails[i].renalstartAssessment_dt,
        //     dates.endofFollowUpDate
        //   );

        //SYJ - changes for -> https://edotpulse.com/EditActionItem/AG-M-226
        const assessmentDate =
          labrenalassessmentDetails[i].renalstartAssessment_dt;

        if (assessmentDate === "Invalid Date") {
          q32array[i].q32assessmentDateInvalid = true;
        } else {
         

          const validationRange =
            indexMinus456days && 
            dates.endofFollowUpDate &&
            assessmentDate &&
            DateValid(indexMinus456days,assessmentDate) &&
            DateValid(assessmentDate, dates.endofFollowUpDate);

          if (
            validationRange !== null && validationRange !== undefined && validationRange !== "" &&
           !validationRange) {
            q32array[i].q32assessmentDateInvalid = true;
          } else {
            q32array[i].q32assessmentDateInvalid = false;
          }
        }



        // if (
        //   labrenalassessmentDetails[i].renalstartAssessment_dt ===
        //   "Invalid Date"
        // ) {
        //   q32array[i].q32assessmentDateInvalid = true;
        // } else if (isAssessmentDateBefore || isAssessmentDateAfter) {
        //   q32array[i].q32assessmentDateInvalid = true;
        // } else if (isTransplantDateBefore || isTransplantDateAfter) {
        //   q32array[i].q32assessmentDateInvalid = true;
        // } else {
        //   q32array[i].q32assessmentDateInvalid = false;
        // }

        q32array[i].q32measurementCreatinineEmpty =
          labrenalassessmentDetails[i].creatinine_measurement !== "" &&
          labrenalassessmentDetails[i].creatinine_measurement !== 99 &&
          labrenalassessmentDetails[i].creatinine_measurement_value_l === "" &&
          labrenalassessmentDetails[i].creatinine_measurement_value_ml === "" &&
          labrenalassessmentDetails[i].creatinine_measurement_value_nl === "" &&
          labrenalassessmentDetails[i].creatinine_measurement_value_dl === ""
            ? true
            : false;
        q32array[i].q32measurementCystatinEmpty =
          labrenalassessmentDetails[i].cystatin_measurement !== "" &&
          labrenalassessmentDetails[i].cystatin_measurement !== 99 &&
          labrenalassessmentDetails[i].cystatin_measurement_value_l === "" &&
          labrenalassessmentDetails[i].cystatin_measurement_value_ml === "" &&
          labrenalassessmentDetails[i].cystatin_measurement_value_nl === ""
            ? true
            : false;
        q32array[i].q32measurementUrineEmpty =
          labrenalassessmentDetails[i].urineprotein_measurement !== "" &&
          labrenalassessmentDetails[i].urineprotein_measurement !== 99 &&
          labrenalassessmentDetails[i].urineprotein_measurement !== 4 &&
          labrenalassessmentDetails[i].urineprotein_measurement !== 5 &&
          labrenalassessmentDetails[i].urineprotein_measurement !== 6 &&
          labrenalassessmentDetails[i].urineprotein_measurement_value_l ===
            "" &&
          // labassessmentDetails[i].hemoglobin_measurement_value_gl === "" &&
          labrenalassessmentDetails[i].urineprotein_measurement_value_ml ===
            "" &&
          labrenalassessmentDetails[i].urineprotein_measurement_value_nl === ""
            ? true
            : false;

    if(labrenalassessmentDetails[i].renalbiomarker ===4 ){
            q32array[i].q32measurementUrineEmpty =
         
            labrenalassessmentDetails[i].urineprotein_measurement !== "" &&
            labrenalassessmentDetails[i].urineprotein_measurement !== 99 &&
            labrenalassessmentDetails[i].urineprotein_measurement_value_l ===
              "" &&
              labrenalassessmentDetails[i].urineprotein_measurement_value_gl === "" && 
            labrenalassessmentDetails[i].urineprotein_measurement_value_ml ===
              "" &&
            labrenalassessmentDetails[i].urineprotein_measurement_value_nl === ""
              ? true
              : false;

    }


        q32array[i].q32measurementUCreatinineEmpty =
          labrenalassessmentDetails[i].urinecreatinine_measurement !== "" &&
          labrenalassessmentDetails[i].urinecreatinine_measurement !== 99 &&
          labrenalassessmentDetails[i].urinecreatinine_measurement_value_l ===
            "" &&
          labrenalassessmentDetails[i].urinecreatinine_measurement_value_ml ===
            "" &&
          labrenalassessmentDetails[i].urinecreatinine_measurement_value_nl ===
            "" && 
          labrenalassessmentDetails[i].urinecreatinine_measurement_value_dl === ""
            ? true
            : false;
        q32array[i].q32assessmentDateEmptyError =
          labrenalassessmentDetails[i].renalstartAssessment === Values.value1 &&
          labrenalassessmentDetails[i].renalstartAssessment_dt === ""
            ? true
            : false;

        if (
          q32array[i].q32measurementCreatinineEmpty ||
          q32array[i].q32measurementCystatinEmpty ||
          q32array[i].q32measurementUrineEmpty ||
          q32array[i].q32measurementUCreatinineEmpty ||
          q32array[i].q32assessmentDateEmptyError ||
          q32array[i].q32assessmentDateInvalid
        ) {
          isValid = false;
        }

        switch (labrenalassessmentDetails[i].renalbiomarker) {
          case 1:
            isValid = validateMeasurement(
              labrenalassessmentDetails[i],
              q32array,
              i,
              900,
              "Q32",
              isValid
            );
            break;
          case 2:
            isValid = validateMeasurement(
              labrenalassessmentDetails[i],
              q32array,
              i,
              7.5,
              "Q32",
              isValid
            );
            break;
          case 3:
            isValid = validateMeasurement(
              labrenalassessmentDetails[i],
              q32array,
              i,
              170,
              "Q32",
              isValid
            );
            break;
          case 4:
            isValid = validateMeasurement(
              labrenalassessmentDetails[i],
              q32array,
              i,
              100,
              "Q32",
              isValid
            );
            break;
        }
      }
    }

    setlabrenalassessmentDetails(q32array);

    return isValid;
  };

  const ValidateQ34 = () => {
    let isValid = true;

    let q34array = [...labchronicDetails];
    for (let i = 0; i < labchronicDetails.length; i++) {
      if (
        labchronicDetails[i].ckdAssessment !== Values.value1 &&
        labchronicDetails[i].ckdAssessment !== Values.value2
      ) {
        if (labchronicDetails[i].ckdstage === "") {
          q34array[i].q34StageEmpty = true;
          isValid = false;
        }
        //else if (
        //  labchronicDetails[i].ckdstage === Values.value5 &&
        //  labchronicDetails[i].ckdkidneyfailure === ""
        //) {
        //  q34array[i].q34StageEmpty = true;
        //  isValid = false;
        //}

        if (labchronicDetails[i].ckdAssessment === "") {
          q34array[i].q34assessmentEmpty = true;
          isValid = false;
        }

        if (
          labchronicDetails[i].ckdAssessment === Values.value99 &&
          (labchronicDetails[i].ckdAssessmentUnkLTLKT === "" ||labchronicDetails[i].ckdAssessmentUnkLTLKT === undefined)
        ) {
          q34array[i].q34AssessmentDateUnkEmpty = true;
          isValid = false;
        }

        const isAssessmentDateBefore =
          dates.oneYr_pretransplant_start &&
          IsDateBefore(
            labchronicDetails[i].ckdAssessment_dt,
            dates.oneYr_pretransplant_start
          );
        const isAssessmentDateAfter =
          dates.endofFollowUpDate &&
          IsDateAfter(
            labchronicDetails[i].ckdAssessment_dt,
            dates.endofFollowUpDate
          );

        if (labchronicDetails[i].ckdAssessment_dt === "Invalid Date") {
          q34array[i].q34assessmentDateInvalid = true;
        } else if (isAssessmentDateBefore || isAssessmentDateAfter) {
          q34array[i].q34assessmentDateInvalid = true;
        } else {
          q34array[i].q34assessmentDateInvalid = false;
        }

        q34array[i].q34assessmentDateEmptyError =
          labchronicDetails[i].ckdAssessment === Values.value3 &&
          labchronicDetails[i].ckdAssessment_dt === ""
            ? true
            : false;

        if (
          q34array[i].q34assessmentDateEmptyError ||
          q34array[i].q34assessmentDateInvalid
        ) {
          isValid = false;
        }
      }
    }

    setlabchronicDetails(q34array);

    return isValid;
  };



  const ValidateQ33 = () => {
    
    let isValid = true;

    let q33array = [...renalSettingCareData];
    for (let i = 0; i < renalSettingCareData.length; i++) {
      if (
        renalSettingCareData[i].admissionSpecimenType === "" &&
        renalSettingCareData[i].admissionAssessment !== 2 &&
        Q33AdmissionHideColumn === true &&
        renalSettingCareData[i].labRenalSettingCareTypeId !== 3 &&
        renalSettingCareData[i].labRenalSettingCareTypeId !== 4
      ) {
        q33array[i].q33AdmissionspecimenEmpty = true;
        isValid = false;
      }

      if (
        renalSettingCareData[i].dischargeSpecimenType === "" &&
        Q33DischargeHideColumn === true &&
        renalSettingCareData[i].dischargeAssessment !== 2 &&
        renalSettingCareData[i].labRenalSettingCareTypeId !== 3 &&
        renalSettingCareData[i].labRenalSettingCareTypeId !== 4
      ) {
        q33array[i].q33DischargespecimenEmpty = true;
        isValid = false;
      }

      if (
        renalSettingCareData[i].admissionSettingCareId === "" &&
        renalSettingCareData[i].admissionAssessment !== 2 &&
        Q33AdmissionHideColumn === true
      ) {
        q33array[i].q33AdmissionSettingCareEmpty = true;
        isValid = false;
      }

      if (
        renalSettingCareData[i].dischargeSettingCareId === "" &&
        renalSettingCareData[i].dischargeAssessment !== 2 &&
        Q33DischargeHideColumn === true
      ) {
        q33array[i].q33DischargeSettingCareEmpty = true;
        isValid = false;
      }

      if (
        renalSettingCareData[i].admissionAssessment === "" &&
        Q33AdmissionHideColumn === true
      ) {
        q33array[i].q33AdmissionassessmentEmpty = true;
        isValid = false;
      }
      if (
        renalSettingCareData[i].dischargeAssessment === "" &&
        Q33DischargeHideColumn === true
      ) {
        q33array[i].q33DischargeassessmentEmpty = true;
        isValid = false;
      }

      if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 1 &&
        Q33AdmissionHideColumn === true &&
        renalSettingCareData[i].admissionMeasurement === "" &&
        renalSettingCareData[i].admissionAssessment !== 2
      ) {
        q33array[i].q33AdmissionmeasurementEmpty = true;
        isValid = false;
      } else if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 2 &&
        Q33AdmissionHideColumn === true &&
        renalSettingCareData[i].admissionMeasurement === "" &&
        renalSettingCareData[i].admissionAssessment !== 2
      ) {
        q33array[i].q33AdmissionmeasurementEmpty = true;
        isValid = false;
      } else if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 3 &&
        Q33AdmissionHideColumn === true &&
        (renalSettingCareData[i].admissionProteinMeasurement === "" ||
          renalSettingCareData[i].admissionCreatinineMeasurement === "") &&
        renalSettingCareData[i].admissionAssessment !== 2
      ) {
        q33array[i].q33AdmissionmeasurementEmpty = true;
        isValid = false;
      } else if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 4 &&
        Q33AdmissionHideColumn === true &&
        (renalSettingCareData[i].admissionProteinMeasurement === "" ||
          renalSettingCareData[i].admissionCreatinineMeasurement === "") &&
        renalSettingCareData[i].admissionAssessment !== 2
      ) {
        q33array[i].q33AdmissionmeasurementEmpty = true;
        isValid = false;
      }

      if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 1 &&
        Q33DischargeHideColumn === true &&
        renalSettingCareData[i].dischargeMeasurement === "" &&
        renalSettingCareData[i].dischargeAssessment !== 2
      ) {
        q33array[i].q33DischargemeasurementEmpty = true;
        isValid = false;
      } else if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 2 &&
        Q33DischargeHideColumn === true &&
        renalSettingCareData[i].dischargeMeasurement === "" &&
        renalSettingCareData[i].dischargeAssessment !== 2
      ) {
        q33array[i].q33DischargemeasurementEmpty = true;
        isValid = false;
      } else if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 3 &&
        Q33DischargeHideColumn === true &&
        (renalSettingCareData[i].dischargeProteinMeasurement === "" ||
          renalSettingCareData[i].dischargeCreatinineMeasurement === "") &&
        renalSettingCareData[i].dischargeAssessment !== 2
      ) {
        q33array[i].q33DischargemeasurementEmpty = true;
        isValid = false;
      } else if (
        renalSettingCareData[i].labRenalSettingCareTypeId === 4 &&
        Q33DischargeHideColumn === true &&
        (renalSettingCareData[i].dischargeProteinMeasurement === "" ||
          renalSettingCareData[i].dischargeCreatinineMeasurement === "") &&
        renalSettingCareData[i].dischargeAssessment !== 2
      ) {
        q33array[i].q33DischargemeasurementEmpty = true;
        isValid = false;
      }

      if (renalSettingCareData[i].admissionAssessmentDate === "Invalid Date") {
        q33array[i].q33AdmissionassessmentDateInvalid = true;
      } else {
        q33array[i].q33AdmissionassessmentDateInvalid = false;
      }

      if (renalSettingCareData[i].dischargeAssessmentDate === "Invalid Date") {
        q33array[i].q33DischargeassessmentDateInvalid = true;
      } else {
        q33array[i].q33DischargeassessmentDateInvalid = false;
      }

      q33array[i].q33AdmissionmeasurementCreatinineEmpty =
        renalSettingCareData[i].labRenalSettingCareTypeId === 1 &&
        renalSettingCareData[i].admissionMeasurement !== "" &&
        renalSettingCareData[i].admissionMeasurement !== 5 &&
        renalSettingCareData[i].admissionMeasurementValue_l === "" &&
        renalSettingCareData[i].admissionMeasurementValue_ml === "" &&
        renalSettingCareData[i].admissionMeasurementValue_nl === "" &&
        renalSettingCareData[i].admissionMeasurementValue_dl === ""
          ? true
          : false;
      q33array[i].q33AdmissionmeasurementCystatinEmpty =
        renalSettingCareData[i].labRenalSettingCareTypeId === 2 &&
        renalSettingCareData[i].admissionMeasurement !== "" &&
        renalSettingCareData[i].admissionMeasurement !== 4 &&
        renalSettingCareData[i].admissionMeasurementValue_l === "" &&
        renalSettingCareData[i].admissionMeasurementValue_ml === "" &&
        renalSettingCareData[i].admissionMeasurementValue_nl === "" &&
        renalSettingCareData[i].admissionMeasurementValue_dl === ""
        
          ? true
          : false;
          
   if( q33array[i].label == "Urine protein"){
      q33array[i].q33AdmissionmeasurementUrineEmpty =
        renalSettingCareData[i].admissionProteinMeasurement !== "" &&
        renalSettingCareData[i].admissionProteinMeasurement !== 6 &&
        renalSettingCareData[i].admissionProteinMeasurement !== 4 &&
        renalSettingCareData[i].admissionProteinMeasurement !== 5 &&
        renalSettingCareData[i].admissionProteinMeasurement !== 7 &&
        renalSettingCareData[i].admissionProteinMeasurementValue_l === "" &&
        renalSettingCareData[i].admissionProteinMeasurementValue_ml === "" &&
        renalSettingCareData[i].admissionProteinMeasurementValue_nl === "" 
          ? true
          : false;
    }

    if( q33array[i].label == "Urine albumin"){
      q33array[i].q33AdmissionmeasurementUrineEmpty =
        renalSettingCareData[i].admissionProteinMeasurement !== "" &&
        renalSettingCareData[i].admissionProteinMeasurement !== 5 &&
        renalSettingCareData[i].admissionProteinMeasurementValue_l === "" &&
        renalSettingCareData[i].admissionProteinMeasurementValue_ml === "" &&
        renalSettingCareData[i].admissionProteinMeasurementValue_nl === "" &&
        renalSettingCareData[i].admissionProteinMeasurementValue_gl === ""
          ? true
          : false;
    }

      q33array[i].q33AdmissionmeasurementUCreatinineEmpty =
        renalSettingCareData[i].admissionCreatinineMeasurement !== "" &&
        renalSettingCareData[i].admissionCreatinineMeasurement !== 5 &&
        renalSettingCareData[i].admissionCreatinineMeasurementValue_l === "" &&
        renalSettingCareData[i].admissionCreatinineMeasurementValue_ml === "" &&
        renalSettingCareData[i].admissionCreatinineMeasurementValue_nl === "" &&
        renalSettingCareData[i].admissionCreatinineMeasurementValue_dl === ""
          ? true
          : false;
      q33array[i].q33AdmissionassessmentDateEmptyError =
        renalSettingCareData[i].admissionAssessment === Values.value1 &&
        renalSettingCareData[i].admissionAssessmentDate === ""
          ? true
          : false;

      q33array[i].q33AdmissionSettingCareOtherEmpty =
        renalSettingCareData[i].admissionSettingCareId !== "" &&
        renalSettingCareData[i].admissionSettingCareId === 5 &&
        renalSettingCareData[i].admissionSettingCareOther === ""
          ? true
          : false;

      if (
        q33array[i].q33AdmissionmeasurementCreatinineEmpty ||
        q33array[i].q33AdmissionmeasurementCystatinEmpty ||
        q33array[i].q33AdmissionmeasurementUrineEmpty ||
        q33array[i].q33AdmissionmeasurementUCreatinineInvalid ||
        q33array[i].q33AdmissionassessmentDateEmptyError ||
        q33array[i].q33AdmissionassessmentDateInvalid ||
        q33array[i].q33AdmissionSettingCareOtherEmpty
      ) {
        isValid = false;
      }

      q33array[i].q33DischargemeasurementCreatinineEmpty =
        renalSettingCareData[i].labRenalSettingCareTypeId === 1 &&
        renalSettingCareData[i].dischargeMeasurement !== "" &&
        renalSettingCareData[i].dischargeMeasurement !== 5 &&
        renalSettingCareData[i].dischargeMeasurementValue_l === "" &&
        renalSettingCareData[i].dischargeMeasurementValue_ml === "" &&
        renalSettingCareData[i].dischargeMeasurementValue_nl === "" &&
        renalSettingCareData[i].dischargeMeasurementValue_dl === ""
          ? true
          : false;
      q33array[i].q33DischargemeasurementCystatinEmpty =
        renalSettingCareData[i].labRenalSettingCareTypeId === 2 &&
        renalSettingCareData[i].dischargeMeasurement !== "" &&
        renalSettingCareData[i].dischargeMeasurement !== 4 &&
        renalSettingCareData[i].dischargeMeasurementValue_l === "" &&
        renalSettingCareData[i].dischargeMeasurementValue_ml === "" &&
        renalSettingCareData[i].dischargeMeasurementValue_nl === "" &&
        renalSettingCareData[i].dischargeMeasurementValue_dl === ""
          ? true
          : false;

          if( q33array[i].label == "Urine protein"){
      q33array[i].q33DischargemeasurementUrineEmpty =
        renalSettingCareData[i].dischargeProteinMeasurement !== "" &&
        renalSettingCareData[i].dischargeProteinMeasurement !== 6 &&
        renalSettingCareData[i].dischargeProteinMeasurement !== 4 &&
        renalSettingCareData[i].dischargeProteinMeasurement !== 5 &&
        renalSettingCareData[i].dischargeProteinMeasurement !== 7 &&
        renalSettingCareData[i].dischargeProteinMeasurementValue_l === "" &&
        renalSettingCareData[i].dischargeProteinMeasurementValue_ml === "" &&
        renalSettingCareData[i].dischargeProteinMeasurementValue_nl === "" && 
        renalSettingCareData[i].dischargeProteinMeasurementValue_dl === ""
          ? true
          : false;
          }

          if( q33array[i].label == "Urine albumin"){
            q33array[i].q33DischargemeasurementUrineEmpty =
              renalSettingCareData[i].dischargeProteinMeasurement !== "" &&
              renalSettingCareData[i].dischargeProteinMeasurement !== 5 &&
              renalSettingCareData[i].dischargeProteinMeasurementValue_l === "" &&
              renalSettingCareData[i].dischargeProteinMeasurementValue_ml === "" &&
              renalSettingCareData[i].dischargeProteinMeasurementValue_nl === "" && 
              renalSettingCareData[i].dischargeProteinMeasurementValue_gl === ""
                ? true
                : false;
                }



      q33array[i].q33DischargemeasurementUCreatinineEmpty =
        renalSettingCareData[i].dischargeCreatinineMeasurement !== "" &&
        renalSettingCareData[i].dischargeCreatinineMeasurement !== 5 &&
        renalSettingCareData[i].dischargeCreatinineMeasurementValue_l === "" &&
        renalSettingCareData[i].dischargeCreatinineMeasurementValue_ml === "" &&
        renalSettingCareData[i].dischargeCreatinineMeasurementValue_nl === "" &&
        renalSettingCareData[i].dischargeCreatinineMeasurementValue_dl === ""
          ? true
          : false;
      q33array[i].q33DischargeassessmentDateEmptyError =
        renalSettingCareData[i].dischargeAssessment === Values.value1 &&
        renalSettingCareData[i].dischargeAssessmentDate === ""
          ? true
          : false;

      q33array[i].q33DischargeSettingCareOtherEmpty =
        renalSettingCareData[i].dischargeSettingCareId !== "" &&
        renalSettingCareData[i].dischargeSettingCareId === 5 &&
        renalSettingCareData[i].dischargeSettingCareOther === ""
          ? true
          : false;

      if (
        q33array[i].q33DischargemeasurementCreatinineEmpty ||
        q33array[i].q33DischargemeasurementCystatinEmpty ||
        q33array[i].q33DischargemeasurementUrineEmpty ||
        q33array[i].q33DischargemeasurementUCreatinineEmpty ||
        q33array[i].q33DischargeassessmentDateEmptyError ||
        q33array[i].q33DischargeassessmentDateInvalid ||
        q33array[i].q33DischargeSettingCareOtherEmpty
      ) {
        isValid = false;
      }

      switch (renalSettingCareData[i].labRenalSettingCareTypeId) {
        case 1:
          isValid = validateMeasurement(
            renalSettingCareData[i],
            q33array,
            i,
            900,
            "Q33",
            isValid
          );
          break;
        case 2:
          isValid = validateMeasurement(
            renalSettingCareData[i],
            q33array,
            i,
            7.5,
            "Q33",
            isValid
          );
          break;
        case 3:
          isValid = validateMeasurement(
            renalSettingCareData[i],
            q33array,
            i,
            170,
            "Q33",
            isValid
          );
          break;
        case 4:
          isValid = validateMeasurement(
            renalSettingCareData[i],
            q33array,
            i,
            100,
            "Q33",
            isValid
          );
          break;
      }
    }

    setrenalSettingCareData(q33array);

    return isValid;
  };

 

  const handleNumericInputKeyDown = (e) => {
    // Allow backspace, arrow keys, delete, and tab
    if (
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }

    // Prevent non-numeric characters, except '.' (and only allow one decimal point)
    if (
      !/[0-9.]/.test(e.key) ||
      (e.key === "." && e.target.value.includes("."))
    ) {
      e.preventDefault();
      return;
    }

    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const newValue =
      value.slice(0, selectionStart) +
      e.key +
      value.slice(e.target.selectionEnd);

    // Prevent '.' as the first character
    if (e.key === "." && value === "") {
      e.preventDefault();
      return;
    }

    // Allow only two digits after the decimal point
    if (newValue.includes(".") && newValue.split(".")[1].length > 1) {
      e.preventDefault();
    }
  };

  const handleNumericInputKeyDownUpto3 = (e) => {
    // Allow backspace, arrow keys, delete, and tab
    if (
      ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)
    ) {
      return;
    }
  
    // Prevent non-numeric characters, except '.' (and only allow one decimal point)
    if (
      !/[0-9.]/.test(e.key) ||
      (e.key === "." && e.target.value.includes("."))
    ) {
      e.preventDefault();
      return;
    }
  
    const value = e.target.value;
    const selectionStart = e.target.selectionStart;
    const newValue =
      value.slice(0, selectionStart) +
      e.key +
      value.slice(e.target.selectionEnd);
  
    // Prevent '.' as the first character
    if (e.key === "." && value === "") {
      e.preventDefault();
      return;
    }
  
    // ✅ Allow only three digits after the decimal point
    if (newValue.includes(".") && newValue.split(".")[1].length > 3) {
      e.preventDefault();
    }
  };
  

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.RenalLabAssessment} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() =>
                toggleSidebar(isSideMenuActive, setisSideMenuActive)
              }
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>RENAL LAB ASSESSMENTS</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}

              <div className="survey-question-section" >
                <div className="survey-question-content survey-content-box grey-bg">
                  <div className="question-answer grid-overflow">
               

                    {/* here 1*/}
                    <div
                      className="block-border block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div>
                        <div className="question">
                          <span className="question-weight">Q32.</span>
                          <span className="quest-text-pad question-weight">
                            Please report renal function assessments{" "}
                            within an <u>outpatient care setting</u> in the following manner:
                            <ul className="unoredered-list-question">
                              <li>
                              The closest records to 12 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexMinus365days}</span>, 9 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexMinus273days}</span>, 6 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexMinus182days}</span>, and 3 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexMinus91days}</span> <i>prior to the index date</i>
                                </li>
                                <li>
                                The closest records to 3 months <span  style={{ color: PageDesignConstants.fontColor }}>{three_month_stabilization}</span>, 6 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexPlus182days}</span>, 9 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexPlus273days}</span>, 12 months <span  style={{ color: PageDesignConstants.fontColor }}>{indexPlus365days}</span>, and 15 months <span  style={{ color: PageDesignConstants.fontColor }}>{twelve_month_post_stabilization}</span> <i>after the index date</i>
                                </li>
                                <li>
                                Every 6-month timepoint thereafter until the end of follow-up (e.g., closest to <span  style={{ color: PageDesignConstants.fontColor }}>{eighteen_month_post_stabilization}</span>, <span  style={{ color: PageDesignConstants.fontColor }}>{twentyfour_month_post_stabilization}</span>, etc. until <span  style={{ color: PageDesignConstants.fontColor }}>{endofFollowUpDate}</span>)
                                </li>
                            </ul>

                            Add additional rows for each occurrence of each
                            assessment, as needed.
                            <br />
                            <br />
                            <b>Please Note:</b> if a urine protein or urine
                            albumin assessment is reported, urine creatinine{" "}
                            <u>from the same sample</u> will also be requested
                            to calculate the concentration of protein or albumin
                            per urine creatinine.
                            <br />
                          </span>
                        </div>
                        <br></br>
                      </div>
                      <div style={{height:"500px",overflowY:"auto"}}>
                      {labrenalassessmentDetails &&
                        labrenalassessmentDetails.length > 0 &&
                        labrenalassessmentDetails.map((data, idx) => (
                          <div className="loop-section-ul">
                            <div className="loop-head">
                              <span className="question-weight">
                                {GetOrdinal(idx + 1)} Renal Assessment
                              </span>
                              {idx !== 0 && (
                                <div className="delete-btn-div">
                                  <img
                                    width="16px"
                                    src="../Assets/images/Icon-material-delete.png"
                                    alt=""
                                    onClick={() =>
                                      deleteRenalAssessmentDetails(idx)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="containertd grid-overflow"
                              colSpan={3}
                            >
                              <table
                                className="borderTable  custom-th-width"
                                style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}

                              >
                                <thead>
                                  <tr>
                                    <th className="table-th-sec">
                                      Biomarker{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th
                                      className="table-th-sec"
                                      style={{
                                        border: "1px solid",
                                        borderColor: "inherit",
                                        padding: "8px",
                                        textAlign: "center",
                                        minWidth: "360px",
                                      }}
                                    >
                                      Date of assessment{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Specimen{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      Measurement{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="modal-popup-table-cell">
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "renalbiomarker-" + idx + "-renal"
                                            }
                                            value={1}
                                            checked={
                                              data.renalbiomarker ===
                                              Values.value1
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />
                                          <span className="">Creatinine</span>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "renalbiomarker-" + idx + "-renal"
                                            }
                                            value={2}
                                            checked={
                                              data.renalbiomarker ===
                                              Values.value2
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />
                                          <span className="">Cystatin C</span>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "renalbiomarker-" + idx + "-renal"
                                            }
                                            value={3}
                                            checked={
                                              data.renalbiomarker ===
                                              Values.value3
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />
                                          <span className="">
                                            Urine protein
                                          </span>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "renalbiomarker-" + idx + "-renal"
                                            }
                                            value={4}
                                            checked={
                                              data.renalbiomarker ===
                                              Values.value4
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />
                                          <span className="">
                                            Urine albumin
                                          </span>
                                        </label>
                                      </div>
                                      {idx === 0 && (
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "renalbiomarker-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={5}
                                              checked={
                                                data.renalbiomarker ===
                                                Values.value5
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span className="">
                                              None of the above assessments
                                              reported
                                            </span>
                                          </label>
                                        </div>
                                      )}

                                      <ErrorField
                                        show={data.q32biomarkerEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />
                                    </td>
                                    {data.renalbiomarker === Values.value5 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "renalstartAssessment-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={1}
                                              checked={
                                                data.renalstartAssessment ===
                                                Values.value1
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <span className="">
                                              <DateControl
                                                optionId={
                                                  "renalstartAssessment_dt"
                                                }
                                                ctrlId={
                                                  "renalstartAssessment_dt-" +
                                                  idx
                                                }
                                                HandleDateChange={
                                                  HandleDateChange
                                                }
                                                date={
                                                  data.renalstartAssessment_dt
                                                }
                                              />
                                            </span>
                                          </label>
                                        </div>
                                        <div className="estimated-date-padding text-margin">
                                          <label>
                                            <input
                                              type="checkbox"
                                              id={idx}
                                              name={
                                                "renalstartAssessment_dt_estimated-" +
                                                idx +
                                                "-renal"
                                              }
                                              checked={
                                                data.renalstartAssessment_dt_estimated
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span className="radio-text-padding">
                                              Estimated Date
                                            </span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "renalstartAssessment-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={99}
                                              checked={
                                                data.renalstartAssessment ===
                                                Values.value99
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span className="">
                                              Date unknown
                                            </span>
                                          </label>
                                          <div style={{ marginLeft: "44px" }}>
                                            {dates?.zero_to12months_before_LT_LKT !==
                                              null &&
                                              dates?.zero_to12months_before_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "renalstartAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-renal"
                                                      }
                                                      value={1}
                                                      checked={
                                                        data.renalstartAssessmentUnkLTLKT ===
                                                        Values.value1
                                                      }
                                                      onChange={
                                                        HandleRenalFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide012HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      0 to 12 months before
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            {dates?.four_to_15months_after_LT_LKT !==
                                              null &&
                                              dates?.four_to_15months_after_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "renalstartAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-renal"
                                                      }
                                                      value={3}
                                                      checked={
                                                        data.renalstartAssessmentUnkLTLKT ===
                                                        Values.value3
                                                      }
                                                      onChange={
                                                        HandleRenalFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide415HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      4 to 15 months after
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            {dates?.sixteen_to_27months_after_LT_LKT !==
                                              null &&
                                              dates?.sixteen_to_27months_after_LT_LKT && (
                                                <div>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={idx}
                                                      name={
                                                        "renalstartAssessmentUnkLTLKT-" +
                                                        idx +
                                                        "-renal"
                                                      }
                                                      value={4}
                                                      checked={
                                                        data.renalstartAssessmentUnkLTLKT ===
                                                        Values.value4
                                                      }
                                                      onChange={
                                                        HandleRenalFieldChange
                                                      }
                                                    />
                                                    <span
                                                      data-tooltip-id="encounterTip"
                                                      className="modal-popup"
                                                      onClick={() =>
                                                        setShowHide1627HyperlinkModal(
                                                          true
                                                        )
                                                      }
                                                    >
                                                      16 to 27 months after
                                                      LT/LKT
                                                    </span>
                                                  </label>
                                                </div>
                                              )}
                                            <div>
                                              <label className="option-fbox">
                                                <input
                                                  type="radio"
                                                  id={idx}
                                                  name={
                                                    "renalstartAssessmentUnkLTLKT-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  value={5}
                                                  checked={
                                                    data.renalstartAssessmentUnkLTLKT ===
                                                    Values.value5
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />
                                                <span className="">
                                                  Date completely unknown
                                                </span>
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                        <ErrorField
                                          show={
                                            data.q32assessmentDateEmptyError
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />

                                        <ErrorField
                                          show={data.q32AssessmentDateUnkEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={data.q32assessmentEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={data.q32assessmentDateInvalid}
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    )}

                                    {data.renalbiomarker === Values.value5 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell">
                                        {data.renalbiomarker !==
                                          Values.value3 &&
                                        data.renalbiomarker !==
                                          Values.value4 ? (
                                          <div className="date-field-padding">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "renalspecimen-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                value={1}
                                                checked={
                                                  data.renalspecimen ===
                                                  Values.value1
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />
                                              <span className="">Blood</span>
                                            </label>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        {data.renalbiomarker !==
                                          Values.value3 &&
                                        data.renalbiomarker !==
                                          Values.value4 ? (
                                          <div className="date-field-padding">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "renalspecimen-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                value={2}
                                                checked={
                                                  data.renalspecimen ===
                                                  Values.value2
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />
                                              <span className="">Plasma</span>
                                            </label>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        {data.renalbiomarker !==
                                          Values.value3 &&
                                        data.renalbiomarker !==
                                          Values.value4 ? (
                                          <div className="date-field-padding">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "renalspecimen-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                value={3}
                                                checked={
                                                  data.renalspecimen ===
                                                  Values.value3
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />
                                              <span className="">Serum</span>
                                            </label>
                                          </div>
                                        ) : (
                                          <></>
                                        )}

                                        {data.renalbiomarker ===
                                          Values.value3 ||
                                        data.renalbiomarker ===
                                          Values.value4 ? (
                                          <div className="date-field-padding">
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "renalspecimen-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                value={4}
                                                checked={
                                                  data.renalspecimen ===
                                                  Values.value4
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />
                                              <span className="">Urine</span>
                                            </label>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        <ErrorField
                                          show={data.q32specimenEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                      </td>
                                    )}

                                    {data.renalbiomarker === Values.value5 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : data.renalbiomarker === Values.value1 ||
                                      data.renalbiomarker === "" ? (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={1}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_l-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value1
                                                      ? data.creatinine_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; µmol/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={2}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_ml-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value2
                                                      ? data.creatinine_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; µmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={3}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_nl-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value3
                                                      ? data.creatinine_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; nmol/mL 
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={4}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value4
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "creatinine_measurement_value_dl-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.creatinine_measurement ===
                                                    Values.value4
                                                      ? data.creatinine_measurement_value_dl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; mg/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>


                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "creatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={99}
                                              checked={
                                                data.creatinine_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q32measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q32measurementCreatinineEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q32measurementCreatinineInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : data.renalbiomarker ===
                                      Values.value2 ? (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "cystatin_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={1}
                                              checked={
                                                data.cystatin_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "cystatin_measurement_value_l-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.cystatin_measurement ===
                                                    Values.value1
                                                      ? data.cystatin_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDownUpto3
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; mg/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "cystatin_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={2}
                                              checked={
                                                data.cystatin_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "cystatin_measurement_value_ml-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.cystatin_measurement ===
                                                    Values.value2
                                                      ? data.cystatin_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDownUpto3
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; mg/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "cystatin_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={3}
                                              checked={
                                                data.cystatin_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "cystatin_measurement_value_nl-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.cystatin_measurement ===
                                                    Values.value3
                                                      ? data.cystatin_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDownUpto3
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; µg/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "cystatin_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={99}
                                              checked={
                                                data.cystatin_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q32measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q32measurementCystatinEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q32measurementCystatinInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    ) : data.renalbiomarker === Values.value3 ||
                                    data.renalbiomarker === "" ?
                                    (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label>
                                            Urine protein {" "}
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={1}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urineprotein_measurement_value_l-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urineprotein_measurement ===
                                                    Values.value1
                                                      ? data.urineprotein_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; g/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={2}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span >
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urineprotein_measurement_value_ml-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urineprotein_measurement ===
                                                    Values.value2
                                                      ? data.urineprotein_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; mg/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={3}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urineprotein_measurement_value_nl-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urineprotein_measurement ===
                                                    Values.value3
                                                      ? data.urineprotein_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; mg/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={4}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value4
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown value, positive 
                                            </span>
                                          </label>
                                        </div>


                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={5}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value5
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown value, trace 
                                            </span>
                                          </label>
                                        </div>



                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={6}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value6
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown value, negative 
                                            </span>
                                          </label>
                                        </div>


                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urineprotein_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={99}
                                              checked={
                                                data.urineprotein_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={data.q32measurementUrineInvalid}
                                          message={CommonError_Msgs.Msg2}
                                        />
                                        <ErrorField
                                          show={data.q32measurementUrineEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <div className="date-field-padding">
                                          <br />
                                          <br />
                                          <br />
                                          <label>
                                            Urine creatinine from same urine
                                            sample
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urinecreatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={1}
                                              checked={
                                                data.urinecreatinine_measurement ===
                                                Values.value1
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urinecreatinine_measurement_value_l-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urinecreatinine_measurement ===
                                                    Values.value1
                                                      ? data.urinecreatinine_measurement_value_l
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; µmol/L
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urinecreatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={2}
                                              checked={
                                                data.urinecreatinine_measurement ===
                                                Values.value2
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urinecreatinine_measurement_value_ml-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urinecreatinine_measurement ===
                                                    Values.value2
                                                      ? data.urinecreatinine_measurement_value_ml
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; µmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urinecreatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={3}
                                              checked={
                                                data.urinecreatinine_measurement ===
                                                Values.value3
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urinecreatinine_measurement_value_nl-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urinecreatinine_measurement ===
                                                    Values.value3
                                                      ? data.urinecreatinine_measurement_value_nl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; nmol/mL
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urinecreatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={4}
                                              checked={
                                                data.urinecreatinine_measurement ===
                                                Values.value4
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />

                                            <div className="option-fbox">
                                              <span>
                                                <input
                                                  className="sub-input-dash"
                                                  id={idx}
                                                  name={
                                                    "urinecreatinine_measurement_value_dl-" +
                                                    idx +
                                                    "-renal"
                                                  }
                                                  type="text"
                                                  value={
                                                    data.urinecreatinine_measurement ===
                                                    Values.value4
                                                      ? data.urinecreatinine_measurement_value_dl
                                                      : ""
                                                  }
                                                  maxLength={8}
                                                  onKeyDown={
                                                    handleNumericInputKeyDown
                                                  }
                                                  onChange={HandleRenalFieldChange}
                                                />{" "}
                                                &nbsp; mg/dL
                                              </span>
                                            </div>
                                          </label>
                                        </div>

                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "urinecreatinine_measurement-" +
                                                idx +
                                                "-renal"
                                              }
                                              value={99}
                                              checked={
                                                data.urinecreatinine_measurement ===
                                                Values.value99
                                              }
                                              onChange={HandleRenalFieldChange}
                                            />
                                            <span
                                              className=""
                                              style={{ textWrap: "nowrap" }}
                                            >
                                              Unknown
                                            </span>
                                          </label>
                                        </div>

                                        <ErrorField
                                          show={data.q32measurementEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />

                                        <ErrorField
                                          show={
                                            data.q32measurementUCreatinineEmpty
                                          }
                                          message={CommonError_Msgs.Msg1}
                                        />
                                        <ErrorField
                                          show={
                                            data.q32measurementUCreatinineInvalid
                                          }
                                          message={CommonError_Msgs.Msg2}
                                        />
                                      </td>
                                    )
                                  : 

                                  // start
                                   data.renalbiomarker === Values.value4 ||
                                  data.renalbiomarker === "" ?
                                  (
                                    <td className="modal-popup-table-cell">
                                      <div className="date-field-padding">
                                        <label>
                                          Urine albumin {" "}
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urineprotein_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={1}
                                            checked={
                                              data.urineprotein_measurement ===
                                              Values.value1
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span>
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urineprotein_measurement_value_l-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urineprotein_measurement ===
                                                  Values.value1
                                                    ? data.urineprotein_measurement_value_l
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; g/L
                                            </span>
                                          </div>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urineprotein_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={2}
                                            checked={
                                              data.urineprotein_measurement ===
                                              Values.value2
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span >
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urineprotein_measurement_value_gl-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urineprotein_measurement ===
                                                  Values.value2
                                                    ? data.urineprotein_measurement_value_gl
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; g/dL
                                            </span>
                                          </div>
                                        </label>
                                      </div>




                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urineprotein_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={3}
                                            checked={
                                              data.urineprotein_measurement ===
                                              Values.value3
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span >
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urineprotein_measurement_value_ml-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urineprotein_measurement ===
                                                  Values.value3
                                                    ? data.urineprotein_measurement_value_ml
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; mg/L
                                            </span>
                                          </div>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urineprotein_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={4}
                                            checked={
                                              data.urineprotein_measurement ===
                                              Values.value4
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span>
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urineprotein_measurement_value_nl-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urineprotein_measurement ===
                                                  Values.value4
                                                    ? data.urineprotein_measurement_value_nl
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; mg/dL
                                            </span>
                                          </div>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urineprotein_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={99}
                                            checked={
                                              data.urineprotein_measurement ===
                                              Values.value99
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />
                                          <span
                                            className=""
                                            style={{ textWrap: "nowrap" }}
                                          >
                                            Unknown
                                          </span>
                                        </label>
                                      </div>
                                      <ErrorField
                                        show={data.q32measurementUrineInvalid}
                                        message={CommonError_Msgs.Msg2}
                                      />
                                      <ErrorField
                                        show={data.q32measurementUrineEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />
                                      <div className="date-field-padding">
                                        <br />
                                        <br />
                                        <br />
                                        <label>
                                          Urine creatinine from same urine
                                          sample
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urinecreatinine_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={1}
                                            checked={
                                              data.urinecreatinine_measurement ===
                                              Values.value1
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span>
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urinecreatinine_measurement_value_l-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urinecreatinine_measurement ===
                                                  Values.value1
                                                    ? data.urinecreatinine_measurement_value_l
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; µmol/L
                                            </span>
                                          </div>
                                        </label>
                                      </div>

                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urinecreatinine_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={2}
                                            checked={
                                              data.urinecreatinine_measurement ===
                                              Values.value2
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span>
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urinecreatinine_measurement_value_ml-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urinecreatinine_measurement ===
                                                  Values.value2
                                                    ? data.urinecreatinine_measurement_value_ml
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; µmol/mL
                                            </span>
                                          </div>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urinecreatinine_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={3}
                                            checked={
                                              data.urinecreatinine_measurement ===
                                              Values.value3
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span>
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urinecreatinine_measurement_value_nl-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urinecreatinine_measurement ===
                                                  Values.value3
                                                    ? data.urinecreatinine_measurement_value_nl
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; nmol/mL
                                            </span>
                                          </div>
                                        </label>
                                      </div>


                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urinecreatinine_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={4}
                                            checked={
                                              data.urinecreatinine_measurement ===
                                              Values.value4
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />

                                          <div className="option-fbox">
                                            <span>
                                              <input
                                                className="sub-input-dash"
                                                id={idx}
                                                name={
                                                  "urinecreatinine_measurement_value_dl-" +
                                                  idx +
                                                  "-renal"
                                                }
                                                type="text"
                                                value={
                                                  data.urinecreatinine_measurement ===
                                                  Values.value4
                                                    ? data.urinecreatinine_measurement_value_dl
                                                    : ""
                                                }
                                                maxLength={8}
                                                onKeyDown={
                                                  handleNumericInputKeyDown
                                                }
                                                onChange={HandleRenalFieldChange}
                                              />{" "}
                                              &nbsp; mg/dL
                                            </span>
                                          </div>
                                        </label>
                                      </div>


                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "urinecreatinine_measurement-" +
                                              idx +
                                              "-renal"
                                            }
                                            value={99}
                                            checked={
                                              data.urinecreatinine_measurement ===
                                              Values.value99
                                            }
                                            onChange={HandleRenalFieldChange}
                                          />
                                          <span
                                            className=""
                                            style={{ textWrap: "nowrap" }}
                                          >
                                            Unknown
                                          </span>
                                        </label>
                                      </div>

                                      <ErrorField
                                        show={data.q32measurementEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />

                                      <ErrorField
                                        show={
                                          data.q32measurementUCreatinineEmpty
                                        }
                                        message={CommonError_Msgs.Msg1}
                                      />
                                      <ErrorField
                                        show={
                                          data.q32measurementUCreatinineInvalid
                                        }
                                        message={CommonError_Msgs.Msg2}
                                      />
                                    </td>
                                  ):
                                  <td
                                  className="containertd"
                                  style={{
                                    textAlign: "center",
                                    borderRight: "0",
                                  }}
                                >
                                  <span
                                    style={{ textAlign: "center" }}
                                    className="not-applicable"
                                  >
                                    <b>Not Applicable</b>
                                  </span>
                                </td>

                                  // end
                                  
                                  }
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))}
</div>
                      {labrenalassessmentDetails &&
                        labrenalassessmentDetails[0].renalbiomarker !==
                          Values.value5 && patientLocked===false && (
                          <div>
                            <div
                              className="answer-list-text"
                              onClick={addrenalassessmentRow}
                            >
                              <a>
                                <img
                                  width="18px"
                                  src="../Assets/images/plus.png"
                                  alt=""
                                />
                              </a>
                              <a className="radio-text-padding">
                                Click to add additional rows for renal function
                                assessments
                              </a>
                            </div>
                          </div>
                        )}
                    </div>
                    {/* here 2 */}

                    <div
                      className="block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <table
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        width="100%"
                      >
                        <tr>
                          <td>
                            {/*  */}

                            {/* Q33 */}
                            <table
                              cellPadding="0"
                              cellSpacing="0"
                              border="1"
                              width="100%"
                              style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}

                            >
                              {/* Question Row */}
                              <tr>
                                <td
                                  className="containertd"
                                  style={{ padding: "10px", textAlign: "left" }}
                                  colSpan="3"
                                >
                                  <div className="question">
                                    <b>Q33.</b>
                                    <span className="quest-text-pad">
                                      Please report the renal function
                                      assessment{" "}
                                      <u>
                                        on or closest to the provided target
                                        date.
                                      </u>
                                    </span>
                                  </div>
                                </td>
                              </tr>

                              {/* Instructions Row */}
                              <tr>
                                <td className="containertd" colSpan="3">
                                  <div className="question">
                                    <span className="quest-text-pad">
                                      <ul>
                                        <li>
                                          Please select assessments from{" "}
                                          <u>any care setting</u> (i.e.,
                                          inpatient, ER, ICU/NICU, outpatient).
                                        </li>
                                      </ul>
                                    </span>
                                  </div>
                                </td>
                              </tr>

                              {/* Important Note Row */}
                              <tr>
                                <td className="containertd" colspan="12">
                                  <div className="question">
                                    <span className="quest-text-pad">
                                      <b>Please note:</b> If a urine protein or
                                      urine albumin assessment is reported,
                                      urine creatinine{" "}
                                      <u>from the same urine sample</u> will
                                      also be requested to calculate the
                                      concentration of protein or albumin per
                                      urine creatinine.
                                    </span>
                                  </div>
                                </td>
                              </tr>

                              {/* Table Header */}

                              <tr>
                                <th
                                  colSpan="2"
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  Target Date
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  Closest to the transplant admission date (
                                  <span className="indigo-text">
                                    {dates.transplant_admissionDt !== null
                                      ? dates.transplant_admissionDt
                                      : "[transplant admission date]"}
                                  </span>
                                  ) to represent lab levels upon admission
                                </th>
                                <th
                                  style={{
                                    border: "1px solid #808080",
                                    padding: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  Closest to the transplant discharge date (
                                  <span className="indigo-text">
                                    {dates.transplant_dischargeDt !== null
                                      ? dates.transplant_dischargeDt
                                      : "[transplant discharge date]"}
                                  </span>
                                  ) to represent lab levels upon discharge
                                </th>
                              </tr>

                              {/* Iterate over each question */}
                              {renalSettingCareData.map((item, idx) => (
                                <React.Fragment key={idx}>
                                  {/* Question Row */}
                                  <tr>
                                    <td
                                      rowSpan="5"
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <b>{item.question}</b> {item.label}
                                    </td>
                                  </tr>

                                  {/* Date of Assessment */}
                                  <tr>
                                    <td
                                      style={{
                                        border: "1px solid  #808080",
                                        padding: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <b>Date of assessment</b>
                                    </td>

                                    {[1, 2].map((index) => {
                                      if (
                                        index === 1
                                          ? Q33AdmissionHideColumn === false
                                          : Q33DischargeHideColumn === false
                                      ) {
                                        return (
                                          <td
                                            className="containertd"
                                            key={`na-${index}`} // Unique key
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            <span
                                              style={{ textAlign: "center" }}
                                            ></span>
                                          </td>
                                        );
                                      }
                                      return (
                                        <td
                                          className="containertd"
                                          key={index}
                                          style={{
                                            border: "1px solid  #808080",
                                            padding: "10px",
                                          }}
                                        >
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-settingcare-${idx}`
                                                    : `dischargeAssessment-${index}-settingcare-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-settingcare-${idx}`
                                                    : `dischargeAssessment-${index}-settingcare-${idx}`
                                                }
                                                value={1}
                                                checked={
                                                  index === Values.value1
                                                    ? item.admissionAssessment ===
                                                      Values.value1
                                                    : item.dischargeAssessment ===
                                                      Values.value1
                                                }
                                                onChange={HandleSettingcareFieldChange}
                                              />

                                              <span className="date-field-padding-left">
                                                <DateControl
                                                  optionId={
                                                    index === 1
                                                      ? "admissionAssessmentDate"
                                                      : "dischargeAssessmentDate"
                                                  }
                                                  ctrlId={
                                                    index === 1
                                                      ? "admissionAssessmentDate-" +
                                                        idx
                                                      : "dischargeAssessmentDate-" +
                                                        idx
                                                  }
                                                  HandleDateChange={
                                                    HandleDateChange
                                                  }
                                                  date={
                                                    index === Values.value1
                                                      ? item.admissionAssessmentDate
                                                      : item.dischargeAssessmentDate
                                                  }
                                                />
                                              </span>
                                            </label>
                                          </div>
                                          <div className="estimated-date-padding text-margin">
                                            <label>
                                              <input
                                                type="checkbox"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessmentDateEstimated-${index}-settingcare-${idx}`
                                                    : `dischargeAssessmentDateEstimated-${index}-settingcare-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessmentDateEstimated-${index}-settingcare-${idx}`
                                                    : `dischargeAssessmentDateEstimated-${index}-settingcare-${idx}`
                                                }
                                                checked={
                                                  index === Values.value1
                                                    ? item.admissionAssessmentDateEstimated
                                                    : item.dischargeAssessmentDateEstimated 
                                                }
                                                onChange={HandleSettingcareFieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                Estimated Date
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-settingcare-${idx}`
                                                    : `dischargeAssessment-${index}-settingcare-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-settingcare-${idx}`
                                                    : `dischargeAssessment-${index}-settingcare-${idx}`
                                                }
                                                value={99}
                                                checked={
                                                  index === Values.value1
                                                    ? item.admissionAssessment ===
                                                      Values.value99
                                                    : item.dischargeAssessment ===
                                                      Values.value99
                                                }
                                                onChange={HandleSettingcareFieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                {" "}
                                                Date unknown
                                              </span>
                                            </label>
                                          </div>
                                          <div>
                                            <label>
                                              <input
                                                type="radio"
                                                id={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-settingcare-${idx}`
                                                    : `dischargeAssessment-${index}-settingcare-${idx}`
                                                }
                                                name={
                                                  index === 1
                                                    ? `admissionAssessment-${index}-settingcare-${idx}`
                                                    : `dischargeAssessment-${index}-settingcare-${idx}`
                                                }
                                                value={2}
                                                checked={
                                                  index === Values.value1
                                                    ? item.admissionAssessment ===
                                                      Values.value2
                                                    : item.dischargeAssessment ===
                                                      Values.value2
                                                }
                                                onChange={HandleSettingcareFieldChange}
                                              />
                                              <span className="radio-text-padding">
                                                {" "}
                                                Not assessed
                                              </span>
                                            </label>
                                          </div>

                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q33AdmissionassessmentDateEmptyError
                                                : item.q33DischargeassessmentDateEmptyError
                                            }
                                            message={CommonError_Msgs.Msg2}
                                          />

                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q33AdmissionAssessmentDateUnkEmpty
                                                : item.q33DischargeAssessmentDateUnkEmpty
                                            }
                                            message={CommonError_Msgs.Msg1}
                                          />

                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q33AdmissionassessmentEmpty
                                                : item.q33DischargeassessmentEmpty
                                            }
                                            message={CommonError_Msgs.Msg1}
                                          />

                                          <ErrorField
                                            show={
                                              index === Values.value1
                                                ? item.q33AdmissionassessmentDateInvalid
                                                : item.q33DischargeassessmentDateInvalid
                                            }
                                            message={CommonError_Msgs.Msg2}
                                          />
                                        </td>
                                      );
                                    })}
                                  </tr>

                                  {/* Setting Care */}
                                  <tr>
                                    <td
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <b>Setting of care</b>
                                    </td>
                                    {Array(2)
                                      .fill(null)
                                      .map((_, colIndex) => {
                                        const notAssesed =
                                          (colIndex === Values.value0 &&
                                            item.admissionAssessment ===
                                              Values.value2) ||
                                          (colIndex === Values.value1 &&
                                            item.dischargeAssessment ===
                                              Values.value2);

                                        const hidecolumn =
                                          colIndex === 0
                                            ? Q33AdmissionHideColumn === false
                                            : Q33DischargeHideColumn === false;
                                        if (notAssesed || hidecolumn) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${colIndex}`} // Unique key
                                              style={{
                                                textAlign: hidecolumn
                                                  ? "center"
                                                  : "left",
                                                borderRight: hidecolumn
                                                  ? ""
                                                  : "1px solid #808080",
                                              }}
                                            >
                                              <span
                                                style={{ textAlign: "center" }}
                                                className="not-applicable"
                                              >
                                                <b>Not Applicable</b>
                                              </span>
                                            </td>
                                          );
                                        }

                                        return (
                                          <td
                                            className="containertd"
                                            key={colIndex}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            {item.settingcare.map(
                                              (type, typeIndex) => (
                                                <div key={typeIndex}>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={
                                                        colIndex === 0
                                                          ? `admissionSettingCareId-${colIndex}-settingcare-${idx}`
                                                          : `dischargeSettingCareId-${colIndex}-settingcare-${idx}`
                                                      }
                                                      name={
                                                        colIndex === 0
                                                          ? `admissionSettingCareId-${colIndex}-settingcare-${idx}`
                                                          : `dischargeSettingCareId-${colIndex}-settingcare-${idx}`
                                                      }
                                                      value={typeIndex + 1}
                                                      checked={
                                                        colIndex ===
                                                        Values.value0
                                                          ? item.admissionSettingCareId ===
                                                            typeIndex + 1
                                                          : item.dischargeSettingCareId ===
                                                            typeIndex + 1
                                                      }
                                                      onChange={
                                                        HandleSettingcareFieldChange
                                                      }
                                                    />

                                                    <span> {type.name}</span>
                                                  </label>
                                                  {type.mdesettingcarevisitid ==
                                                    5 && (
                                                    <div>
                                                      <CustomTextArea
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionSettingCareOther-${colIndex}-settingcare-${idx}-${typeIndex}`
                                                            : `dischargeSettingCareOther-${colIndex}-settingcare-${idx}-${typeIndex}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionSettingCareOther-${colIndex}-settingcare-${idx}-${typeIndex}`
                                                            : `dischargeSettingCareOther-${colIndex}-settingcare-${idx}-${typeIndex}`
                                                        }
                                                        value={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionSettingCareOther
                                                            : item.dischargeSettingCareOther
                                                        }
                                                        onChange={
                                                          HandleSettingcareFieldChange
                                                        }
                                                      />
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            )}

                                            <ErrorField
                                              show={
                                                colIndex === 0
                                                  ? item.q33AdmissionSettingCareEmpty
                                                  : item.q33DischargeSettingCareEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />

                                            <ErrorField
                                              show={
                                                colIndex === 0
                                                  ? item.q33AdmissionSettingCareOtherEmpty
                                                  : item.q33DischargeSettingCareOtherEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                          </td>
                                        );
                                      })}
                                  </tr>

                                  {/* Specimen Type */}
                                  <tr>
                                    <td
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <b>Specimen type</b>
                                    </td>
                                    {Array(2)
                                      .fill(null)
                                      .map((_, colIndex) => {
                                        const notAssesed =
                                          (colIndex === Values.value0 &&
                                            item.admissionAssessment ===
                                              Values.value2) ||
                                          (colIndex === Values.value1 &&
                                            item.dischargeAssessment ===
                                              Values.value2);

                                        const hidecolumn =
                                          colIndex === 0
                                            ? Q33AdmissionHideColumn === false
                                            : Q33DischargeHideColumn === false;
                                        if (notAssesed || hidecolumn) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${colIndex}`} // Unique key
                                              style={{
                                                textAlign: hidecolumn
                                                  ? "center"
                                                  : "left",
                                                borderRight: hidecolumn
                                                  ? ""
                                                  : "1px solid #808080",
                                                borderTop: hidecolumn
                                                  ? ""
                                                  : "1px solid #808080",
                                              }}
                                            >
                                              {notAssesed &&
                                                hidecolumn === false && (
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not Applicable</b>
                                                  </span>
                                                )}
                                            </td>
                                          );
                                        }

                                        return (
                                          <td
                                            className="containertd"
                                            key={colIndex}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            {item.specimenTypes.map(
                                              (type, typeIndex) => (
                                                <div key={typeIndex}>
                                                  <label className="option-fbox">
                                                    {type === "Urine" ? (
                                                      <></>
                                                    ) : (
                                                      <input
                                                        type="radio"
                                                        id={
                                                          colIndex === 0
                                                            ? `admissionSpecimenType-${colIndex}-settingcare-${idx}`
                                                            : `dischargeSpecimenType-${colIndex}-settingcare-${idx}`
                                                        }
                                                        name={
                                                          colIndex === 0
                                                            ? `admissionSpecimenType-${colIndex}-settingcare-${idx}`
                                                            : `dischargeSpecimenType-${colIndex}-settingcare-${idx}`
                                                        }
                                                        value={typeIndex + 1}
                                                        checked={
                                                          colIndex ===
                                                          Values.value0
                                                            ? item.admissionSpecimenType ===
                                                              typeIndex + 1
                                                            : item.dischargeSpecimenType ===
                                                              typeIndex + 1
                                                        }
                                                        onChange={
                                                          HandleSettingcareFieldChange
                                                        }
                                                      />
                                                    )}
                                                    <span> {type}</span>
                                                  </label>
                                                </div>
                                              )
                                            )}

                                            <ErrorField
                                              show={
                                                colIndex === 0
                                                  ? item.q33AdmissionspecimenEmpty
                                                  : item.q33DischargespecimenEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                          </td>
                                        );
                                      })}
                                  </tr>

                                  {/* Measurements */}
                                  <tr>
                                    <td
                                      style={{
                                        border: "1px solid #808080",
                                        padding: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <b>Measurement</b>
                                    </td>
                                    {Array(2)
                                      .fill(null)
                                      .map((_, colIndex) => {
                                        const notAssesed =
                                          (colIndex === Values.value0 &&
                                            item.admissionAssessment ===
                                              Values.value2) ||
                                          (colIndex === Values.value1 &&
                                            item.dischargeAssessment ===
                                              Values.value2);

                                        const hidecolumn =
                                          colIndex === 0
                                            ? Q33AdmissionHideColumn === false
                                            : Q33DischargeHideColumn === false;
                                        if (notAssesed || hidecolumn) {
                                          return (
                                            <td
                                              className="containertd"
                                              key={`na-${colIndex}`} // Unique key
                                              style={{
                                                textAlign: hidecolumn
                                                  ? ""
                                                  : "left",
                                                borderRight: hidecolumn
                                                  ? ""
                                                  : "1px solid #808080",
                                                borderTop: hidecolumn
                                                  ? ""
                                                  : "1px solid #808080",
                                                borderBottom: hidecolumn
                                                  ? "1px solid #808080"
                                                  : "",
                                              }}
                                            >
                                              {notAssesed &&
                                                hidecolumn === false && (
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                    className="not-applicable"
                                                  >
                                                    <b>Not Applicable</b>
                                                  </span>
                                                )}
                                            </td>
                                          );
                                        }

                                        return (
                                          <td
                                            key={colIndex}
                                            style={{
                                              border: "1px solid #808080",
                                              padding: "10px",
                                            }}
                                          >
                                            {item.extraUrineProtein && (
                                              <>
                                                <div>
                                                  <b>
                                                    {item.extraUrineProtein}
                                                  </b>
                                                </div>
                                              </>
                                            )}
                                            {
                                            item.measurements
                                            .filter(
                                              (measurement) => {
                                            //     !(
                                            //       item.question === 
                                            //       "Q33.4." &&
                                            //       item.label === "Urine albumin" &&
                                            //       (measurement === "Unknown value, positive" ||
                                            //       measurement === "Unknown value, trace" ||
                                            //        measurement === "Unknown value, negative")
                                            //     )
                                            // ).
                                            if (
                                              item.question === "Q33.4." &&
                                              item.label === "Urine albumin" &&
                                              (
                                                measurement === "Unknown value, positive" ||
                                                measurement === "Unknown value, trace" ||
                                                measurement === "Unknown value, negative"
                                              )
                                            ) {
                                              return false;
                                            }
                                            // Exclude "g/dL" for Q33.3
                                            if (
                                              item.question === "Q33.3." &&
                                              measurement === "g/dL"
                                            ) {
                                              return false;
                                            }
                                            // Include "g/dL" for Q33.4
                                            return true;
                                          }). 
                                            map(
                                              (measurement, mIndex) => (
                                                <div key={mIndex}>
                                                  <label className="option-fbox">
                                                    <input
                                                      type="radio"
                                                      id={
                                                        colIndex === 0
                                                          ? item.label.includes(
                                                              "Urine"
                                                            )
                                                            ? `admissionProteinMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : `admissionMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          : item.label.includes(
                                                              "Urine"
                                                            )
                                                          ? `dischargeProteinMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          : `dischargeMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          
                                                      }
                                                      name={
                                                        colIndex === 0
                                                          ? item.label.includes(
                                                              "Urine"
                                                            )
                                                            ? `admissionProteinMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : `admissionMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          : item.label.includes(
                                                              "Urine"
                                                            )
                                                          ? `dischargeProteinMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          : `dischargeMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                      }
                                                      value={mIndex + 1}
                                                      checked={
                                                        colIndex ===
                                                        Values.value0
                                                          ? item.label.includes(
                                                              "Urine"
                                                            )
                                                            ? item.admissionProteinMeasurement ===
                                                              mIndex + 1
                                                            : item.admissionMeasurement ===
                                                              mIndex + 1
                                                          : item.label.includes(
                                                              "Urine"
                                                            )
                                                          ? item.dischargeProteinMeasurement ===
                                                            mIndex + 1
                                                          : item.dischargeMeasurement ===
                                                            mIndex + 1
                                                      }
                                                      onChange={
                                                        HandleSettingcareFieldChange
                                                      }
                                                    />

                                                    {measurement === "Unknown" || measurement === "Unknown value, positive" || measurement === "Unknown value, trace" ||
                                                    measurement === "Unknown value, negative"
                                                    ? (
                                                      <></>
                                                    ) : (
                                                      <input
                                                        className="sub-input-dash"
                                                        // id={
                                                        //   colIndex === 0
                                                        //     ? item.label.includes(
                                                        //         "Urine"
                                                        //       )
                                                        //       ? mIndex ===
                                                        //         Values.value0
                                                        //         ? `admissionProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //         : mIndex ===
                                                        //           Values.value1
                                                        //         ? `admissionProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : `admissionProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            
                                                        //       : mIndex ===
                                                        //         Values.value0
                                                        //       ? `admissionMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : mIndex ===
                                                        //         Values.value1
                                                        //       ? `admissionMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //        : mIndex === Values.value2
                                                        //        ? `admissionMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : `admissionMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`

                                                        //     : item.label.includes(
                                                        //         "Urine"
                                                        //       )
                                                        //     ? mIndex ===
                                                        //       Values.value0
                                                        //       ? `dischargeProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : mIndex ===
                                                        //         Values.value1
                                                        //       ? `dischargeProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //        : mIndex === Values.value2
                                                        //       ? `dischargeProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //        : `dischargeProteinMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : mIndex ===
                                                        //       Values.value0
                                                        //     ? `dischargeMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : mIndex ===
                                                        //       Values.value1
                                                        //     ? `dischargeMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //      : mIndex === Values.value2
                                                        //      ? `dischargeMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : `dischargeMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        // }


                                                        id={
                                                          colIndex === 0
                                                            ? item.label.includes("Urine protein")
                                                              ? mIndex === Values.value0
                                                                ? `admissionProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex === Values.value1
                                                                ? `admissionProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine protein → ml
                                                                : `admissionProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : item.label.includes("Urine albumin")
                                                              ? mIndex === Values.value0
                                                                ? `admissionProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex === Values.value1
                                                                ? `admissionProteinMeasurementValue_gl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine albumin → gl
                                                                : mIndex === Values.value2
                                                                ? `admissionProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : `admissionProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`

                                                              : mIndex === Values.value0
                                                              ? `admissionMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value1
                                                              ? `admissionMeasurementValue_gl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value2
                                                              ? `admissionMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : `admissionMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : item.label.includes("Urine protein")
                                                            ? mIndex === Values.value0
                                                              ? `dischargeProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value1
                                                              ? `dischargeProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine protein → ml
                                                              : `dischargeProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : item.label.includes("Urine albumin")
                                                            ? mIndex === Values.value0
                                                              ? `dischargeProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value1
                                                              ? `dischargeProteinMeasurementValue_gl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine albumin → gl
                                                              : mIndex === Values.value2
                                                              ? `dischargeProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : `dischargeProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : mIndex === Values.value0
                                                            ? `dischargeMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : mIndex === Values.value1
                                                            ? `dischargeMeasurementValue_gl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : mIndex === Values.value2
                                                            ? `dischargeMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : `dischargeMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        }

                                                        
                                                        // name={
                                                        //   colIndex === 0
                                                        //     ? item.label.includes(
                                                        //         "Urine"
                                                        //       )
                                                        //       ? mIndex ===
                                                        //         Values.value0
                                                        //         ? `admissionProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //         : mIndex ===
                                                        //           Values.value1
                                                        //         ? `admissionProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //          : mIndex === Values.value2
                                                        //         ? `admissionProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //          : `admissionProteinMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : mIndex ===
                                                        //         Values.value0
                                                        //       ? `admissionMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : mIndex ===
                                                        //         Values.value1
                                                        //       ? `admissionMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //        : mIndex === Values.value2
                                                        //        ? `admissionMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : `admissionMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : item.label.includes(
                                                        //         "Urine"
                                                        //       )
                                                        //     ? mIndex ===
                                                        //       Values.value0
                                                        //       ? `dischargeProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //       : mIndex ===
                                                        //         Values.value1
                                                        //       ? `dischargeProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //        : mIndex === Values.value2
                                                        //       ? `dischargeProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //        : `dischargeProteinMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : mIndex ===
                                                        //       Values.value0
                                                        //     ? `dischargeMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : mIndex ===
                                                        //       Values.value1
                                                        //     ? `dischargeMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //      : mIndex === Values.value2
                                                        //    ? `dischargeMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        //     : `dischargeMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        // }

                                                        name={
                                                          colIndex === 0
                                                            ? item.label.includes("Urine protein")
                                                              ? mIndex === Values.value0
                                                                ? `admissionProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex === Values.value1
                                                                ? `admissionProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine protein → ml
                                                                : `admissionProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : item.label.includes("Urine albumin")
                                                              ? mIndex === Values.value0
                                                                ? `admissionProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex === Values.value1
                                                                ? `admissionProteinMeasurementValue_gl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine albumin → gl
                                                                : mIndex === Values.value2
                                                                ? `admissionProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : `admissionProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value0
                                                              ? `admissionMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value1
                                                              ? `admissionMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value2
                                                              ? `admissionMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : `admissionMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : item.label.includes("Urine protein")
                                                            ? mIndex === Values.value0
                                                              ? `dischargeProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value1
                                                              ? `dischargeProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine protein → ml
                                                              : `dischargeProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : item.label.includes("Urine albumin")
                                                            ? mIndex === Values.value0
                                                              ? `dischargeProteinMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : mIndex === Values.value1
                                                              ? `dischargeProteinMeasurementValue_gl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}` // ✅ Urine albumin → gl
                                                              : mIndex === Values.value2
                                                              ? `dischargeProteinMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : `dischargeProteinMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : mIndex === Values.value0
                                                            ? `dischargeMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : mIndex === Values.value1
                                                            ? `dischargeMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : mIndex === Values.value2
                                                            ? `dischargeMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            : `dischargeMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                        }

                                                        
                                                        type="text"
                                                        // value={
                                                        //   colIndex ===
                                                        //   Values.value0
                                                        //     ? item.label.includes(
                                                        //         "Urine"
                                                        //       )
                                                        //       ? mIndex ===
                                                        //         Values.value0
                                                        //         ? item.admissionProteinMeasurement ===
                                                        //           mIndex + 1
                                                        //           ? item.admissionProteinMeasurementValue_l
                                                        //           : ""
                                                        //         : mIndex ===
                                                        //           Values.value1
                                                        //         ? item.admissionProteinMeasurement ===
                                                        //           mIndex + 1
                                                        //           ? item.admissionProteinMeasurementValue_ml
                                                        //           : ""
                                                        //           // : mIndex ===
                                                        //           // Values.value2
                                                        //          :
                                                        //            item.admissionProteinMeasurement ===
                                                        //           mIndex + 1
                                                        //           ? item.admissionProteinMeasurementValue_nl
                                                        //           : ""
                                                                
                                                        //       : mIndex ===
                                                        //         Values.value0
                                                        //       ? item.admissionMeasurement ===
                                                        //         mIndex + 1
                                                        //         ? item.admissionMeasurementValue_l
                                                        //         : ""
                                                        //       : mIndex ===
                                                        //         Values.value1
                                                        //       ? item.admissionMeasurement ===
                                                        //         mIndex + 1
                                                        //         ? item.admissionMeasurementValue_ml
                                                        //         : ""

                                                        //         : mIndex ===
                                                        //         Values.value2
                                                        //       ?
                                                        //         item.admissionMeasurement ===
                                                        //         mIndex + 1
                                                        //       ? item.admissionMeasurementValue_nl
                                                        //       : ""
                                                        //       : item.admissionMeasurement === 
                                                        //           mIndex + 1
                                                        //           ? item.admissionMeasurementValue_dl :""
                                                        //     : item.label.includes(
                                                        //         "Urine"
                                                        //       )
                                                        //     ? mIndex ===
                                                        //       Values.value0
                                                        //       ? item.dischargeProteinMeasurement ===
                                                        //         mIndex + 1
                                                        //         ? item.dischargeProteinMeasurementValue_l
                                                        //         : ""
                                                        //       : mIndex ===
                                                        //         Values.value1
                                                        //       ? item.dischargeProteinMeasurement ===
                                                        //         mIndex + 1
                                                        //         ? item.dischargeProteinMeasurementValue_ml
                                                        //         : ""
                                                        //       // : mIndex === Values.value2
                                                        //       // ? mIndex + 1
                                                        //       // ? item.dischargeProteinMeasurementValue_nl
                                                        //       // : ""

                                                        //       : item.dischargeProteinMeasurement ===
                                                        //         mIndex + 1
                                                        //       ? item.dischargeProteinMeasurementValue_nl
                                                        //       : ""
                                                        //     : mIndex ===
                                                        //       Values.value0
                                                        //     ? item.dischargeMeasurement ===
                                                        //       mIndex + 1
                                                        //       ? item.dischargeMeasurementValue_l
                                                        //       : ""
                                                        //     : mIndex ===
                                                        //       Values.value1
                                                        //     ? item.dischargeMeasurement ===
                                                        //       mIndex + 1
                                                        //       ? item.dischargeMeasurementValue_ml
                                                        //       : ""
                                                        //     : mIndex === Values.value2
                                                        //     ? 
                                                        //      item.dischargeMeasurement ===
                                                        //       mIndex + 1
                                                        //     ? item.dischargeMeasurementValue_nl
                                                        //     : ""
                                                        //     : item.dischargeMeasurement ===
                                                        //       mIndex + 1
                                                        //     ? item.dischargeMeasurementValue_dl
                                                        //     : ""
                                                        // }


                                                        value={
                                                          colIndex === Values.value0
                                                            ? item.label.includes("Urine protein")
                                                              ? mIndex === Values.value0
                                                                ? item.admissionProteinMeasurement === mIndex + 1
                                                                  ? item.admissionProteinMeasurementValue_l
                                                                  : ""
                                                                : mIndex === Values.value1
                                                                ? item.admissionProteinMeasurement === mIndex + 1
                                                                  ? item.admissionProteinMeasurementValue_ml // ✅ Urine protein → ml
                                                                  : ""
                                                                : item.admissionProteinMeasurement === mIndex + 1
                                                                ? item.admissionProteinMeasurementValue_nl
                                                                : ""
                                                              : item.label.includes("Urine albumin")
                                                              ? mIndex === Values.value0
                                                                ? item.admissionProteinMeasurement === mIndex + 1
                                                                  ? item.admissionProteinMeasurementValue_l
                                                                  : ""
                                                                : mIndex === Values.value1
                                                                ? item.admissionProteinMeasurement === mIndex + 1
                                                                  ? item.admissionProteinMeasurementValue_gl // ✅ Urine albumin → gl
                                                                  : ""
                                                                : mIndex === Values.value2
                                                                ? item.admissionProteinMeasurement === mIndex + 1
                                                                  ? item.admissionProteinMeasurementValue_ml
                                                                  : ""
                                                                : item.admissionProteinMeasurement === mIndex + 1
                                                                ? item.admissionProteinMeasurementValue_nl
                                                                : ""
                                                              : mIndex === Values.value0
                                                              ? item.admissionMeasurement === mIndex + 1
                                                                ? item.admissionMeasurementValue_l
                                                                : ""
                                                              : mIndex === Values.value1
                                                              ? item.admissionMeasurement === mIndex + 1
                                                                ? item.admissionMeasurementValue_ml
                                                                : ""
                                                              : mIndex === Values.value2
                                                              ? item.admissionMeasurement === mIndex + 1
                                                                ? item.admissionMeasurementValue_nl
                                                                : ""
                                                              : item.admissionMeasurement === mIndex + 1
                                                              ? item.admissionMeasurementValue_dl
                                                              : ""
                                                            : item.label.includes("Urine protein")
                                                            ? mIndex === Values.value0
                                                              ? item.dischargeProteinMeasurement === mIndex + 1
                                                                ? item.dischargeProteinMeasurementValue_l
                                                                : ""
                                                              : mIndex === Values.value1
                                                              ? item.dischargeProteinMeasurement === mIndex + 1
                                                                ? item.dischargeProteinMeasurementValue_ml // ✅ Urine protein → ml
                                                                : ""
                                                              : item.dischargeProteinMeasurement === mIndex + 1
                                                              ? item.dischargeProteinMeasurementValue_nl
                                                              : ""
                                                            : item.label.includes("Urine albumin")
                                                            ? mIndex === Values.value0
                                                              ? item.dischargeProteinMeasurement === mIndex + 1
                                                                ? item.dischargeProteinMeasurementValue_l
                                                                : ""
                                                              : mIndex === Values.value1
                                                              ? item.dischargeProteinMeasurement === mIndex + 1
                                                                ? item.dischargeProteinMeasurementValue_gl // ✅ Urine albumin → gl
                                                                : ""
                                                              : mIndex === Values.value2
                                                              ? item.dischargeProteinMeasurement === mIndex + 1
                                                                ? item.dischargeProteinMeasurementValue_ml
                                                                : ""
                                                              : item.dischargeProteinMeasurement === mIndex + 1
                                                              ? item.dischargeProteinMeasurementValue_nl
                                                              : ""
                                                            : mIndex === Values.value0
                                                            ? item.dischargeMeasurement === mIndex + 1
                                                              ? item.dischargeMeasurementValue_l
                                                              : ""
                                                            : mIndex === Values.value1
                                                            ? item.dischargeMeasurement === mIndex + 1
                                                              ? item.dischargeMeasurementValue_ml
                                                              : ""
                                                            : mIndex === Values.value2
                                                            ? item.dischargeMeasurement === mIndex + 1
                                                              ? item.dischargeMeasurementValue_nl
                                                              : ""
                                                            : item.dischargeMeasurement === mIndex + 1
                                                            ? item.dischargeMeasurementValue_dl
                                                            : ""
                                                        }
                                                        
                                                        maxLength={8}
                                                        onKeyDown={
                                                          handleNumericInputKeyDownUpto3//handleNumericInputKeyDown
                                                        }
                                                        onChange={
                                                          HandleSettingcareFieldChange
                                                        }
                                                      />
                                                    )}
                                                    <span>{measurement}</span>
                                                  </label>
                                                </div>
                                              )
                                            )}

                                            <ErrorField
                                              show={
                                                item.label.includes("Urine")
                                                  ? colIndex === 0
                                                    ? item.q33AdmissionmeasurementUrineEmpty
                                                    : item.q33DischargemeasurementUrineEmpty
                                                  : null
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                            <ErrorField
                                              show={
                                                item.label.includes("Urine")
                                                  ? colIndex === 0
                                                    ? item.q33AdmissionmeasurementUrineInvalid
                                                    : item.q33DischargemeasurementUrineInvalid
                                                  : false
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />
                                        

                                            {item.extra && (
                                              <>
                                                <br />
                                                <div>
                                                  <b>{item.extra}</b>
                                                </div>
                                                {item.urineMeasurement.map(
                                                  (measurement, mIndex) => (
                                                    <div
                                                      key={`extra-${mIndex}`}
                                                    >
                                                      <label className="option-fbox">
                                                        <input
                                                          type="radio"
                                                          id={
                                                            colIndex === 0
                                                              ? `admissionCreatinineMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : `dischargeCreatinineMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          }
                                                          name={
                                                            colIndex === 0
                                                              ? `admissionCreatinineMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                              : `dischargeCreatinineMeasurement-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                          }
                                                          value={mIndex + 1}
                                                          checked={
                                                            colIndex ===
                                                            Values.value0
                                                              ? item.admissionCreatinineMeasurement ===
                                                                mIndex + 1
                                                              : item.dischargeCreatinineMeasurement ===
                                                                mIndex + 1
                                                          }
                                                          onChange={
                                                            HandleSettingcareFieldChange
                                                          }
                                                        />

                                                        {measurement ===
                                                        "Unknown" ? (
                                                          <></>
                                                        ) : (
                                                          <input
                                                            className="sub-input-dash"
                                                            id={
                                                              colIndex === 0
                                                                ? mIndex ===
                                                                  Values.value0
                                                                  ? `admissionCreatinineMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                  : mIndex ===
                                                                    Values.value1
                                                                  ? `admissionCreatinineMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                  : mIndex === Values.value2
                                                                  ? `admissionCreatinineMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                  : `admissionCreatinineMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex ===
                                                                  Values.value0
                                                                ? `dischargeCreatinineMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeCreatinineMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex === Values.value2
                                                                ? `dischargeCreatinineMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : `dischargeCreatinineMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            }
                                                            name={
                                                              colIndex === 0
                                                                ? mIndex ===
                                                                  Values.value0
                                                                  ? `admissionCreatinineMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                  : mIndex ===
                                                                    Values.value1
                                                                  ? `admissionCreatinineMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                  : mIndex === Values.value2
                                                                  ? `admissionCreatinineMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                  : `admissionCreatinineMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex ===
                                                                  Values.value0
                                                                ? `dischargeCreatinineMeasurementValue_l-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex ===
                                                                  Values.value1
                                                                ? `dischargeCreatinineMeasurementValue_ml-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : mIndex === Values.value2
                                                                ? `dischargeCreatinineMeasurementValue_nl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                                : `dischargeCreatinineMeasurementValue_dl-${colIndex}-settingcare-${idx}-${mIndex}-${item.label}`
                                                            }
                                                            type="text"
                                                            value={
                                                              colIndex ===
                                                              Values.value0
                                                                ? mIndex ===
                                                                  Values.value0
                                                                  ? item.admissionCreatinineMeasurement ===
                                                                    mIndex + 1
                                                                    ? item.admissionCreatinineMeasurementValue_l
                                                                    : ""
                                                                  : mIndex ===
                                                                    Values.value1
                                                                  ? item.admissionCreatinineMeasurement ===
                                                                    mIndex + 1
                                                                    ? item.admissionCreatinineMeasurementValue_ml
                                                                    : ""

                                                                    : mIndex === Values.value2
                                                                    ? item.admissionCreatinineMeasurement ===
                                                                      mIndex + 1
                                                                      ? item.admissionCreatinineMeasurementValue_nl
                                                                      :""
                                                                  : item.admissionCreatinineMeasurement ===
                                                                    mIndex + 1
                                                                  ? item.admissionCreatinineMeasurementValue_dl
                                                                  : ""
                                                                : mIndex ===
                                                                  Values.value0
                                                                ? item.dischargeCreatinineMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeCreatinineMeasurementValue_l
                                                                  : ""

                                                                : mIndex ===
                                                                  Values.value1
                                                                ? item.dischargeCreatinineMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeCreatinineMeasurementValue_ml
                                                                  : ""

                                                                : mIndex === Values.value2
                                                                ? item.dischargeCreatinineMeasurement ===
                                                                  mIndex + 1
                                                                  ? item.dischargeCreatinineMeasurementValue_nl
                                                                  :""
                                                                : item.dischargeCreatinineMeasurement ===
                                                                  mIndex + 1
                                                                ? item.dischargeCreatinineMeasurementValue_dl
                                                                : "" 
                                                            }
                                                            maxLength={8}
                                                            onKeyDown={
                                                              handleNumericInputKeyDown
                                                            }
                                                            onChange={
                                                              HandleSettingcareFieldChange
                                                            }
                                                          />
                                                        )}
                                                        <span>
                                                          {measurement}
                                                        </span>
                                                      </label>
                                                    </div>
                                                  )
                                                )}
                                              </>
                                            )}

                                            <ErrorField
                                              show={
                                                item.label.includes("Urine")
                                                  ? false
                                                  : colIndex === 0
                                                  ? item.labRenalSettingCareTypeId ===
                                                    Values.value1
                                                    ? item.q33AdmissionmeasurementCreatinineEmpty
                                                    : item.q33AdmissionmeasurementCystatinEmpty
                                                  : item.labRenalSettingCareTypeId ===
                                                    Values.value1
                                                  ? item.q33DischargemeasurementCreatinineEmpty
                                                  : item.q33DischargemeasurementCystatinEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                            <ErrorField
                                              show={
                                                item.label.includes("Urine")
                                                  ? false
                                                  : colIndex === 0
                                                  ? item.labRenalSettingCareTypeId ===
                                                    Values.value1
                                                    ? item.q33AdmissionmeasurementCreatinineInvalid
                                                    : item.q33AdmissionmeasurementCystatinInvalid
                                                  : item.labRenalSettingCareTypeId ===
                                                    Values.value1
                                                  ? item.q33DischargemeasurementCreatinineInvalid
                                                  : item.q33DischargemeasurementCystatinInvalid
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />

                                            <ErrorField
                                              show={
                                                colIndex === 0
                                                  ? item.q33AdmissionmeasurementUCreatinineEmpty
                                                  : item.q33DischargemeasurementUCreatinineEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />
                                            <ErrorField
                                              show={
                                                colIndex === 0
                                                  ? item.q33AdmissionmeasurementUCreatinineInvalid
                                                  : item.q33DischargemeasurementUCreatinineInvalid
                                              }
                                              message={CommonError_Msgs.Msg2}
                                            />

<ErrorField
                                              show={
                                                colIndex === 0
                                                  ? item.q33AdmissionmeasurementEmpty
                                                  : item.q33DischargemeasurementEmpty
                                              }
                                              message={CommonError_Msgs.Msg1}
                                            />

                                          </td>
                                        );
                                      })}
                                  </tr>
                                </React.Fragment>
                              ))}
                            </table>
                            {/*  */}
                          </td>
                        </tr>
                      </table>
                    </div>

                    {/* here 11*/}
                    <div
                      className="block-border block-margin white-bg"
                      style={{ marginBlock: "20px 0" }}
                    >
                      <div>
                        <div className="question">
                          <span className="question-weight">Q34.</span>
                          <span className="quest-text-pad question-weight">
                            Please list{" "}
                            <u>
                              all chronic kidney disease (CKD) stage diagnoses
                            </u>{" "}
                            that occurred within 12 months prior to and any time
                            on or after the index date (from{" "}
                            <span className="indigo-text">
                              {dates.oneYr_pretransplant_start !== null
                                ? dates.oneYr_pretransplant_start
                                : "[1-year pre-transplant start]"}
                            </span>{" "}
                            to{" "}
                            <span className="indigo-text">
                              {dates.endofFollowUpDate !== null
                                ? dates.endofFollowUpDate
                                : " [end of follow-up]"}
                            </span>
                            ). Please add additional rows for each occurrence,
                            as needed.
                            <br />
                            <br />
                          </span>
                        </div>
                        <br></br>
                      </div>
                      {labchronicDetails &&
                        labchronicDetails.length > 0 &&
                        labchronicDetails.map((data, idx) => (
                          <div className="loop-section-ul">
                            <div className="loop-head">
                              <span className="question-weight">
                                {GetOrdinal(idx + 1)} CKD Assessment
                              </span>
                              {idx !== 0 && (
                                <div className="delete-btn-div">
                                  <img
                                    width="16px"
                                    src="../Assets/images/Icon-material-delete.png"
                                    alt=""
                                    onClick={() => deleteChronicDetails(idx)}
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="containertd grid-overflow"
                              colSpan={3}
                            >
                              <table
                                className="borderTable  custom-th-width"
                                style={patientLocked ? { pointerEvents: 'none', width: '100%'} : {width: '100%'}}

                              >
                                <thead>
                                  <tr>
                                    <th className="table-th-sec">
                                      Date of CKD assessment{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                    <th className="table-th-sec">
                                      CKD stage reported{" "}
                                      <span className="indigo-text"></span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="modal-popup-table-cell">
                                      {idx === 0 && (
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "ckdAssessment-" + idx + "-ckd"
                                              }
                                              value={1}
                                              checked={
                                                data.ckdAssessment ===
                                                Values.value1
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">
                                              Patient not diagnosed with CKD
                                            </span>
                                          </label>
                                        </div>
                                      )}

                                      {idx === 0 && (
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={
                                                "ckdAssessment-" + idx + "-ckd"
                                              }
                                              value={2}
                                              checked={
                                                data.ckdAssessment ===
                                                Values.value2
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">
                                              Patient diagnosed with CKD but
                                              stage not assessed
                                            </span>
                                          </label>
                                        </div>
                                      )}
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "ckdAssessment-" + idx + "-ckd"
                                            }
                                            value={3}
                                            checked={
                                              data.ckdAssessment ===
                                              Values.value3
                                            }
                                            onChange={HandleCkdFieldChange}
                                          />

                                          <span className="">
                                            <DateControl
                                              optionId={"ckdAssessment_dt"}
                                              ctrlId={"ckdAssessment_dt-" + idx}
                                              HandleDateChange={
                                                HandleDateChange
                                              }
                                              date={data.ckdAssessment_dt}
                                            />
                                          </span>
                                        </label>
                                      </div>
                                      <div className="estimated-date-padding text-margin">
                                        <label>
                                          <input
                                            type="checkbox"
                                            id={idx}
                                            name={
                                              "ckdAssessment_dt_estimated-" +
                                              idx +
                                              "-ckd"
                                            }
                                            checked={
                                              data.ckdAssessment_dt_estimated
                                            }
                                            onChange={HandleCkdFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Estimated Date
                                          </span>
                                        </label>
                                      </div>
                                      <div className="date-field-padding">
                                        <label className="option-fbox">
                                          <input
                                            type="radio"
                                            id={idx}
                                            name={
                                              "ckdAssessment-" + idx + "-ckd"
                                            }
                                            value={99}
                                            checked={
                                              data.ckdAssessment ===
                                              Values.value99
                                            }
                                            onChange={HandleCkdFieldChange}
                                          />
                                          <span className="">Date unknown</span>
                                        </label>
                                        <div style={{ marginLeft: "44px" }}>
                                          {dates?.zero_to12months_before_LT_LKT !==
                                            null &&
                                            dates?.zero_to12months_before_LT_LKT && (
                                              <div>
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "ckdAssessmentUnkLTLKT-" +
                                                      idx +
                                                      "-ckd"
                                                    }
                                                    value={1}
                                                    checked={
                                                      data.ckdAssessmentUnkLTLKT ===
                                                      Values.value1
                                                    }
                                                    onChange={HandleCkdFieldChange}
                                                  />
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHide012HyperlinkModal(
                                                        true
                                                      )
                                                    }
                                                  >
                                                    0 to 12 months before LT/LKT
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                          {dates?.zero_to_3months_after_LT_LKT !==
                                            null &&
                                            dates?.zero_to_3months_after_LT_LKT && (
                                              <div>
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "ckdAssessmentUnkLTLKT-" +
                                                      idx +
                                                      "-ckd"
                                                    }
                                                    value={2}
                                                    checked={
                                                      data.ckdAssessmentUnkLTLKT ===
                                                      Values.value2
                                                    }
                                                    onChange={HandleCkdFieldChange}
                                                  />
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHide03HyperlinkModal(
                                                        true
                                                      )
                                                    }
                                                  >
                                                    0 to 3 months after LT/LKT
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                          {dates?.four_to_15months_after_LT_LKT !==
                                            null &&
                                            dates?.four_to_15months_after_LT_LKT && (
                                              <div>
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "ckdAssessmentUnkLTLKT-" +
                                                      idx +
                                                      "-ckd"
                                                    }
                                                    value={3}
                                                    checked={
                                                      data.ckdAssessmentUnkLTLKT ===
                                                      Values.value3
                                                    }
                                                    onChange={HandleCkdFieldChange}
                                                  />
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHide415HyperlinkModal(
                                                        true
                                                      )
                                                    }
                                                  >
                                                    4 to 15 months after LT/LKT
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                          {dates?.sixteen_to_27months_after_LT_LKT !==
                                            null &&
                                            dates?.sixteen_to_27months_after_LT_LKT && (
                                              <div>
                                                <label className="option-fbox">
                                                  <input
                                                    type="radio"
                                                    id={idx}
                                                    name={
                                                      "ckdAssessmentUnkLTLKT-" +
                                                      idx +
                                                      "-ckd"
                                                    }
                                                    value={4}
                                                    checked={
                                                      data.ckdAssessmentUnkLTLKT ===
                                                      Values.value4
                                                    }
                                                    onChange={HandleCkdFieldChange}
                                                  />
                                                  <span
                                                    data-tooltip-id="encounterTip"
                                                    className="modal-popup"
                                                    onClick={() =>
                                                      setShowHide1627HyperlinkModal(
                                                        true
                                                      )
                                                    }
                                                  >
                                                    16 to 27 months after LT/LKT
                                                  </span>
                                                </label>
                                              </div>
                                            )}
                                          <div>
                                            <label className="option-fbox">
                                              <input
                                                type="radio"
                                                id={idx}
                                                name={
                                                  "ckdAssessmentUnkLTLKT-" +
                                                  idx +
                                                  "-ckd"
                                                }
                                                value={5}
                                                checked={
                                                  data.ckdAssessmentUnkLTLKT ===
                                                  Values.value5
                                                }
                                                onChange={HandleCkdFieldChange}
                                              />
                                              <span className="">
                                                Date completely unknown
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>

                                      <ErrorField
                                        show={data.q34assessmentDateEmptyError}
                                        message={CommonError_Msgs.Msg2}
                                      />

                                      <ErrorField
                                        show={data.q34AssessmentDateUnkEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />

                                      <ErrorField
                                        show={data.q34assessmentEmpty}
                                        message={CommonError_Msgs.Msg1}
                                      />

                                      <ErrorField
                                        show={data.q34assessmentDateInvalid}
                                        message={CommonError_Msgs.Msg2}
                                      />
                                    </td>

                                    {data.ckdAssessment === Values.value1 ||
                                    data.ckdAssessment === Values.value2 ? (
                                      <td
                                        className="containertd"
                                        style={{
                                          textAlign: "center",
                                          borderRight: "0",
                                        }}
                                      >
                                        <span
                                          style={{ textAlign: "center" }}
                                          className="not-applicable"
                                        >
                                          <b>Not Applicable</b>
                                        </span>
                                      </td>
                                    ) : (
                                      <td className="modal-popup-table-cell">
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"ckdstage-" + idx + "-ckd"}
                                              value={1}
                                              checked={
                                                data.ckdstage === Values.value1
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">Stage 1</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"ckdstage-" + idx + "-ckd"}
                                              value={2}
                                              checked={
                                                data.ckdstage === Values.value2
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">Stage 2</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"ckdstage-" + idx + "-ckd"}
                                              value={3}
                                              checked={
                                                data.ckdstage === Values.value3
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">Stage 3</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"ckdstage-" + idx + "-ckd"}
                                              value={4}
                                              checked={
                                                data.ckdstage === Values.value4
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">Stage 4</span>
                                          </label>
                                        </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"ckdstage-" + idx + "-ckd"}
                                              value={5}
                                              checked={
                                                data.ckdstage === Values.value5
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">
                                              Stage 5 or end-stage renal disease
                                              (ESRD)
                                            </span>
                                          </label>
                                        </div>
                                                            <div className="date-field-padding">
                                                                <label className="option-fbox radio-text-padding">



                                                                    <input
                                                                        type="checkbox"
                                                                        id={idx}
                                                                        name={
                                                                            "ckdkidneyfailure-" +
                                                                            idx +
                                                                            "-ckd"
                                                                        }
                                                                        //value={1}
                                                                        checked={
                                                                            data.ckdkidneyfailure
                                                                            //===
                                                                            // Values.value1 &&
                                                                            //data.ckdstage === Values.value5
                                                                        }
                                                                        style={{ marginTop: "8px", marginLeft: "14px" }}
                                                                        onChange={HandleCkdFieldChange}
                                                                    />
                                                                    <span className="">
                                                                        Patient receiving dialysis for
                                                                        kidney failure
                                                                    </span>
                                                                </label>
                                                            </div>
                                        <div className="date-field-padding">
                                          <label className="option-fbox">
                                            <input
                                              type="radio"
                                              id={idx}
                                              name={"ckdstage-" + idx + "-ckd"}
                                              value={99}
                                              checked={
                                                data.ckdstage === Values.value99
                                              }
                                              onChange={HandleCkdFieldChange}
                                            />
                                            <span className="">Unknown</span>
                                          </label>
                                        </div>
                                        <ErrorField
                                          show={data.q34StageEmpty}
                                          message={CommonError_Msgs.Msg1}
                                        />
                                      </td>
                                    )}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))}

                      {labchronicDetails &&
                        labchronicDetails[0].ckdAssessment !== Values.value1 &&
                        labchronicDetails[0].ckdAssessment !==
                          Values.value2 && patientLocked===false && (
                          <div>
                            <div
                              className="answer-list-text"
                              onClick={addchronicRow}
                            >
                              <a>
                                <img
                                  width="18px"
                                  src="../Assets/images/plus.png"
                                  alt=""
                                />
                              </a>
                              <a className="radio-text-padding">
                                Click to add additional rows for chronic kidney
                                disease (CKD) stage
                              </a>
                            </div>
                          </div>
                        )}
                    </div>
                    {/* here 2 */}

  
                  </div>
                </div>

                <div className="survey-section-content-foot">
                  <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showHide012HyperlinkModal && (
        <InfoPopUp
          description={zeroToTwelve(
            dates?.oneYr_pretransplant_start,
            dates?.oneYr_pretransplant_end
          )}
          OkClick={() => setShowHide012HyperlinkModal(false)}
        />
      )}
      {showHide03HyperlinkModal && (
        <InfoPopUp
          description={zeroToThree(
            dates?.indexDt,
            dates?.three_month_stabilization
          )}
          OkClick={() => setShowHide03HyperlinkModal(false)}
        />
      )}
      {showHide415HyperlinkModal && (
        <InfoPopUp
          description={fourToFifteen(
            dates?.post_stabilization_start,
            dates?.twelve_month_post_stabilization
          )}
          OkClick={() => setShowHide415HyperlinkModal(false)}
        />
      )}
      {showHide1627HyperlinkModal && (
        <InfoPopUp
          description={sixteenToTwentySeven(
            dates?.twelve_month_post_stabilization_plusOneday,
            dates?.twenty_four_months_post_stabilization
          )}
          OkClick={() => setShowHide1627HyperlinkModal(false)}
        />
      )}
    </>
  );
};

export default RenalLabAssessment;
